// Global JavaScript - Optimized for Performance

(function() {
  'use strict';
  
  // TILE-046: Production-safe logger (console statements removed for production)
  // Set window.DEBUG = true in browser console to enable logging
  const logger = {
    log: function() { if (window.DEBUG) console.log.apply(console, arguments); },
    warn: function() { if (window.DEBUG) console.warn.apply(console, arguments); },
    debug: function() { if (window.DEBUG) console.debug.apply(console, arguments); },
    error: function() { console.error.apply(console, arguments); } // Keep errors for production debugging
  };
  
  // Initialize global cart variable to prevent ReferenceError.
  window.cart = window.cart || null;

  // Reuse the early cart bootstrap request from theme.liquid when available.
  if (window.__velunaCartBootstrapPromise && typeof window.__velunaCartBootstrapPromise.then === 'function') {
    window.__velunaCartBootstrapPromise.then(function(cartData) {
      if (cartData) {
        window.cart = cartData;
      }
    }).catch(function(err) {
      logger.debug('Cart bootstrap failed (non-critical):', err);
    });
  } else if (typeof fetch !== 'undefined') {
    window.__velunaCartBootstrapPromise = fetch('/cart.js', {
      cache: 'no-cache',
      headers: { 'Accept': 'application/json' }
    })
    .then(function(response) {
      if (response.ok) {
        return response.json();
      }
      return null;
    })
    .then(function(cartData) {
      if (cartData) {
        window.cart = cartData;
      }
      return cartData;
    })
    .catch(function(err) {
      logger.debug('Cart fetch failed (non-critical):', err);
      return null;
    });
  }

  // ═══════════════════════════════════════════════════════════════════════════
  // TILE-038: GLOBAL PERFORMANCE CORE v2
  // ═══════════════════════════════════════════════════════════════════════════
  
  /**
   * Performance Core v2
   * 
   * Unified performance optimization system for all components.
   * Ensures ALL components (cart drawer, sticky ATC, search, flyouts, accordions,
   * sliders, predictive search, etc.) inherit performance optimizations automatically.
   * 
   * Features:
   * - Defer non-critical code until after LCP
   * - Idle-time task scheduling
   * - RequestAnimationFrame batching
   * - Optimized event listeners (passive, throttled)
   * - Lazy imports for code splitting
   * - Throttle/debounce utilities
   * - DOM read/write batching (queueWork)
   * - Tree-shakable, safe for async loading
   * 
   * Usage:
   * - PerformanceCore.afterLCP(callback) - Defer until after LCP
   * - PerformanceCore.deferIdle(callback) - Schedule idle-time task
   * - PerformanceCore.event('scroll', handler, { passive: true, throttle: 'raf' })
   * - PerformanceCore.rafBatch(callback) - Batch DOM operations
   * - PerformanceCore.throttle(func, delay) - Throttle function calls
   * - PerformanceCore.queueWork(readFn, writeFn) - Batch reads/writes
   */
  
  window.PerformanceCore = (function() {
    'use strict';
    
    // Internal state
    var lcpObserver = null;
    var lcpResolved = false;
    var lcpCallbacks = [];
    var rafQueue = [];
    var rafScheduled = false;
    var idleQueue = [];
    var idleScheduled = false;
    var eventListeners = new WeakMap();
    
    /**
     * defer - Execute callback asynchronously (next tick)
     * @param {Function} callback
     */
    function defer(callback) {
      if (typeof callback !== 'function') return;
      setTimeout(callback, 0);
    }
    
    /**
     * deferIdle - Schedule task for idle time (uses requestIdleCallback if available)
     * @param {Function} callback
     * @param {Object} options - { timeout: number }
     */
    function deferIdle(callback, options) {
      if (typeof callback !== 'function') return;
      
      options = options || {};
      var timeout = options.timeout || 5000;
      
      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(callback, { timeout: timeout });
      } else {
        // Fallback: Use setTimeout with small delay
        setTimeout(callback, 1);
      }
    }
    
    /**
     * afterLCP - Defer callback until after Largest Contentful Paint
     * @param {Function} callback
     */
    function afterLCP(callback) {
      if (typeof callback !== 'function') return;
      
      // If already resolved, execute immediately
      if (lcpResolved) {
        defer(callback);
      return;
    }
    
      // Add to queue
      lcpCallbacks.push(callback);
      
      // If observer not started, start it
      if (!lcpObserver && 'PerformanceObserver' in window) {
        try {
          lcpObserver = new PerformanceObserver(function(list) {
          var entries = list.getEntries();
          var lastEntry = entries[entries.length - 1];
          if (lastEntry) {
              // LCP detected, resolve all callbacks
              lcpResolved = true;
              if (lcpObserver) {
                lcpObserver.disconnect();
                lcpObserver = null;
              }
              
              // Execute all queued callbacks after small delay
              setTimeout(function() {
                lcpCallbacks.forEach(function(cb) {
                  try {
                    cb();
                  } catch (e) {
                    logger.warn('PerformanceCore.afterLCP callback error:', e);
                  }
                });
                lcpCallbacks = [];
              }, 100);
            }
          });
          lcpObserver.observe({ entryTypes: ['largest-contentful-paint'] });
          
          // Fallback timeout (3 seconds)
        setTimeout(function() {
            if (!lcpResolved) {
              lcpResolved = true;
              if (lcpObserver) {
                lcpObserver.disconnect();
                lcpObserver = null;
              }
              lcpCallbacks.forEach(function(cb) {
                try {
                  cb();
                } catch (e) {
                  logger.warn('PerformanceCore.afterLCP callback error:', e);
                }
              });
              lcpCallbacks = [];
            }
        }, 3000);
      } catch (e) {
          // PerformanceObserver failed, use DOMContentLoaded fallback
          lcpObserver = null;
          if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', function() {
              lcpResolved = true;
              lcpCallbacks.forEach(function(cb) {
                try {
                  cb();
                } catch (err) {
                  logger.warn('PerformanceCore.afterLCP callback error:', err);
                }
              });
              lcpCallbacks = [];
            });
    } else {
            // Already loaded
            lcpResolved = true;
            defer(function() {
              lcpCallbacks.forEach(function(cb) {
                try {
                  cb();
                } catch (err) {
                  logger.warn('PerformanceCore.afterLCP callback error:', err);
                }
              });
              lcpCallbacks = [];
            });
          }
        }
      } else if (!('PerformanceObserver' in window)) {
        // No PerformanceObserver support, use DOMContentLoaded
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', function() {
            lcpResolved = true;
            lcpCallbacks.forEach(function(cb) {
              try {
                cb();
              } catch (err) {
                logger.warn('PerformanceCore.afterLCP callback error:', err);
              }
            });
            lcpCallbacks = [];
          });
        } else {
          // Already loaded
          lcpResolved = true;
          defer(function() {
            lcpCallbacks.forEach(function(cb) {
              try {
                cb();
              } catch (err) {
                logger.warn('PerformanceCore.afterLCP callback error:', err);
              }
            });
            lcpCallbacks = [];
          });
        }
      }
    }
    
    /**
     * rafBatch - Batch callback in next requestAnimationFrame
     * @param {Function} callback
     */
    function rafBatch(callback) {
      if (typeof callback !== 'function') return;
      
      rafQueue.push(callback);
      
      if (!rafScheduled) {
        rafScheduled = true;
        window.requestAnimationFrame(function() {
          rafScheduled = false;
          var queue = rafQueue.slice();
          rafQueue = [];
          queue.forEach(function(cb) {
            try {
              cb();
            } catch (e) {
              logger.warn('PerformanceCore.rafBatch callback error:', e);
            }
          });
        });
      }
    }
    
    /**
     * event - Add optimized event listener with passive/throttle support
     * @param {string} eventType - Event type (scroll, resize, mousemove, etc.)
     * @param {Function} handler - Event handler
     * @param {Object} options - { passive: boolean, throttle: string|number, capture: boolean }
     */
    function event(eventType, handler, options) {
      if (!eventType || typeof handler !== 'function') return function() {}; // Return no-op unsubscribe
      
      options = options || {};
      var passive = options.passive !== false; // Default to true for scroll/resize/mousemove
      var throttle = options.throttle;
      var capture = options.capture || false;
      var target = options.target || window;
      
      // Auto-enable passive for scroll/resize/touch events
      if (eventType === 'scroll' || eventType === 'resize' || eventType === 'touchmove' || eventType === 'touchstart' || eventType === 'touchend') {
        passive = true;
      }
      
      var wrappedHandler = handler;
      
      // Apply throttling if requested
      if (throttle === 'raf') {
        // Throttle via requestAnimationFrame
        var ticking = false;
        wrappedHandler = function(e) {
          if (!ticking) {
            ticking = true;
            window.requestAnimationFrame(function() {
              ticking = false;
              handler(e);
            });
          }
        };
      } else if (typeof throttle === 'number' && throttle > 0) {
        // Throttle via timeout (milliseconds)
        var lastCall = 0;
        wrappedHandler = function(e) {
          var now = Date.now();
          if (now - lastCall >= throttle) {
            lastCall = now;
            handler(e);
          }
        };
      }
      
      // Create listener options
      var listenerOptions = { passive: passive, capture: capture };
      
      // Add listener
      target.addEventListener(eventType, wrappedHandler, listenerOptions);
      
      // Return unsubscribe function
      return function() {
        target.removeEventListener(eventType, wrappedHandler, listenerOptions);
      };
    }
    
    /**
     * lazyImport - Lazy load ES module (for code splitting)
     * @param {Function} importFn - Function returning Promise (e.g., () => import('./module.js'))
     * @returns {Promise}
     */
    function lazyImport(importFn) {
      if (typeof importFn !== 'function') {
        return Promise.reject(new Error('lazyImport requires a function that returns a Promise'));
      }
      
      return deferIdle(function() {
        return importFn();
      });
    }
    
    /**
     * throttle - Throttle function calls (executes at most once per delay period)
     * @param {Function} func - Function to throttle
     * @param {number} delay - Delay in milliseconds
     * @returns {Function} Throttled function
     */
    function throttle(func, delay) {
      if (typeof func !== 'function' || typeof delay !== 'number' || delay <= 0) {
        return func;
      }
      
      var lastCall = 0;
      
      return function() {
        var context = this;
        var args = arguments;
        var now = Date.now();
        
        if (now - lastCall >= delay) {
          lastCall = now;
          func.apply(context, args);
        }
      };
    }
    
    /**
     * debounce - Debounce function calls (executes after delay period of inactivity)
     * @param {Function} func - Function to debounce
     * @param {number} delay - Delay in milliseconds
     * @returns {Function} Debounced function
     */
    function debounce(func, delay) {
      if (typeof func !== 'function' || typeof delay !== 'number' || delay <= 0) {
        return func;
      }
      
      var timeout = null;
      
      return function() {
        var context = this;
        var args = arguments;
        
        // Clear existing timeout
        if (timeout) {
          clearTimeout(timeout);
        }
        
        // Set new timeout
        timeout = setTimeout(function() {
          timeout = null;
          func.apply(context, args);
        }, delay);
      };
    }
    
    /**
     * queueWork - Batch DOM reads and writes to avoid layout thrash
     * @param {Function} readFn - Function that reads from DOM (executed first)
     * @param {Function} writeFn - Function that writes to DOM (executed after reads)
     */
    function queueWork(readFn, writeFn) {
      if (typeof readFn === 'function') {
        readFn();
      }
      
      if (typeof writeFn === 'function') {
        rafBatch(writeFn);
      }
    }
    
    // Expose public API
    return {
      defer: defer,
      deferIdle: deferIdle,
      afterLCP: afterLCP,
      rafBatch: rafBatch,
      event: event,
      lazyImport: lazyImport,
      throttle: throttle,
      debounce: debounce,
      queueWork: queueWork
    };
  })();
  
  // Legacy compatibility: Keep deferUntilAfterLCP for backward compatibility during migration
  function deferUntilAfterLCP(callback) {
    window.PerformanceCore.afterLCP(callback);
  }

  // Critical: Run sticky headers fix IMMEDIATELY (affects layout)
  initStickyHeaders();
  
  // Performance: Defer non-critical theme initialization until after LCP (TILE-038)
  window.PerformanceCore.afterLCP(function() {
    logger.log('Veluna Premium Theme loaded (deferred)');
    initMobileMenu();
    initFunnelPopups();
    initLoadingStates();
    initAjaxProductForm();
    initProductImageGallery();
    initVariantPicker();
    initUrgencyTimer();
    initToastSystem();
    initStickyHeaders(); // Disables sticky positioning - run again after DOM ready
  });

  // Ensure headers scroll normally - no sticky positioning - COMPREHENSIVE FIX
  function initStickyHeaders() {
    // Don't wait - run immediately if elements exist, or wait if not
    if (document.readyState === 'loading' && !document.querySelector('.announcement-bar') && !document.querySelector('.navbar')) {
      document.addEventListener('DOMContentLoaded', initStickyHeaders);
      return;
    }
    
    const announcementBar = document.querySelector('.announcement-bar');
    const navbar = document.querySelector('.navbar');
    
    // Force relative positioning via inline styles to override any CSS
    function forceRelative(element) {
      if (!element) return;
      // Remove ALL positioning properties that could cause sticking
      element.style.setProperty('position', 'relative', 'important');
      element.style.setProperty('top', 'auto', 'important');
      element.style.setProperty('left', 'auto', 'important');
      element.style.setProperty('right', 'auto', 'important');
      element.style.setProperty('bottom', 'auto', 'important');
      element.style.setProperty('transform', 'none', 'important');
      element.style.setProperty('will-change', 'auto', 'important');
      element.style.setProperty('z-index', 'auto', 'important');
    }
    
    // Apply to elements
    if (announcementBar) forceRelative(announcementBar);
    if (navbar) forceRelative(navbar);
    
    // Apply to ALL parent containers up to body
    function fixAllParents(element) {
      if (!element) return;
      let parent = element.parentElement;
      while (parent && parent !== document.body && parent !== document.documentElement) {
        const computedStyle = window.getComputedStyle(parent);
        // Only fix if it has sticky/fixed positioning
        if (computedStyle.position === 'sticky' || computedStyle.position === 'fixed') {
          parent.style.setProperty('position', 'relative', 'important');
          parent.style.setProperty('top', 'auto', 'important');
        }
        parent = parent.parentElement;
      }
    }
    
    if (announcementBar) fixAllParents(announcementBar);
    if (navbar) fixAllParents(navbar);
    
    // Also ensure parent sections don't have sticky
    const announcementSection = announcementBar ? announcementBar.closest('section, .shopify-section, div') : null;
    const navbarSection = navbar ? navbar.closest('section, .shopify-section, div') : null;
    
    if (announcementSection) forceRelative(announcementSection);
    if (navbarSection) forceRelative(navbarSection);
    
    // Run multiple times to catch any late-loading styles
    const runFix = function() {
      if (announcementBar) forceRelative(announcementBar);
      if (navbar) forceRelative(navbar);
      if (announcementSection) forceRelative(announcementSection);
      if (navbarSection) forceRelative(navbarSection);
      if (announcementBar) fixAllParents(announcementBar);
      if (navbar) fixAllParents(navbar);
    };
    
    // Run immediately and multiple times
    setTimeout(runFix, 50);
    setTimeout(runFix, 100);
    setTimeout(runFix, 300);
    setTimeout(runFix, 500);
    
    // Also run on scroll to catch any dynamic changes (TILE-038)
    window.PerformanceCore.event('scroll', function() {
      window.PerformanceCore.rafBatch(runFix);
    }, { passive: true, throttle: 'raf' });
  }

  // Mobile menu functionality
  function initMobileMenu() {
    const toggle = document.querySelector('.navbar-mobile-toggle');
    const menu = document.querySelector('.navbar-menu');
    if (!toggle || !menu) return;

    toggle.addEventListener('click', function() {
      menu.classList.toggle('navbar-menu--open');
      toggle.classList.toggle('navbar-mobile-toggle--active');
    });

    // Close menu when clicking outside
    document.addEventListener('click', function(e) {
      if (!menu.contains(e.target) && !toggle.contains(e.target)) {
        menu.classList.remove('navbar-menu--open');
        toggle.classList.remove('navbar-mobile-toggle--active');
      }
    });
  }

  // Cookie helper functions
  function setCookie(name, value, days) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    const expires = 'expires=' + date.toUTCString();
    document.cookie = name + '=' + value + ';' + expires + ';path=/';
  }

  function getCookie(name) {
    const nameEQ = name + '=';
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }

  function getThemeSettings() {
    window.VelunaThemeSettings = window.VelunaThemeSettings || {};
    if (!window.VelunaThemeSettings.emailSubscribeEndpoint) {
      window.VelunaThemeSettings.emailSubscribeEndpoint = '/apps/jarvis/email/subscribe';
    }
    if (!window.VelunaThemeSettings.emailSubscribeTopic) {
      window.VelunaThemeSettings.emailSubscribeTopic = 'popup_subscribe';
    }
    if (!window.VelunaThemeSettings.emailConcernMap) {
      window.VelunaThemeSettings.emailConcernMap = {
        'mind-calm-starter-set': 'mc',
        'mind-calm-stater-set': 'mc',
        'vs1-recovery-cream': 'dr',
        'sleep-plus-collagen-cream': 'ss',
        'deep-restore': 'dr',
        'sacred-soothe': 'ss',
        'circadian-reset': 'cr'
      };
    }
    return window.VelunaThemeSettings;
  }

  function parseBoolean(value, fallbackValue) {
    if (value === undefined || value === null || value === '') {
      return Boolean(fallbackValue);
    }
    return String(value).toLowerCase() === 'true';
  }

  function getCurrentPageType() {
    const path = window.location.pathname || '/';
    if (path.indexOf('/products/') === 0) return 'product';
    if (path.indexOf('/collections/') === 0) return 'collection';
    if (path.indexOf('/pages/') === 0) return 'page';
    if (path === '/' || path === '') return 'home';
    return 'other';
  }

  function getCurrentProductHandle() {
    const path = window.location.pathname || '';
    if (path.indexOf('/products/') !== 0) return '';
    return path.replace('/products/', '').split('/')[0];
  }

  function getCurrentProductTitle() {
    const node = document.querySelector('h1, [data-product-title]');
    return node ? (node.textContent || '').trim() : '';
  }

  function resolveAngleId() {
    try {
      const params = new URLSearchParams(window.location.search);
      const explicit = params.get('utm_content') || params.get('angle_id');
      if (explicit) {
        localStorage.setItem('veluna_last_angle_id', explicit);
        return explicit;
      }
    } catch (error) {
      logger.debug('Failed to parse angle id from URL:', error);
    }
    return localStorage.getItem('veluna_last_angle_id') || '';
  }

  function getProductContract(productHandle) {
    const contracts = (getThemeSettings().funnelContracts || {}).products || {};
    return contracts[productHandle] || null;
  }

  function resolveConcernCode(productHandle, explicitConcern) {
    const settings = getThemeSettings();
    if (explicitConcern) return explicitConcern;
    const contract = getProductContract(productHandle);
    if (contract && contract.concern) return contract.concern;
    return settings.emailConcernMap[productHandle] || 'mc';
  }

  function parseTagList(rawTags) {
    if (!rawTags) return [];
    return String(rawTags)
      .split(',')
      .map(function(tag) {
        return tag.toLowerCase().replace(/[^a-z0-9]+/g, '_').replace(/^_+|_+$/g, '');
      })
      .filter(Boolean);
  }

  function normalizeToken(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '_')
      .replace(/^_+|_+$/g, '');
  }

  function inferConcernFromToken(rawValue) {
    const token = normalizeToken(rawValue);
    if (!token) return '';
    if (token.indexOf('mind_calm') !== -1 || token.indexOf('mindcalm') !== -1 || token.indexOf('racing_mind') !== -1) {
      return 'mc';
    }
    if (token.indexOf('deep_restore') !== -1 || token.indexOf('deeprestore') !== -1) {
      return 'dr';
    }
    if (token.indexOf('sacred_soothe') !== -1 || token.indexOf('sacredsoothe') !== -1) {
      return 'ss';
    }
    if (token.indexOf('circadian_reset') !== -1 || token.indexOf('circadianreset') !== -1) {
      return 'cr';
    }
    return '';
  }

  function concernToCartSequence(concern) {
    const normalized = String(concern || '').toLowerCase();
    if (normalized === 'mc') return 'mind_calm_cart_save';
    if (normalized === 'dr') return 'deep_restore_cart_save';
    if (normalized === 'ss') return 'sacred_soothe_cart_save';
    if (normalized === 'cr') return 'circadian_reset_cart_save';
    return '';
  }

  function concernToLeadSequence(concern) {
    const normalized = String(concern || '').toLowerCase();
    if (normalized === 'mc') return 'mind_calm_pdp_exit';
    if (normalized === 'dr') return 'recovery_cream_pdp_exit';
    if (normalized === 'ss') return 'sacred_soothe_pdp_exit';
    if (normalized === 'cr') return 'circadian_reset_pdp_exit';
    return '';
  }

  function inferConcernFromCartItem(item) {
    if (!item) return '';
    const candidates = [
      item.handle,
      item.product_handle,
      item.title,
      item.product_title,
      item.variant_title,
      item.product_type,
      item.sku,
      item.vendor
    ];

    for (let i = 0; i < candidates.length; i += 1) {
      const concern = inferConcernFromToken(candidates[i]);
      if (concern) return concern;
    }

    const tags = Array.isArray(item.tags)
      ? item.tags
      : String(item.tags || '').split(',');
    for (let i = 0; i < tags.length; i += 1) {
      const concern = inferConcernFromToken(tags[i]);
      if (concern) return concern;
    }

    return '';
  }

  function resolveCartExitContext() {
    const cart = window.cart || {};
    const items = Array.isArray(cart.items) ? cart.items : [];
    const settings = getThemeSettings();
    const concernByHandle = settings.emailConcernMap || {};

    for (let i = 0; i < items.length; i += 1) {
      const item = items[i] || {};
      const handle = item.handle || item.product_handle || '';
      const contract = handle ? getProductContract(handle) : null;
      const explicitConcern = (handle && concernByHandle[handle]) || '';
      const inferredConcern = explicitConcern || inferConcernFromCartItem(item) || (contract && contract.concern) || '';
      const sequence = (contract && contract.cartCaptureVariant) || concernToCartSequence(inferredConcern);
      if (sequence || inferredConcern) {
        return {
          productHandle: handle,
          concern: inferredConcern,
          sequence: sequence,
          contract: contract || {}
        };
      }
    }

    return {
      productHandle: '',
      concern: '',
      sequence: '',
      contract: {}
    };
  }

  function resolvePopupCopy(sequence) {
    const copyBySequence = {
      mind_calm_cart_save: {
        title: 'Before You Go, Save Your Mind Calm Ritual',
        message: 'Leave your email and we will keep your cart plus tonight\'s Mind Calm wind-down routine ready for you.',
        primaryCta: 'Return to Cart',
        emailLabel: 'Enter your email and we will save your Mind Calm cart and ritual steps.',
        emailButton: 'Save Mind Calm Cart'
      },
      deep_restore_cart_save: {
        title: 'Keep Your Deep Restore Plan Ready',
        message: 'Share your email and we will hold your cart and send your Deep Restore bedtime protocol so you can restart tonight.',
        primaryCta: 'Secure My Cart',
        emailLabel: 'Enter your email to save your Deep Restore cart and recovery protocol.',
        emailButton: 'Save Deep Restore Cart'
      },
      sacred_soothe_cart_save: {
        title: 'Your Sacred Soothe Routine Is One Step Away',
        message: 'Drop your email and we will save your cart with your Sacred Soothe ritual notes for tonight.',
        primaryCta: 'Keep My Ritual Ready',
        emailLabel: 'Enter your email and we will save your Sacred Soothe cart plus ritual details.',
        emailButton: 'Save Sacred Soothe Cart'
      },
      circadian_reset_cart_save: {
        title: 'Lock In Your Circadian Reset Setup',
        message: 'Add your email and we will hold your cart and send your Circadian Reset timing guide.',
        primaryCta: 'Resume Checkout',
        emailLabel: 'Enter your email and we will save your Circadian Reset cart and timing guide.',
        emailButton: 'Save Circadian Reset Cart'
      }
    };

    return copyBySequence[sequence] || null;
  }

  function applyPopupCopy(popup, sequence) {
    const copy = resolvePopupCopy(sequence);
    if (!copy) return;

    const titleNode = popup.querySelector('.exit-intent-popup__title');
    const messageNode = popup.querySelector('.exit-intent-popup__message');
    const primaryButton = popup.querySelector('.exit-intent-popup__button--primary');
    const emailLabel = popup.querySelector('.exit-intent-popup__email-label');
    const emailButton = popup.querySelector('.exit-intent-popup__email-button');

    if (titleNode && copy.title) titleNode.textContent = copy.title;
    if (messageNode && copy.message) messageNode.textContent = copy.message;
    if (primaryButton && copy.primaryCta) primaryButton.textContent = copy.primaryCta;
    if (emailLabel && copy.emailLabel) emailLabel.textContent = copy.emailLabel;
    if (emailButton && copy.emailButton) emailButton.textContent = copy.emailButton;
  }

  function buildPopupContext(popup) {
    const popupKind = popup.dataset.popupKind || 'lead_capture';
    const cartExitContext = popupKind === 'cart_exit' ? resolveCartExitContext() : null;
    const productHandle = popup.dataset.productHandle || (cartExitContext && cartExitContext.productHandle) || getCurrentProductHandle();
    const productContract = getProductContract(productHandle) || {};
    const angleId = resolveAngleId();
    const angleConfig = angleId && productContract.angles ? productContract.angles[angleId] || {} : {};
    const defaultConcern = popup.dataset.concern || '';
    const resolvedConcern = (cartExitContext && cartExitContext.concern) || resolveConcernCode(productHandle, defaultConcern);
    const derivedSequence = popupKind === 'cart_exit'
      ? (
        (cartExitContext && cartExitContext.sequence) ||
        productContract.cartCaptureVariant ||
        concernToCartSequence(resolvedConcern)
      )
      : (
        productContract.emailSequence ||
        concernToLeadSequence(resolvedConcern)
      );
    const popupVariant = popup.dataset.popupVariant || derivedSequence || '';
    const emailSequence = popup.dataset.emailSequence || popupVariant || derivedSequence || '';

    if (popupKind === 'cart_exit' && popupVariant) {
      popup.dataset.popupVariant = popupVariant;
    }
    if (popupKind === 'cart_exit' && emailSequence) {
      popup.dataset.emailSequence = emailSequence;
    }
    if (popupKind === 'cart_exit' && resolvedConcern) {
      popup.dataset.concern = resolvedConcern;
    }

    return {
      page_type: getCurrentPageType(),
      product_handle: productHandle,
      product_title: getCurrentProductTitle(),
      angle_id: angleId,
      popup_id: popup.dataset.popupId || popup.id || '',
      popup_kind: popupKind,
      popup_variant: popupVariant,
      email_sequence: emailSequence,
      concern: resolvedConcern,
      cart_item_count: Number(popup.dataset.cartItemCount || (window.cart && window.cart.item_count) || 0),
      cart_total: Number(popup.dataset.cartTotal || (window.cart && window.cart.total_price ? window.cart.total_price / 100 : 0) || 0),
      contract_id: productContract.contractId || '',
      audience_stage: angleConfig.audienceStage || '',
      cta_type: angleConfig.ctaType || ''
    };
  }

  function emitFunnelEvent(eventName, context) {
    const payload = Object.assign({ event_name: eventName }, context || {});
    document.dispatchEvent(new CustomEvent('veluna:funnel-event', { detail: payload }));
    if (typeof gtag !== 'undefined') {
      try {
        gtag('event', eventName, {
          event_category: payload.popup_kind || 'funnel',
          event_label: payload.popup_variant || payload.popup_id || '',
          value: payload.cart_total || 1,
          product_handle: payload.product_handle || '',
          angle_id: payload.angle_id || ''
        });
      } catch (error) {
        logger.debug('gtag event failed:', error);
      }
    }
  }

  function getPopupStatusNode(popup) {
    return popup.querySelector('.newsletter-popup-message, .exit-intent-popup__status');
  }

  function showPopupMessage(popup, message, isError) {
    const node = getPopupStatusNode(popup);
    if (!node) return;
    node.textContent = message;
    node.style.display = 'block';
    node.style.color = isError ? '#CC5A71' : '#7FB069';
  }

  function shouldDisplayPopup(popup, cartPopupActive) {
    if (window.location.pathname.indexOf('/pages/ritual-quiz') !== -1) {
      return false;
    }
    const pageType = getCurrentPageType();
    const pageScope = popup.dataset.pageScope || 'all';
    if (pageScope === 'product' && pageType !== 'product') {
      return false;
    }
    if (pageScope === 'non_product' && pageType === 'product') {
      return false;
    }
    if (popup.dataset.popupKind === 'cart_exit') {
      return true;
    }
    if (cartPopupActive) {
      return false;
    }
    if (parseBoolean(popup.dataset.onlyWhenCartEmpty, false) && Number((window.cart && window.cart.item_count) || 0) > 0) {
      return false;
    }
    return true;
  }

  function isPopupSuppressed(popup) {
    const key = popup.dataset.suppressionKey;
    if (!key) return false;
    if (popup.dataset.suppressionScope === 'cookie') {
      return getCookie(key) === 'true';
    }
    return window.sessionStorage.getItem(key) === 'true';
  }

  function suppressPopup(popup) {
    const key = popup.dataset.suppressionKey;
    if (!key) return;
    if (popup.dataset.suppressionScope === 'cookie') {
      const cookieDays = parseInt(popup.dataset.cookieDays, 10) || 30;
      setCookie(key, 'true', cookieDays);
      return;
    }
    window.sessionStorage.setItem(key, 'true');
  }

  function bindPopupLifecycle(popup) {
    let isOpen = false;
    let previousFocus = null;

    function trapFocus(event) {
      const focusableElements = popup.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
      if (!focusableElements.length) return;
      const firstElement = focusableElements[0];
      const lastElement = focusableElements[focusableElements.length - 1];
      if (event.key !== 'Tab') return;
      if (event.shiftKey && document.activeElement === firstElement) {
        event.preventDefault();
        lastElement.focus();
      } else if (!event.shiftKey && document.activeElement === lastElement) {
        event.preventDefault();
        firstElement.focus();
      }
    }

    function handleEscape(event) {
      if (event.key === 'Escape') {
        close('escape');
      }
    }

    function close(reason) {
      if (!isOpen) return;
      isOpen = false;
      popup.style.display = 'none';
      popup.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      popup.removeEventListener('keydown', trapFocus);
      document.removeEventListener('keydown', handleEscape);
      if (previousFocus && typeof previousFocus.focus === 'function') {
        previousFocus.focus();
      }
      emitFunnelEvent('veluna_popup_closed', Object.assign(buildPopupContext(popup), { close_reason: reason || 'dismissed' }));
    }

    function open(trigger) {
      if (isOpen) return;
      isOpen = true;
      popup.style.display = 'flex';
      popup.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      previousFocus = document.activeElement;
      const emailInput = popup.querySelector('input[type="email"]');
      if (emailInput) {
        setTimeout(function() { emailInput.focus(); }, 100);
      }
      popup.addEventListener('keydown', trapFocus);
      document.addEventListener('keydown', handleEscape);
      suppressPopup(popup);
      emitFunnelEvent('veluna_popup_shown', Object.assign(buildPopupContext(popup), { trigger: trigger || 'unknown' }));
    }

    const closeButton = popup.querySelector('.newsletter-popup-close, .exit-intent-popup__close');
    const dismissButton = popup.querySelector('[data-dismiss-popup]');
    const overlay = popup.querySelector('.newsletter-popup-overlay, .exit-intent-popup__overlay');
    if (closeButton) {
      closeButton.addEventListener('click', function() { close('close_button'); });
    }
    if (dismissButton) {
      dismissButton.addEventListener('click', function() { close('secondary_cta'); });
    }
    if (overlay) {
      overlay.addEventListener('click', function() { close('overlay'); });
    }
    popup.addEventListener('click', function(event) {
      if (event.target === popup) {
        close('overlay');
      }
    });

    return {
      open: open,
      close: close,
      isOpen: function() { return isOpen; }
    };
  }

  function submitPopupCapture(form, popup, lifecycle) {
    form.addEventListener('submit', function(event) {
      event.preventDefault();
      const emailInput = form.querySelector('input[type="email"], input[name="contact[email]"]');
      const email = emailInput ? String(emailInput.value || '').trim().toLowerCase() : '';
      if (!email) {
        showPopupMessage(popup, 'Enter a valid email address.', true);
        return;
      }

      const settings = getThemeSettings();
      const context = buildPopupContext(popup);
      const concern = context.concern || resolveConcernCode(context.product_handle, popup.dataset.concern);
      const payload = {
        topic: settings.emailSubscribeTopic || 'popup_subscribe',
        email: email,
        concern: concern,
        first_name: '',
        source: popup.dataset.source || 'popup',
        tags: [
          'veluna_sleep',
          context.popup_kind,
          context.popup_variant,
          context.page_type,
          context.product_handle,
          context.angle_id,
          'concern_' + concern
        ].concat(parseTagList(popup.dataset.tags)).filter(Boolean),
        fields: {
          popup_id: context.popup_id,
          popup_variant: context.popup_variant,
          popup_kind: context.popup_kind,
          product_handle: context.product_handle,
          angle_id: context.angle_id,
          email_sequence: context.email_sequence,
          audience_stage: context.audience_stage,
          cta_type: context.cta_type
        },
        metadata: {
          page_url: window.location.href,
          referrer: document.referrer || '',
          product_title: context.product_title,
          cart_item_count: context.cart_item_count,
          cart_total: context.cart_total,
          contract_id: context.contract_id
        }
      };

      emitFunnelEvent('veluna_popup_submit_started', context);
      fetch(settings.emailSubscribeEndpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
        credentials: 'same-origin'
      })
        .then(function(response) {
          if (!response.ok) {
            throw new Error('Capture request failed.');
          }
          return response.json();
        })
        .then(function() {
          localStorage.setItem('veluna_customer_email', email);
          showPopupMessage(popup, popup.dataset.successMessage || 'Check your inbox.', false);
          form.style.display = 'none';
          emitFunnelEvent('veluna_popup_submit_success', Object.assign(context, { email_captured: true }));
          setTimeout(function() { lifecycle.close('success'); }, 2000);
        })
        .catch(function(error) {
          showPopupMessage(popup, 'Something went wrong. Please try again.', true);
          emitFunnelEvent('veluna_popup_submit_error', Object.assign(context, { error: error.message || 'unknown_error' }));
        });
    });
  }

  function initCartExitPopup(popup) {
    if (!popup || isPopupSuppressed(popup)) return false;
    const startupContext = buildPopupContext(popup);
    applyPopupCopy(popup, startupContext.email_sequence || startupContext.popup_variant);
    const lifecycle = bindPopupLifecycle(popup);
    const form = popup.querySelector('[data-email-capture-form]');
    if (form) {
      submitPopupCapture(form, popup, lifecycle);
    }
    const primaryButton = popup.querySelector('.exit-intent-popup__button--primary');
    if (primaryButton) {
      primaryButton.addEventListener('click', function() {
        emitFunnelEvent('veluna_popup_primary_cta', buildPopupContext(popup));
      });
    }
    let shown = false;
    window.PerformanceCore.event('mouseleave', function(event) {
      if (shown || event.clientY > 0) return;
      shown = true;
      const liveCount = (window.cart && window.cart.item_count) || 0;
      if (liveCount > 0) {
        const triggerContext = buildPopupContext(popup);
        applyPopupCopy(popup, triggerContext.email_sequence || triggerContext.popup_variant);
      }
      lifecycle.open('exit_intent');
    }, { target: document, passive: true });
    window.addEventListener('pagehide', function() {
      emitFunnelEvent('veluna_cart_abandonment', buildPopupContext(popup));
    });
    return true;
  }

  function initLeadCapturePopup(popup) {
    if (!popup || isPopupSuppressed(popup)) return;
    const lifecycle = bindPopupLifecycle(popup);
    const form = popup.querySelector('[data-email-capture-form]');
    if (form) {
      submitPopupCapture(form, popup, lifecycle);
    }

    const triggerType = popup.dataset.triggerType || 'time_and_exit';
    const triggerValue = parseInt(popup.dataset.triggerValue, 10) || 12;
    let shown = false;

    function openIfNeeded(trigger) {
      if (shown) return;
      shown = true;
      lifecycle.open(trigger);
    }

    if (triggerType === 'time_delay' || triggerType === 'time_and_exit') {
      setTimeout(function() { openIfNeeded('time_delay'); }, triggerValue * 1000);
    }
    if (triggerType === 'scroll_depth') {
      let scrollTriggered = false;
      window.PerformanceCore.event('scroll', function() {
        if (scrollTriggered || shown) return;
        window.PerformanceCore.rafBatch(function() {
          const scrollPercent = (window.scrollY / Math.max(document.documentElement.scrollHeight - window.innerHeight, 1)) * 100;
          if (scrollPercent >= triggerValue) {
            scrollTriggered = true;
            openIfNeeded('scroll_depth');
          }
        });
      }, { passive: true, throttle: 'raf' });
    }
    if (triggerType === 'exit_intent' || triggerType === 'time_and_exit') {
      window.PerformanceCore.event('mouseleave', function(event) {
        if (event.clientY <= 0) {
          openIfNeeded('exit_intent');
        }
      }, { target: document, passive: true });
    }
  }

  function initFunnelPopups() {
    getThemeSettings();
    const cartPopup = document.getElementById('exit-intent-popup');
    const leadPopup = document.getElementById('newsletter-popup-overlay');

    function run() {
      const cartPopupActive = cartPopup && shouldDisplayPopup(cartPopup, false);
      if (cartPopupActive) {
        initCartExitPopup(cartPopup);
      }
      if (leadPopup && shouldDisplayPopup(leadPopup, Boolean(cartPopupActive))) {
        initLeadCapturePopup(leadPopup);
      }
    }

    // Wait for async cart fetch so window.cart is populated before init
    if (window.__velunaCartBootstrapPromise) {
      window.__velunaCartBootstrapPromise.then(run).catch(run);
    } else {
      run();
    }
  }

  // Cart functionality
  window.addToCart = function(variantId, quantity = 1) {
    return fetch(window.routes.cart_add_url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        items: [{
          id: variantId,
          quantity: quantity
        }]
      })
    })
    .then(response => response.json())
    .then(data => {
      if (data.error) {
        console.error('Cart error:', data.error);
        return Promise.reject(data.error);
      }
      // Update global cart variable after adding to cart
      if (data && typeof window !== 'undefined') {
        window.cart = data;
      }
      return data;
    });
  };

  // Loading states for forms and buttons
  function initLoadingStates() {
    // Add to cart forms
    const addToCartForms = document.querySelectorAll('form[action="/cart/add"]');
    addToCartForms.forEach(function(form) {
      form.addEventListener('submit', function(e) {
        const button = form.querySelector('.pdp-add-to-cart');
        if (button) {
          setButtonLoading(button, true);
        }
      });
    });

    // Newsletter forms
    const newsletterForms = document.querySelectorAll('.newsletter-popup-form, .newsletter-capture-form');
    newsletterForms.forEach(function(form) {
      form.addEventListener('submit', function(e) {
        const button = form.querySelector('button[type="submit"]');
        if (button) {
          setButtonLoading(button, true);
        }
      });
    });

    // Contact forms
    const contactForms = document.querySelectorAll('.contact-form');
    contactForms.forEach(function(form) {
      form.addEventListener('submit', function(e) {
        const button = form.querySelector('.contact-form-submit');
        if (button) {
          setButtonLoading(button, true);
        }
      });
    });

    // Quiz lead forms
    const quizForms = document.querySelectorAll('.quiz-lead-form');
    quizForms.forEach(function(form) {
      form.addEventListener('submit', function(e) {
        const button = form.querySelector('.quiz-lead-submit');
        if (button) {
          setButtonLoading(button, true);
        }
      });
    });

    // Sticky ATC forms
    const stickyATCForms = document.querySelectorAll('.pdp-sticky-form');
    stickyATCForms.forEach(function(form) {
      form.addEventListener('submit', function(e) {
        const button = form.querySelector('.pdp-sticky-add-to-cart');
        if (button) {
          setButtonLoading(button, true);
        }
      });
    });

    // Product card quick add forms
    const quickAddForms = document.querySelectorAll('.product-card-quick-add, .pdp-cross-sell-quick-add');
    quickAddForms.forEach(function(form) {
      form.addEventListener('submit', function(e) {
        e.preventDefault();
        const button = form.querySelector('button[type="submit"]');
        if (button) {
          setButtonLoading(button, true);
          
          // Get form data
          const formData = new FormData(form);
          
          // Submit to cart
          fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Accept': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: formData
          })
            .then(function(response) {
              if (!response.ok) {
                return response.json().catch(function() { return {}; }).then(function(err) {
                  const error = new Error(err.description || 'Unable to add product to cart.');
                  error.status = response.status;
                  throw error;
                });
              }
              return response.json();
            })
            .then(function() {
              setButtonLoading(button, false);
              if (window.openCartDrawer) {
                window.openCartDrawer();
              } else {
                window.location.href = '/cart';
              }
              if (window.showNotification) {
                window.showNotification('Added to cart!', 'success');
              }
            })
            .catch(function(error) {
              console.error('Error adding to cart:', error);
              setButtonLoading(button, false);
              const message = error.message || 'Unable to add product to cart. Please try again.';
              if (window.showNotification) {
                window.showNotification(message, 'error');
              } else if (window.showErrorToast) {
                window.showErrorToast(message);
              } else {
                alert(message);
              }
            });
        }
      });
    });
  }

  function initAjaxProductForm() {
    const form = document.getElementById('pdp-add-to-cart-form');
    if (!form) return;
    
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      const button = form.querySelector('.pdp-add-to-cart');
      if (button) {
        setButtonLoading(button, true);
      }
      
      const formData = new FormData(form);
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: formData
      })
        .then(function(response) {
          if (!response.ok) {
            return response.json().catch(function() { return {}; }).then(function(err) {
              const error = new Error(err.description || 'Unable to add product to cart.');
              error.status = response.status;
              throw error;
            });
          }
          return response.json();
        })
        .then(function() {
          if (button) {
            setButtonLoading(button, false);
          }
          if (window.openCartDrawer) {
            window.openCartDrawer();
          } else {
            window.location.href = '/cart';
          }
          if (window.showNotification) {
            window.showNotification('Added to cart!', 'success');
          }
        })
        .catch(function(error) {
          console.error('PDP add to cart failed:', error);
          if (button) {
            setButtonLoading(button, false);
          }
          const message = error.message || 'Unable to add product to cart. Please try again.';
          if (window.showNotification) {
            window.showNotification(message, 'error');
          } else if (window.showErrorToast) {
            window.showErrorToast(message);
          } else {
            alert(message);
          }
        });
    });
  }

  // Helper function to set button loading state
  function setButtonLoading(button, isLoading) {
    if (!button) return;
    
    const textSpan = button.querySelector('span:first-of-type');
    const spinnerSpan = button.querySelector('span:last-of-type');
    
    if (isLoading) {
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      if (textSpan) textSpan.style.display = 'none';
      if (spinnerSpan) spinnerSpan.style.display = 'inline';
    } else {
      button.disabled = false;
      button.setAttribute('aria-busy', 'false');
      if (textSpan) textSpan.style.display = 'inline';
      if (spinnerSpan) spinnerSpan.style.display = 'none';
    }
  }

  // Product Image Gallery
  function initProductImageGallery() {
    const mainImage = document.getElementById('pdp-main-image');
    const thumbBtns = document.querySelectorAll('.pdp-image-thumb-btn');
    const zoomBtn = document.querySelector('.pdp-image-zoom-btn');
    const lightbox = document.getElementById('pdp-image-lightbox');
    const lightboxImg = document.getElementById('pdp-image-lightbox-img');
    const lightboxClose = document.querySelector('.pdp-image-lightbox-close');
    const lightboxOverlay = document.querySelector('.pdp-image-lightbox-overlay');
    const lightboxPrev = document.querySelector('.pdp-image-lightbox-prev');
    const lightboxNext = document.querySelector('.pdp-image-lightbox-next');
    
    let currentImageIndex = 0;
    const productImages = Array.from(thumbBtns).map(function(btn) {
      return {
        url: btn.dataset.imageUrl,
        index: parseInt(btn.dataset.imageIndex)
      };
    });

    // Thumbnail click handler
    thumbBtns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        const imageUrl = this.dataset.imageUrl;
        const imageIndex = parseInt(this.dataset.imageIndex);
        
        if (mainImage) {
          mainImage.src = imageUrl;
          mainImage.dataset.imageIndex = imageIndex;
        }
        
        // Update active state
        thumbBtns.forEach(function(b) {
          b.classList.remove('pdp-image-thumb-btn--active');
        });
        this.classList.add('pdp-image-thumb-btn--active');
        
        currentImageIndex = imageIndex;
      });
    });

    // Zoom button handler
    if (zoomBtn && lightbox && lightboxImg) {
      zoomBtn.addEventListener('click', function() {
        if (mainImage) {
          lightboxImg.src = mainImage.src;
          currentImageIndex = parseInt(mainImage.dataset.imageIndex) || 0;
        }
        lightbox.style.display = 'flex';
        lightbox.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
      });
    }

    // Close lightbox
    function closeLightbox() {
      if (lightbox) {
        lightbox.style.display = 'none';
        lightbox.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
      }
    }

    if (lightboxClose) {
      lightboxClose.addEventListener('click', closeLightbox);
    }

    if (lightboxOverlay) {
      lightboxOverlay.addEventListener('click', closeLightbox);
    }

    // ESC key to close
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && lightbox && lightbox.getAttribute('aria-hidden') === 'false') {
        closeLightbox();
      }
    });

    // Lightbox navigation
    function showImage(index) {
      if (productImages.length === 0) return;
      
      if (index < 0) index = productImages.length - 1;
      if (index >= productImages.length) index = 0;
      
      currentImageIndex = index;
      const image = productImages[index];
      if (lightboxImg && image) {
        lightboxImg.src = image.url;
      }
      
      // Update main image if exists
      if (mainImage) {
        mainImage.src = image.url;
        mainImage.dataset.imageIndex = index;
      }
      
      // Update thumbnails
      thumbBtns.forEach(function(btn) {
        btn.classList.remove('pdp-image-thumb-btn--active');
        if (parseInt(btn.dataset.imageIndex) === index) {
          btn.classList.add('pdp-image-thumb-btn--active');
        }
      });
    }

    if (lightboxPrev) {
      lightboxPrev.addEventListener('click', function(e) {
        e.stopPropagation();
        showImage(currentImageIndex - 1);
      });
    }

    if (lightboxNext) {
      lightboxNext.addEventListener('click', function(e) {
        e.stopPropagation();
        showImage(currentImageIndex + 1);
      });
    }

    // Keyboard navigation in lightbox
    if (lightbox) {
      lightbox.addEventListener('keydown', function(e) {
        if (e.key === 'ArrowLeft') {
          e.preventDefault();
          showImage(currentImageIndex - 1);
        } else if (e.key === 'ArrowRight') {
          e.preventDefault();
          showImage(currentImageIndex + 1);
        }
      });
    }
  }

  // Visual Variant Picker
  function initVariantPicker() {
    const variantOptions = document.querySelectorAll('.pdp-variant-option');
    const variantIdInput = document.getElementById('pdp-selected-variant-id');
    const form = document.getElementById('pdp-add-to-cart-form');
    
    if (!variantIdInput || !form) return;

    // Get product data from form
    const productHandle = form.dataset.jarvisProductHandle;
    if (!productHandle) return;

    // Fetch product JSON for variant matching
    fetch('/products/' + productHandle + '.js')
      .then(function(response) {
        return response.json();
      })
      .then(function(product) {
        const variantBtns = document.querySelectorAll('.pdp-variant-option-btn:not(:disabled)');
        
        variantBtns.forEach(function(btn) {
          btn.addEventListener('click', function() {
            const optionIndex = parseInt(this.dataset.optionIndex);
            const optionValue = this.dataset.optionValue;
            
            // Update selected state
            const optionGroup = this.closest('.pdp-variant-option');
            const optionBtns = optionGroup.querySelectorAll('.pdp-variant-option-btn');
            optionBtns.forEach(function(b) {
              b.classList.remove('pdp-variant-option-btn--selected');
            });
            this.classList.add('pdp-variant-option-btn--selected');
            
            // Update selected value display
            const selectedSpan = document.getElementById('pdp-option-' + optionIndex + '-selected');
            if (selectedSpan) {
              selectedSpan.textContent = optionValue;
            }
            
            // Find matching variant
            const selectedOptions = [];
            variantOptions.forEach(function(opt) {
              const selectedBtn = opt.querySelector('.pdp-variant-option-btn--selected');
              if (selectedBtn) {
                selectedOptions.push(selectedBtn.dataset.optionValue);
              }
            });
            
            // Match variant
            const matchedVariant = product.variants.find(function(v) {
              return v.options.length === selectedOptions.length &&
                     v.options.every(function(opt, idx) {
                       return opt === selectedOptions[idx];
                     });
            });
            
            if (matchedVariant && variantIdInput) {
              variantIdInput.value = matchedVariant.id;
              variantIdInput.dataset.jarvisVariantId = matchedVariant.id;
              
              // Update price if element exists
              const priceEl = document.querySelector('.pdp-price-regular, .pdp-price-sale');
              if (priceEl && matchedVariant.price) {
                // Price update would go here if needed
              }
              
              // Update image if variant has specific image
              if (matchedVariant.featured_image) {
                const mainImage = document.getElementById('pdp-main-image');
                if (mainImage) {
                  mainImage.src = matchedVariant.featured_image.src;
                }
              }
            }
          });
        });
      })
      .catch(function(err) {
        logger.warn('Could not load product data for variant picker:', err);
      });
  }

  // Urgency Timer
  function initUrgencyTimer() {
    const timerEl = document.querySelector('.pdp-urgency-timer-countdown');
    if (!timerEl) return;

    const hours = parseInt(timerEl.dataset.urgencyHours) || 24;
    const endTime = new Date().getTime() + (hours * 60 * 60 * 1000);

    function updateTimer() {
      const now = new Date().getTime();
      const distance = endTime - now;

      if (distance < 0) {
        timerEl.textContent = '00:00:00';
        return;
      }

      const hoursRemaining = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutesRemaining = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const secondsRemaining = Math.floor((distance % (1000 * 60)) / 1000);

      const h = String(hoursRemaining).padStart(2, '0');
      const m = String(minutesRemaining).padStart(2, '0');
      const s = String(secondsRemaining).padStart(2, '0');

      timerEl.textContent = h + ':' + m + ':' + s;
    }

    updateTimer();
    setInterval(updateTimer, 1000);
  }

  // Toast Notification System
  function initToastSystem() {
    // Create toast container if it doesn't exist
    let container = document.getElementById('toast-container');
    if (!container) {
      container = document.createElement('div');
      container.id = 'toast-container';
      container.className = 'toast-container';
      container.setAttribute('aria-live', 'polite');
      container.setAttribute('aria-atomic', 'true');
      document.body.appendChild(container);
    }
  }

  // Show toast notification
  function showToast(message, type = 'info', duration = 4000) {
    const container = document.getElementById('toast-container');
    if (!container) {
      initToastSystem();
      container = document.getElementById('toast-container');
    }

    const toast = document.createElement('div');
    toast.className = 'toast toast--' + type;
    toast.setAttribute('role', 'alert');
    toast.setAttribute('aria-live', 'assertive');
    
    const icon = type === 'success' ? '✓' : type === 'error' ? '✕' : type === 'warning' ? '⚠' : 'ℹ';
    toast.innerHTML = `
      <span class="toast-icon">${icon}</span>
      <span class="toast-message">${message}</span>
      <button class="toast-close" aria-label="Close notification" type="button">×</button>
    `;

    container.appendChild(toast);

    // Trigger animation
    setTimeout(function() {
      toast.classList.add('toast--show');
    }, 10);

    // Close button
    const closeBtn = toast.querySelector('.toast-close');
    closeBtn.addEventListener('click', function() {
      closeToast(toast);
    });

    // Auto-close
    if (duration > 0) {
      setTimeout(function() {
        closeToast(toast);
      }, duration);
    }

    return toast;
  }

  // Close toast
  function closeToast(toast) {
    toast.classList.remove('toast--show');
    toast.classList.add('toast--hide');
    setTimeout(function() {
      if (toast.parentNode) {
        toast.parentNode.removeChild(toast);
      }
    }, 300);
  }

  // Expose toast functions globally
  window.showToast = showToast;
  window.showSuccessToast = function(message, duration) {
    return showToast(message, 'success', duration);
  };
  window.showErrorToast = function(message, duration) {
    return showToast(message, 'error', duration);
  };
  window.showWarningToast = function(message, duration) {
    return showToast(message, 'warning', duration);
  };
  window.showInfoToast = function(message, duration) {
    return showToast(message, 'info', duration);
  };
  window.showNotification = function(message, type = 'info', duration) {
    return showToast(message, type, duration);
  };

  // ═══════════════════════════════════════════════════════════════════════════
  // TILE-030: CART DRAWER ENGINE
  // ═══════════════════════════════════════════════════════════════════════════
  
  // Cart Drawer: Open/Close
  function initCartDrawer() {
    const drawer = document.getElementById('v-cart-drawer');
    const overlay = drawer?.querySelector('.js-cart-drawer-overlay');
    const closeBtn = drawer?.querySelector('.js-cart-drawer-close');
    const triggers = document.querySelectorAll('.js-cart-drawer-trigger, a[href*="/cart"]');
    
    if (!drawer) return;
    
    let focusTrap = null;
    let previouslyFocused = null;
    
    // Open drawer
    function openDrawer() {
      drawer.setAttribute('aria-hidden', 'false');
      drawer.classList.add('is-open');
      document.body.classList.add('drawer-open');
      
      // Focus trap
      previouslyFocused = document.activeElement;
      trapFocus(drawer);
      
      // Prevent body scroll
      document.body.style.overflow = 'hidden';
      
      // Track event
      if (window.dataLayer) {
        window.dataLayer.push({
          'event': 'cart_drawer_open',
          'cart_item_count': window.cart?.item_count || 0
        });
      }
    }
    
    // Close drawer
    function closeDrawer() {
      drawer.setAttribute('aria-hidden', 'true');
      drawer.classList.remove('is-open');
      document.body.classList.remove('drawer-open');
      
      // Release focus trap
      releaseFocusTrap();
      
      // Restore body scroll
      document.body.style.overflow = '';
      
      // Return focus to trigger
      if (previouslyFocused) {
        previouslyFocused.focus();
        previouslyFocused = null;
      }
      
      // Track event
      if (window.dataLayer) {
        window.dataLayer.push({
          'event': 'cart_drawer_close'
        });
      }
    }
    
    // Focus trap
    function trapFocus(container) {
      const focusableElements = container.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
      );
      
      const firstElement = focusableElements[0];
      const lastElement = focusableElements[focusableElements.length - 1];
      
      function handleTab(e) {
        if (e.key !== 'Tab') return;
        
        if (e.shiftKey) {
          if (document.activeElement === firstElement) {
            e.preventDefault();
            lastElement?.focus();
          }
        } else {
          if (document.activeElement === lastElement) {
            e.preventDefault();
            firstElement?.focus();
          }
        }
      }
      
      container.addEventListener('keydown', handleTab);
      firstElement?.focus();
      
      focusTrap = handleTab;
    }
    
    // Release focus trap
    function releaseFocusTrap() {
      if (focusTrap) {
        drawer.removeEventListener('keydown', focusTrap);
        focusTrap = null;
      }
    }
    
    // Escape key handler
    function handleEscape(e) {
      if (e.key === 'Escape' && drawer.getAttribute('aria-hidden') === 'false') {
        closeDrawer();
      }
    }
    
    // Event listeners
    triggers.forEach(function(trigger) {
      trigger.addEventListener('click', function(e) {
        e.preventDefault();
        openDrawer();
      });
    });
    
    if (closeBtn) {
      closeBtn.addEventListener('click', closeDrawer);
    }
    
    if (overlay) {
      overlay.addEventListener('click', closeDrawer);
    }
    
    document.addEventListener('keydown', handleEscape);
    
    // Expose functions globally
    window.openCartDrawer = openDrawer;
    window.closeCartDrawer = closeDrawer;
  }
  
  // Cart Drawer: Quantity Controls
  function initCartQuantityControls() {
    const drawer = document.getElementById('v-cart-drawer');
    if (!drawer) return;
    
    // Increment quantity
    drawer.addEventListener('click', function(e) {
      const incrementBtn = e.target.closest('.js-cart-quantity-increment');
      if (incrementBtn) {
        e.preventDefault();
        const itemKey = incrementBtn.dataset.itemKey;
        if (itemKey && window.cart) {
          const cartItem = window.cart.items.find(function(item) {
            return item.key === itemKey;
          });
          if (cartItem) {
            updateCartQuantity(itemKey, cartItem.quantity + 1);
          }
        }
      }
    });
    
    // Decrement quantity
    drawer.addEventListener('click', function(e) {
      const decrementBtn = e.target.closest('.js-cart-quantity-decrement');
      if (decrementBtn) {
        e.preventDefault();
        const itemKey = decrementBtn.dataset.itemKey;
        if (itemKey && window.cart) {
          const cartItem = window.cart.items.find(function(item) {
            return item.key === itemKey;
          });
          if (cartItem && cartItem.quantity > 1) {
            updateCartQuantity(itemKey, cartItem.quantity - 1);
          }
        }
      }
    });
    
    // Remove item
    drawer.addEventListener('click', function(e) {
      const removeBtn = e.target.closest('.js-cart-remove-item');
      if (removeBtn) {
        e.preventDefault();
        const itemKey = removeBtn.dataset.itemKey;
        if (itemKey) {
          removeCartItem(itemKey);
        }
      }
    });
  }
  
  // Update cart quantity
  function updateCartQuantity(itemKey, quantity) {
    if (!itemKey) return;
    
    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: itemKey,
        quantity: quantity
      })
    })
    .then(function(response) {
      if (response.ok) {
        return response.json();
      }
      throw new Error('Failed to update cart');
    })
    .then(function(cart) {
      window.cart = cart;
      refreshCartDrawer();
      updateProgressBar(cart);
    })
    .catch(function(err) {
      console.error('Cart update failed:', err);
      if (window.showErrorToast) {
        window.showErrorToast('Failed to update cart. Please try again.');
      }
    });
  }
  
  // Remove cart item
  function removeCartItem(itemKey) {
    if (!itemKey) return;
    
    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: itemKey,
        quantity: 0
      })
    })
    .then(function(response) {
      if (response.ok) {
        return response.json();
      }
      throw new Error('Failed to remove item');
    })
    .then(function(cart) {
      window.cart = cart;
      refreshCartDrawer();
      updateProgressBar(cart);
      
      if (window.showSuccessToast) {
        window.showSuccessToast('Item removed from cart');
      }
    })
    .catch(function(err) {
      console.error('Cart removal failed:', err);
      if (window.showErrorToast) {
        window.showErrorToast('Failed to remove item. Please try again.');
      }
    });
  }
  
  // Refresh cart drawer
  function refreshCartDrawer() {
    const drawer = document.getElementById('v-cart-drawer');
    if (!drawer) return;
    
    fetch('/cart.js')
      .then(function(response) {
        return response.json();
      })
      .then(function(cart) {
        window.cart = cart;
        // Reload drawer HTML via section rendering
        fetch('/?section_id=cart-drawer')
          .then(function(response) {
            return response.text();
          })
          .then(function(html) {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            const newDrawer = doc.getElementById('v-cart-drawer');
            if (newDrawer) {
              drawer.innerHTML = newDrawer.innerHTML;
              initCartQuantityControls();
              updateProgressBar(cart);
              updateCartCount(cart);
            }
          })
          .catch(function(err) {
            console.error('Cart drawer HTML refresh failed:', err);
          });
      })
      .catch(function(err) {
        console.error('Cart refresh failed:', err);
      });
  }
  
  // Update progress bar
  function updateProgressBar(cart) {
    if (!cart) return;
    
    const threshold = 5000; // $50 in cents (default)
    const cartTotal = cart.total_price || 0;
    const remaining = Math.max(0, threshold - cartTotal);
    const progressPercent = Math.min(100, (cartTotal / threshold) * 100);
    
    const progressFill = document.querySelector('.v-cart-progress__fill');
    const progressText = document.querySelector('.v-cart-progress__text');
    
    if (progressFill) {
      progressFill.style.width = progressPercent + '%';
    }
    
    if (progressText && remaining > 0) {
      const dollarsRemaining = (remaining / 100).toFixed(2);
      progressText.textContent = 'You\'re $' + dollarsRemaining + ' away from free shipping';
    } else if (progressText && remaining <= 0) {
      progressText.textContent = '🎉 You\'ve unlocked FREE Shipping!';
    }
  }
  
  // Initialize cart drawer after DOM ready
  deferUntilAfterLCP(function() {
    initCartDrawer();
    initCartQuantityControls();
    
    // Update cart count in header
    if (window.cart) {
      updateCartCount(window.cart);
    }
  });
  
  // Update cart count in header
  function updateCartCount(cart) {
    const cartCounts = document.querySelectorAll('.header__cart-count, .cart-count');
    const count = cart.item_count || 0;
    
    cartCounts.forEach(function(el) {
      if (count > 0) {
        el.textContent = count;
        el.style.display = 'inline-block';
      } else {
        el.style.display = 'none';
      }
    });
  }
  
  // Listen for cart updates (from AJAX add-to-cart)
  document.addEventListener('cart:updated', function(e) {
    if (e.detail && e.detail.cart) {
      window.cart = e.detail.cart;
      refreshCartDrawer();
      updateCartCount(e.detail.cart);
      updateProgressBar(e.detail.cart);
    }
  });
  
  // Expose functions globally
  window.refreshCartDrawer = refreshCartDrawer;
  window.updateCartCount = updateCartCount;

  // ═══════════════════════════════════════════════════════════════════════════
  // TILE-001: MOBILE STICKY ADD-TO-CART BAR (Atlas Report)
  // Enhanced from TILE-031 with hero section visibility detection
  // ═══════════════════════════════════════════════════════════════════════════
  
  // Sticky ATC: Scroll detection and visibility with hero section awareness
  function initPDPStickyATC() {
    const stickyATC = document.querySelector('.js-pdp-sticky-atc');
    if (!stickyATC) return;
    
    // Only enable on mobile devices (< 768px) per TILE-001 requirements
    const isMobile = window.innerWidth < 768;
    if (!isMobile) {
      stickyATC.style.display = 'none';
      return;
    }
    
    const scrollThreshold = parseInt(stickyATC.dataset.scrollThreshold || '300', 10);
    const heroSection = document.querySelector('.pdp-above-fold-section') || 
                        document.querySelector('.pdp-images') ||
                        document.querySelector('.pdp-info');
    let isVisible = false;
    let lastScrollY = window.scrollY || window.pageYOffset;
    
    // Function to check if hero section is visible in viewport
    function isHeroSectionVisible() {
      if (!heroSection) return false;
      const rect = heroSection.getBoundingClientRect();
      const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
      // Hero is visible if any part of it is in the viewport
      return rect.bottom > 0 && rect.top < viewportHeight;
    }
    
    // Function to update sticky ATC visibility
    function updateStickyATCVisibility() {
      const scrollY = window.scrollY || window.pageYOffset;
      const heroVisible = isHeroSectionVisible();
      const scrolledPastThreshold = scrollY >= scrollThreshold;
      
      // Show sticky ATC only if:
      // 1. Scrolled past threshold AND
      // 2. Hero section is not visible (scrolled past it)
      const shouldShow = scrolledPastThreshold && !heroVisible;
      
      if (shouldShow && !isVisible) {
        stickyATC.setAttribute('aria-hidden', 'false');
        isVisible = true;
      } else if (!shouldShow && isVisible) {
        stickyATC.setAttribute('aria-hidden', 'true');
        isVisible = false;
      }
      
      lastScrollY = scrollY;
    }
    
    // Use passive scroll listener for performance
    window.PerformanceCore.event('scroll', function() {
      window.PerformanceCore.rafBatch(function() {
        updateStickyATCVisibility();
      });
    }, { passive: true, throttle: 'raf' });
    
    // Initial check
    updateStickyATCVisibility();
    
    // Handle window resize (mobile/desktop switch)
    let resizeTimeout;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(function() {
        const isMobileNow = window.innerWidth < 768;
        if (isMobileNow !== isMobile) {
          stickyATC.style.display = isMobileNow ? '' : 'none';
          if (isMobileNow) {
            updateStickyATCVisibility();
          }
        }
      }, 250);
    }, { passive: true });
    
    // Sync variant selection with main form and update price
    const stickyVariantSelect = stickyATC.querySelector('.js-sticky-atc-variant');
    const stickyPriceElement = stickyATC.querySelector('.v-pdp-sticky-atc__price');
    const mainVariantSelect = document.querySelector('#pdp-variant-' + (document.querySelector('[id^="pdp-variant-"]')?.id || '').replace('pdp-variant-', ''));
    // Standardized form selector pattern
    const mainProductForm = document.querySelector('.pdp-hero__form');
    const mainPriceElement = document.querySelector('.pdp-price') || document.querySelector('[data-test="product-price"]');
    
    // Function to update sticky bar price (TILE-001: Dynamic price updates)
    function updateStickyPrice(variantId) {
      if (!stickyPriceElement || !stickyVariantSelect) return;
      
      const selectedOption = stickyVariantSelect.querySelector('option[value="' + variantId + '"]');
      if (!selectedOption) return;
      
      const price = selectedOption.dataset.price;
      const comparePrice = selectedOption.dataset.comparePrice;
      
      if (price) {
        // Use Shopify money format helper if available, otherwise format manually
        let formattedPrice, formattedComparePrice;
        
        if (window.Shopify && window.Shopify.formatMoney) {
          formattedPrice = window.Shopify.formatMoney(parseInt(price), '{{ shop.money_format }}');
          if (comparePrice) {
            formattedComparePrice = window.Shopify.formatMoney(parseInt(comparePrice), '{{ shop.money_format }}');
          }
        } else {
          // Fallback: Format using Intl.NumberFormat
          formattedPrice = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
          }).format(parseInt(price) / 100);
          
          if (comparePrice) {
            formattedComparePrice = new Intl.NumberFormat('en-US', {
              style: 'currency',
              currency: 'USD',
              minimumFractionDigits: 0,
              maximumFractionDigits: 0
            }).format(parseInt(comparePrice) / 100);
          }
        }
        
        // Update sticky bar price display
        if (comparePrice && parseInt(comparePrice) > parseInt(price)) {
          stickyPriceElement.innerHTML = '<span class="pdp-price-compare">' + formattedComparePrice + '</span> <span class="pdp-price-sale">' + formattedPrice + '</span>';
        } else {
          stickyPriceElement.innerHTML = '<span class="pdp-price-regular">' + formattedPrice + '</span>';
        }
        
        // Announce price change to screen readers
        stickyPriceElement.setAttribute('aria-live', 'polite');
      }
    }
    
    if (stickyVariantSelect) {
      // Sync sticky variant to main form
      stickyVariantSelect.addEventListener('change', function(e) {
        const variantId = e.target.value;
        
        // Update sticky bar price
        updateStickyPrice(variantId);
        
        // Sync with main form if it exists
        if (mainVariantSelect) {
          mainVariantSelect.value = variantId;
          
          // Trigger price update if needed
          if (mainVariantSelect.dispatchEvent) {
            mainVariantSelect.dispatchEvent(new Event('change', { bubbles: true }));
          }
        } else if (mainProductForm) {
          const hiddenVariantInput = mainProductForm.querySelector('input[name="id"]');
          if (hiddenVariantInput) {
            hiddenVariantInput.value = variantId;
            // Update data attribute for tracking
            hiddenVariantInput.setAttribute('data-jarvis-variant-id', variantId);
          }
        }
      });
      
      // Sync main variant to sticky form
      if (mainVariantSelect) {
        mainVariantSelect.addEventListener('change', function(e) {
          if (stickyVariantSelect) {
            stickyVariantSelect.value = e.target.value;
            updateStickyPrice(e.target.value);
          }
        });
      }
      
      // Initial price update
      if (stickyVariantSelect.value) {
        updateStickyPrice(stickyVariantSelect.value);
      }
    }
    
    // Sticky ATC button triggers main form submission (TILE-001)
    const stickyATCButton = stickyATC.querySelector('.js-sticky-atc-submit');
    
    if (stickyATCButton) {
      // Keyboard navigation support (TILE-001 requirement: accessibility)
      stickyATCButton.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          stickyATCButton.click();
        }
      });
      
      // Click handler for form submission
      if (mainProductForm) {
        stickyATCButton.addEventListener('click', function(e) {
          e.preventDefault();
          
          // Update button state (loading)
          stickyATCButton.setAttribute('aria-busy', 'true');
          stickyATCButton.disabled = true;
          
          // Sync variant selection
          if (stickyVariantSelect) {
            const variantId = stickyVariantSelect.value;
            
            if (mainVariantSelect) {
              mainVariantSelect.value = variantId;
              // Trigger change event to update main form price
              mainVariantSelect.dispatchEvent(new Event('change', { bubbles: true }));
            } else if (mainProductForm.querySelector('input[name="id"]')) {
              const hiddenInput = mainProductForm.querySelector('input[name="id"]');
              hiddenInput.value = variantId;
              hiddenInput.setAttribute('data-jarvis-variant-id', variantId);
            }
          }
          
          // Submit main form
          const submitButton = mainProductForm.querySelector('button[type="submit"]');
          if (submitButton) {
            submitButton.click();
          } else {
            mainProductForm.submit();
          }
          
          // Track event (TILE-001: Analytics)
          if (window.dataLayer) {
            window.dataLayer.push({
              'event': 'pdp_sticky_atc_add_to_cart',
              'product_handle': stickyATC.dataset.productHandle || '',
              'location': 'pdp_sticky_atc',
              'variant_id': stickyVariantSelect ? stickyVariantSelect.value : ''
            });
          }
          
          // Reset button state after a delay (in case form submission fails)
          setTimeout(function() {
            stickyATCButton.setAttribute('aria-busy', 'false');
            stickyATCButton.disabled = false;
          }, 2000);
        });
      }
    }
  }
  
  // Initialize sticky ATC after DOM ready (TILE-038)
  window.PerformanceCore.afterLCP(function() {
    initPDPStickyATC();
  });

  // ═══════════════════════════════════════════════════════════════════════════
  // TILE-035: HEADER FLYOUT MENU ENGINE
  // ═══════════════════════════════════════════════════════════════════════════
  
  /**
   * FlyoutController
   * 
   * Unified, ritual-aware, token-driven flyout menu engine for header navigation.
   * Replaces Shopify's default hover menus with a calm, editorial, premium flyout system.
   * 
   * Features:
   * - Hover-open on desktop, tap-open on mobile
   * - Delay-open/close (175ms) for smoother UX
   * - Flyout closes on scroll
   * - ESC key to close
   * - Outside-click to close
   * - Focus trap inside flyout
   * - Performance Core pattern (passive listeners, rAF throttling)
   */
  
  function initFlyoutMenu() {
    const flyoutTriggers = document.querySelectorAll('[data-flyout-trigger]');
    if (flyoutTriggers.length === 0) return;
    
    let activeFlyout = null;
    let openTimeout = null;
    let closeTimeout = null;
    const DELAY_MS = 175; // Delay for smoother UX
    let ticking = false;
    let isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
    
    // Detect mobile breakpoint (768px from CSS)
    function isMobile() {
      return window.innerWidth <= 768;
    }
    
    // Open flyout
    function openFlyout(trigger, flyoutPanel) {
      if (activeFlyout === flyoutPanel) return;
      
      // Close any active flyout first
      if (activeFlyout) {
        closeFlyout(activeFlyout);
      }
      
      // Clear any pending close timeout
      if (closeTimeout) {
        clearTimeout(closeTimeout);
        closeTimeout = null;
      }
      
      // Set active flyout
      activeFlyout = flyoutPanel;
      
      // Update ARIA
      trigger.setAttribute('aria-expanded', 'true');
      flyoutPanel.setAttribute('aria-hidden', 'false');
      
      // Show flyout
      flyoutPanel.classList.add('is-visible');
      const flyoutMenu = flyoutPanel.querySelector('.v-flyout-menu');
      if (flyoutMenu) {
        flyoutMenu.classList.add('is-visible');
      }
      
      // Focus trap: Focus first link in flyout
      const firstLink = flyoutPanel.querySelector('.v-flyout-menu__link');
      if (firstLink) {
        setTimeout(function() {
          firstLink.focus();
        }, DELAY_MS);
      }
      
      // Track event
      if (window.dataLayer) {
        window.dataLayer.push({
          'event': 'flyout_menu_open',
          'menu_title': trigger.textContent.trim()
        });
      }
    }
    
    // Close flyout
    function closeFlyout(flyoutPanel) {
      if (!flyoutPanel) return;
      
      // Clear any pending open/close timeouts
      if (openTimeout) {
        clearTimeout(openTimeout);
        openTimeout = null;
      }
      if (closeTimeout) {
        clearTimeout(closeTimeout);
        closeTimeout = null;
      }
      
      // Find trigger
      const trigger = document.querySelector('[aria-controls="' + flyoutPanel.id + '"]');
      
      // Update ARIA
      if (trigger) {
        trigger.setAttribute('aria-expanded', 'false');
      }
      flyoutPanel.setAttribute('aria-hidden', 'true');
      
      // Hide flyout
      flyoutPanel.classList.remove('is-visible');
      const flyoutMenu = flyoutPanel.querySelector('.v-flyout-menu');
      if (flyoutMenu) {
        flyoutMenu.classList.remove('is-visible');
      }
      
      // Clear active flyout
      if (activeFlyout === flyoutPanel) {
        activeFlyout = null;
      }
    }
    
    // Close all flyouts
    function closeAllFlyouts() {
      const allFlyouts = document.querySelectorAll('[data-flyout-panel].is-visible');
      allFlyouts.forEach(function(flyout) {
        closeFlyout(flyout);
      });
    }
    
    // Handle scroll (close flyout on scroll)
    function handleScroll() {
      if (!ticking) {
        window.requestAnimationFrame(function() {
          if (activeFlyout) {
            closeAllFlyouts();
          }
          ticking = false;
        });
        ticking = true;
      }
    }
    
    // Handle outside click
    function handleClickOutside(e) {
      if (!activeFlyout) return;
      
      const isClickInsideFlyout = activeFlyout.contains(e.target);
      const isClickOnTrigger = e.target.closest('[data-flyout-trigger]');
      
      if (!isClickInsideFlyout && !isClickOnTrigger) {
        closeAllFlyouts();
      }
    }
    
    // Handle ESC key
    function handleEscKey(e) {
      if (e.key === 'Escape' && activeFlyout) {
        e.preventDefault();
        closeAllFlyouts();
        
        // Return focus to trigger
        const trigger = document.querySelector('[aria-expanded="true"][data-flyout-trigger]');
        if (trigger) {
          trigger.focus();
        }
      }
    }
    
    // Handle hover (desktop)
    function handleHover(e) {
      if (isMobile()) return;
      
      const trigger = e.target.closest('[data-flyout-trigger]');
      if (!trigger) return;
      
      const flyoutId = trigger.getAttribute('aria-controls');
      if (!flyoutId) return;
      
      const flyoutPanel = document.getElementById(flyoutId);
      if (!flyoutPanel) return;
      
      // Clear any pending close timeout
      if (closeTimeout) {
        clearTimeout(closeTimeout);
        closeTimeout = null;
      }
      
      // Delay open
      openTimeout = setTimeout(function() {
        openFlyout(trigger, flyoutPanel);
      }, DELAY_MS);
    }
    
    // Handle hover leave (desktop)
    function handleHoverLeave(e) {
      if (isMobile()) return;
      
      const trigger = e.target.closest('[data-flyout-trigger]');
      if (!trigger) return;
      
      const flyoutId = trigger.getAttribute('aria-controls');
      if (!flyoutId) return;
      
      const flyoutPanel = document.getElementById(flyoutId);
      if (!flyoutPanel) return;
      
      // Clear any pending open timeout
      if (openTimeout) {
        clearTimeout(openTimeout);
        openTimeout = null;
      }
      
      // Delay close
      closeTimeout = setTimeout(function() {
        closeFlyout(flyoutPanel);
      }, DELAY_MS);
    }
    
    // Handle click/tap (mobile)
    function handleClick(e) {
      if (!isMobile()) return;
      
      const trigger = e.target.closest('[data-flyout-trigger]');
      if (!trigger) return;
      
      e.preventDefault();
      
      const flyoutId = trigger.getAttribute('aria-controls');
      if (!flyoutId) return;
      
      const flyoutPanel = document.getElementById(flyoutId);
      if (!flyoutPanel) return;
      
      const isExpanded = trigger.getAttribute('aria-expanded') === 'true';
      
      if (isExpanded) {
        // Close
        closeFlyout(flyoutPanel);
      } else {
        // Open
        openFlyout(trigger, flyoutPanel);
      }
    }
    
    // Initialize each trigger (TILE-038)
    flyoutTriggers.forEach(function(trigger) {
      // Hover events (desktop) - Performance Core v2
      window.PerformanceCore.event('mouseenter', handleHover, { target: trigger, passive: true });
      window.PerformanceCore.event('mouseleave', handleHoverLeave, { target: trigger, passive: true });
      
      // Click events (mobile) - Performance Core v2
      window.PerformanceCore.event('click', handleClick, { target: trigger });
      
      // Handle flyout panel hover (desktop) - keep open when hovering flyout (TILE-038)
      const flyoutId = trigger.getAttribute('aria-controls');
      if (flyoutId) {
        const flyoutPanel = document.getElementById(flyoutId);
        if (flyoutPanel) {
          window.PerformanceCore.event('mouseenter', function() {
            if (isMobile()) return;
            // Clear any pending close timeout
            if (closeTimeout) {
              clearTimeout(closeTimeout);
              closeTimeout = null;
            }
          }, { target: flyoutPanel, passive: true });
          
          window.PerformanceCore.event('mouseleave', function() {
            if (isMobile()) return;
            // Delay close
            closeTimeout = setTimeout(function() {
              closeFlyout(flyoutPanel);
            }, DELAY_MS);
          }, { target: flyoutPanel, passive: true });
        }
      }
    });
    
    // Global event listeners (Performance Core v2 pattern - TILE-038)
    window.PerformanceCore.event('scroll', handleScroll, { passive: true, throttle: 'raf' });
    window.PerformanceCore.event('click', handleClickOutside, { target: document });
    window.PerformanceCore.event('keydown', handleEscKey, { target: document });
    
    // Handle window resize (update mobile state) (TILE-038)
    var handleResize = window.PerformanceCore.throttle(function() {
      // Re-evaluate mobile state and close flyouts if switching to mobile
      if (isMobile() && activeFlyout) {
        closeAllFlyouts();
      }
    }, 250);
    window.PerformanceCore.event('resize', handleResize, { passive: true });
  }
  
  // Initialize flyout menu after DOM ready (TILE-038)
  window.PerformanceCore.afterLCP(function() {
    initFlyoutMenu();
  });

  // ═══════════════════════════════════════════════════════════════════════════
  // TILE-036: GLOBAL SEARCH ENGINE (PHASE 1: RITUAL-AWARE PREDICTIVE SEARCH)
  // ═══════════════════════════════════════════════════════════════════════════
  
  /**
   * SearchController (TILE-037: Updated to use unified index)
   * 
   * Unified, ritual-aware, token-driven predictive search engine for Veluna Sleep.
   * Replaces Shopify's default search with a calm, editorial, premium search flyout system.
   * 
   * Features:
   * - Debounced predictive search (200ms)
   * - Ritual-aware ranking (using unified index from TILE-037)
   * - Unified search flyout
   * - Token + Performance Core integration
   * - Full accessibility (ARIA, keyboard navigation, screen reader announcements)
   * - Backend indexing via unified index (TILE-037)
   * 
   * Phase 2 (TILE-037):
   * - Backend search indexing for enhanced performance
   * - Advanced ranking algorithms using unified index
   * - Semantic scoring without external APIs
   */
  
  function initSearchFlyout() {
    const searchFlyout = document.getElementById('v-search-flyout');
    const searchTrigger = document.querySelector('.js-search-trigger');
    if (!searchFlyout || !searchTrigger) return;
    
    // Wait for unified index to be available (TILE-037)
    if (!window.__VELUNA_INDEX__) {
      // Wait for index to load (with timeout fallback)
      let indexWaitCount = 0;
      const maxWaitCount = 50; // 5 seconds max wait
      const checkIndex = function() {
        if (window.__VELUNA_INDEX__ || indexWaitCount >= maxWaitCount) {
          initSearchFlyoutInternal();
        } else {
          indexWaitCount++;
          setTimeout(checkIndex, 100);
        }
      };
      checkIndex();
      return;
    }
    
    initSearchFlyoutInternal();
  }
  
  function initSearchFlyoutInternal() {
    const searchFlyout = document.getElementById('v-search-flyout');
    const searchTrigger = document.querySelector('.js-search-trigger');
    if (!searchFlyout || !searchTrigger) return;
    
    // Use unified index (TILE-037)
    const INDEX = window.__VELUNA_INDEX__;
    if (!INDEX) {
      logger.warn('Veluna Index not available, search will have limited functionality');
      return;
    }
    
    const searchInput = searchFlyout.querySelector('#v-search-flyout-input');
    const searchClear = searchFlyout.querySelector('.js-search-clear');
    const searchResults = searchFlyout.querySelector('#v-search-flyout-results');
    const searchLoading = searchFlyout.querySelector('.js-search-loading');
    const searchEmpty = searchFlyout.querySelector('.js-search-empty');
    const searchResultsContent = searchFlyout.querySelector('.js-search-results');
    const searchRitualsSection = searchFlyout.querySelector('.js-search-rituals');
    const searchRitualsList = searchFlyout.querySelector('.js-search-rituals-list');
    const searchProductsSection = searchFlyout.querySelector('.js-search-products');
    const searchProductsList = searchFlyout.querySelector('.js-search-products-list');
    const searchIngredientsSection = searchFlyout.querySelector('.js-search-ingredients');
    const searchIngredientsList = searchFlyout.querySelector('.js-search-ingredients-list');
    const searchGuidesSection = searchFlyout.querySelector('.js-search-guides');
    const searchGuidesList = searchFlyout.querySelector('.js-search-guides-list');
    const searchCta = searchFlyout.querySelector('.js-search-cta');
    const searchAnnouncements = searchFlyout.querySelector('#v-search-flyout-announcements');
    
    let currentQuery = '';
    let isSearching = false;
    const DEBOUNCE_MS = 200;
    const MIN_QUERY_LENGTH = 2;
    
    // Open search flyout
    function openSearchFlyout() {
      searchFlyout.classList.add('is-visible');
      searchFlyout.setAttribute('aria-hidden', 'false');
      searchTrigger.setAttribute('aria-expanded', 'true');
      
      // Focus search input
      setTimeout(function() {
        searchInput.focus();
      }, 100);
      
      // Track event
      if (window.dataLayer) {
        window.dataLayer.push({
          'event': 'search_open',
          'location': 'header'
        });
      }
    }
    
    // Close search flyout
    function closeSearchFlyout() {
      searchFlyout.classList.remove('is-visible');
      searchFlyout.setAttribute('aria-hidden', 'true');
      searchTrigger.setAttribute('aria-expanded', 'false');
      
      // Clear search input
      searchInput.value = '';
      currentQuery = '';
      
      // Hide all sections
      hideAllSections();
      searchLoading.style.display = 'none';
      searchEmpty.style.display = 'none';
      searchResultsContent.style.display = 'none';
      searchClear.style.display = 'none';
      
      // Clear debounce handled by PerformanceCore.debounce
      
      // Return focus to trigger
      searchTrigger.focus();
    }
    
    // Hide all sections
    function hideAllSections() {
      searchRitualsSection.style.display = 'none';
      searchProductsSection.style.display = 'none';
      searchIngredientsSection.style.display = 'none';
      searchGuidesSection.style.display = 'none';
      searchCta.style.display = 'none';
      searchRitualsList.innerHTML = '';
      searchProductsList.innerHTML = '';
      searchIngredientsList.innerHTML = '';
      searchGuidesList.innerHTML = '';
    }
    
    // Show/hide clear button
    function updateClearButton() {
      if (searchInput.value.length > 0) {
        searchClear.style.display = 'block';
      } else {
        searchClear.style.display = 'none';
      }
    }
    
    // Debounced predictive search
    function performSearch(query) {
      if (!query || query.length < MIN_QUERY_LENGTH) {
        hideAllSections();
        searchLoading.style.display = 'none';
        searchEmpty.style.display = 'none';
        searchResultsContent.style.display = 'none';
        searchCta.style.display = 'none';
        return;
      }
      
      currentQuery = query;
      isSearching = true;
      
      // Show loading state
      searchLoading.style.display = 'block';
      searchEmpty.style.display = 'none';
      searchResultsContent.style.display = 'none';
      hideAllSections();
      
      // Fetch predictive search results from Shopify
      fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=5&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,vendor')
        .then(function(response) {
          if (!response.ok) {
            throw new Error('Search request failed');
          }
          return response.json();
        })
        .then(function(data) {
          if (currentQuery !== query) return; // Ignore stale results
          
          isSearching = false;
          searchLoading.style.display = 'none';
          
          // Organize results using unified index (TILE-037)
          const ritualMatches = findRitualMatches(query);
          const ingredientMatches = findIngredientMatches(query);
          const products = data.resources?.results?.products || [];
          const pages = data.resources?.results?.pages || [];
          const articles = data.resources?.results?.articles || [];
          
          // Filter ingredients from pages using index
          const ingredientPages = pages.filter(function(page) {
            const titleLower = page.title.toLowerCase();
            // Check if page title matches any ingredient name
            return INDEX.ingredients.some(function(ingredient) {
              return titleLower.includes(ingredient.name.toLowerCase());
            }) || titleLower.includes('ingredient') || titleLower.includes('science') || titleLower.includes('the-science');
          });
          
          // Filter guides & stories
          const guidePages = pages.filter(function(page) {
            const titleLower = page.title.toLowerCase();
            return titleLower.includes('guide') || titleLower.includes('story') || titleLower.includes('the-story') || titleLower.includes('ritual');
          });
          const allGuides = guidePages.concat(articles);
          
          const hasResults = ritualMatches.length > 0 || ingredientMatches.length > 0 || products.length > 0 || ingredientPages.length > 0 || allGuides.length > 0;
          
          if (!hasResults) {
            // Show empty state
            searchEmpty.style.display = 'block';
            searchResultsContent.style.display = 'none';
          } else {
            // Show results
            searchEmpty.style.display = 'none';
            searchResultsContent.style.display = 'block';
            
            // Render ritual matches (highest priority)
            if (ritualMatches.length > 0) {
              renderRitualMatches(ritualMatches);
            }
            
            // Render products
            if (products.length > 0) {
              renderProducts(products);
            }
            
            // Render ingredients (from index + pages)
            const allIngredients = ingredientMatches.concat(ingredientPages);
            if (allIngredients.length > 0) {
              renderIngredients(allIngredients);
            }
            
            // Render guides & stories
            if (allGuides.length > 0) {
              renderGuides(allGuides);
            }
            
            // Show CTA
            searchCta.style.display = 'block';
            
            // Announce results to screen reader
            const totalResults = ritualMatches.length + ingredientMatches.length + products.length + ingredientPages.length + allGuides.length;
            announceResults(totalResults);
          }
        })
        .catch(function(error) {
          logger.warn('Search error:', error);
          if (currentQuery === query) {
            isSearching = false;
            searchLoading.style.display = 'none';
            searchEmpty.style.display = 'block';
            searchResultsContent.style.display = 'none';
          }
        });
    }
    
    // Find ritual matches using unified index scoring (TILE-037)
    function findRitualMatches(query) {
      if (!query || query.length < MIN_QUERY_LENGTH) return [];
      
      const matches = [];
      const MIN_SCORE = 0.1; // Minimum score threshold
      
      INDEX.rituals.forEach(function(ritual) {
        // Use index scoring utilities for better ranking
        const keywordScore = INDEX.utilities.scoreKeyword(query, ritual.keywords);
        const painScore = INDEX.utilities.scoreKeyword(query, ritual.pains || []);
        const benefitScore = INDEX.utilities.scoreKeyword(query, ritual.benefits || []);
        
        // Weighted combination (keywords weighted highest)
        const totalScore = (keywordScore * 1.0) + (painScore * 0.8) + (benefitScore * 0.7);
        
        if (totalScore >= MIN_SCORE) {
          matches.push({
            ritual: ritual,
            score: totalScore
          });
        }
      });
      
      // Sort by score (highest first) and return top matches
      matches.sort(function(a, b) {
        return b.score - a.score;
      });
      
      // Return top 4 ritual matches
      return matches.slice(0, 4).map(function(match) {
        return match.ritual;
      });
    }
    
    // Find ingredient matches using unified index (TILE-037)
    function findIngredientMatches(query) {
      if (!query || query.length < MIN_QUERY_LENGTH) return [];
      
      const matches = [];
      const MIN_SCORE = 0.1; // Minimum score threshold
      
      INDEX.ingredients.forEach(function(ingredient) {
        // Use index scoring utilities
        const keywordScore = INDEX.utilities.scoreKeyword(query, ingredient.keywords);
        const effectScore = INDEX.utilities.scoreKeyword(query, ingredient.effects || []);
        const benefitScore = INDEX.utilities.scoreKeyword(query, ingredient.benefits || []);
        
        // Weighted combination
        const totalScore = (keywordScore * 1.0) + (effectScore * 0.8) + (benefitScore * 0.7);
        
        if (totalScore >= MIN_SCORE) {
          matches.push({
            ingredient: ingredient,
            score: totalScore
          });
        }
      });
      
      // Sort by score and return top matches
      matches.sort(function(a, b) {
        return b.score - a.score;
      });
      
      // Return top 5 ingredient matches
      return matches.slice(0, 5).map(function(match) {
        const ing = match.ingredient;
        return {
          name: ing.name,
          description: ing.effects && ing.effects.length > 0 ? ing.effects[0] : ing.benefits && ing.benefits.length > 0 ? ing.benefits[0] : '',
          url: '/pages/ingredients#' + ing.name.toLowerCase().replace(/\s+/g, '-'),
          icon: 'info'
        };
      });
    }
    
    // Render ritual matches (using unified index data)
    function renderRitualMatches(ritualMatches) {
      searchRitualsSection.style.display = 'block';
      searchRitualsList.innerHTML = '';
      
      ritualMatches.forEach(function(ritual) {
        const ritualLink = document.createElement('a');
        ritualLink.href = '/pages/' + ritual.key; // Assuming ritual pages exist
        ritualLink.className = 'v-search-flyout__ritual-item type-body-sm';
        ritualLink.setAttribute('role', 'option');
        ritualLink.setAttribute('data-jarvis-event', 'search_ritual_click');
        ritualLink.setAttribute('data-jarvis-ritual', ritual.key);
        ritualLink.setAttribute('data-jarvis-location', 'search_flyout');
        
        // Create icon HTML (simplified - using inline SVG for now)
        const iconSvg = getIconSvg(ritual.icon, 'sm');
        
        // Use index data for richer display
        const benefit = ritual.benefit || (ritual.benefits && ritual.benefits.length > 0 ? ritual.benefits[0] : '');
        
        ritualLink.innerHTML = `
          <div class="v-search-flyout__ritual-icon">${iconSvg}</div>
          <div class="v-search-flyout__ritual-info">
            <div class="v-search-flyout__ritual-label type-body-sm">${ritual.label}</div>
            <div class="v-search-flyout__ritual-benefit type-body-sm type-body--muted">${benefit}</div>
          </div>
        `;
        
        searchRitualsList.appendChild(ritualLink);
      });
    }
    
    // Render products
    function renderProducts(products) {
      searchProductsSection.style.display = 'block';
      searchProductsList.innerHTML = '';
      
      products.forEach(function(product) {
        // Use Liquid render pattern via innerHTML (simplified for JS)
        // In production, you'd want to render via AJAX to get full Liquid rendering
        const productCard = document.createElement('div');
        productCard.innerHTML = `
          <a href="${product.url}" class="v-product-card-mini" role="option" aria-label="${product.title}" data-jarvis-event="search_product_click" data-jarvis-product-handle="${product.handle}" data-jarvis-location="search_flyout">
            ${product.image ? `<div class="v-product-card-mini__image"><img src="${product.image}" alt="${product.title}" width="60" height="60" loading="lazy" class="v-product-card-mini__image-element"></div>` : ''}
            <div class="v-product-card-mini__info">
              <h3 class="v-product-card-mini__title type-body-sm">${product.title}</h3>
              <div class="v-product-card-mini__price">${product.price ? formatMoney(product.price) : ''}</div>
            </div>
          </a>
        `;
        searchProductsList.appendChild(productCard.firstElementChild);
      });
    }
    
    // Render ingredients (from index + pages)
    function renderIngredients(allIngredients) {
      searchIngredientsSection.style.display = 'block';
      searchIngredientsList.innerHTML = '';
      
      allIngredients.forEach(function(item) {
        // Handle both index items (with name, description, url) and page items (with title, url)
        const ingredientLink = document.createElement('a');
        ingredientLink.href = item.url || (typeof item === 'string' ? item : item.url);
        ingredientLink.className = 'v-search-flyout__ingredient-item type-body-sm';
        ingredientLink.setAttribute('role', 'option');
        ingredientLink.setAttribute('data-jarvis-event', 'search_ingredient_click');
        ingredientLink.setAttribute('data-jarvis-location', 'search_flyout');
        
        if (item.name) {
          // Index item
          const iconSvg = getIconSvg(item.icon || 'info', 'sm');
          ingredientLink.innerHTML = `
            <div class="v-search-flyout__ingredient-icon">${iconSvg}</div>
            <div class="v-search-flyout__ingredient-info">
              <div class="v-search-flyout__ingredient-label type-body-sm">${item.name}</div>
              ${item.description ? `<div class="v-search-flyout__ingredient-description type-body-sm type-body--muted">${item.description}</div>` : ''}
            </div>
          `;
        } else {
          // Page item
          ingredientLink.textContent = item.title || item;
        }
        
        searchIngredientsList.appendChild(ingredientLink);
      });
    }
    
    // Render guides & stories
    function renderGuides(guides) {
      searchGuidesSection.style.display = 'block';
      searchGuidesList.innerHTML = '';
      
      guides.forEach(function(guide) {
        const guideLink = document.createElement('a');
        guideLink.href = guide.url;
        guideLink.className = 'v-search-flyout__guide-item type-body-sm';
        guideLink.setAttribute('role', 'option');
        guideLink.setAttribute('data-jarvis-event', 'search_guide_click');
        guideLink.setAttribute('data-jarvis-location', 'search_flyout');
        guideLink.textContent = guide.title;
        
        searchGuidesList.appendChild(guideLink);
      });
    }
    
    // Announce results to screen reader
    function announceResults(count) {
      if (searchAnnouncements) {
        searchAnnouncements.textContent = count + ' result' + (count !== 1 ? 's' : '') + ' found';
      }
    }
    
    // Helper: Get icon SVG (simplified - would use v-icon component in production)
    function getIconSvg(iconName, size) {
      const icons = {
        moon: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="none"/></svg>',
        sparkle: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 2L13.5 8.5L20 10L13.5 11.5L12 18L10.5 11.5L4 10L10.5 8.5L12 2Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="none"/></svg>',
        star: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="none"/></svg>',
        'arrow-down': '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 5V19M12 19L5 12M12 19L19 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>'
      };
      return icons[iconName] || icons.moon;
    }
    
    // Helper: Format money (simplified)
    function formatMoney(cents) {
      return '$' + (cents / 100).toFixed(2);
    }
    
    // Debounced search handler (TILE-038)
    var debouncedSearch = window.PerformanceCore.debounce(function(query) {
      performSearch(query);
    }, DEBOUNCE_MS);
    
    // Event listeners
    searchTrigger.addEventListener('click', function(e) {
      e.preventDefault();
      openSearchFlyout();
    });
    
    window.PerformanceCore.event('input', function(e) {
      const query = e.target.value.trim();
      updateClearButton();
      debouncedSearch(query);
    }, { target: searchInput, passive: true });
    
    searchClear.addEventListener('click', function() {
      searchInput.value = '';
      currentQuery = '';
      updateClearButton();
      hideAllSections();
      searchLoading.style.display = 'none';
      searchEmpty.style.display = 'none';
      searchResultsContent.style.display = 'none';
      searchInput.focus();
    });
    
    // ESC key to close (TILE-038)
    window.PerformanceCore.event('keydown', function(e) {
      if (e.key === 'Escape' && searchFlyout.classList.contains('is-visible')) {
        e.preventDefault();
        closeSearchFlyout();
      }
    }, { target: document });
    
    // Click outside to close (TILE-038)
    window.PerformanceCore.event('click', function(e) {
      if (e.target === searchFlyout || e.target.classList.contains('v-search-flyout__backdrop')) {
        closeSearchFlyout();
      }
    }, { target: searchFlyout });
    
    // Focus trap (simplified - would need more robust implementation)
    searchInput.addEventListener('keydown', function(e) {
      if (e.key === 'Tab' && e.shiftKey === false) {
        const focusableElements = searchFlyout.querySelectorAll('a, button, input');
        const lastElement = focusableElements[focusableElements.length - 1];
        if (e.target === lastElement) {
          e.preventDefault();
          focusableElements[0].focus();
        }
      }
    });
  }
  
  // Initialize search flyout after DOM ready (TILE-038)
  window.PerformanceCore.afterLCP(function() {
    initSearchFlyout();
  });

  // ═══════════════════════════════════════════════════════════════════════════
  // TILE-040: RITUAL QUIZ ENGINE (WAVE 1: SHELL, ROUTING & UI SKELETON)
  // ═══════════════════════════════════════════════════════════════════════════
  
  /**
   * QuizController (Wave 2: Logic Engine)
   * 
   * Unified, ritual-aware quiz controller with full intelligent logic layer.
   * Manages question bank, branching rules, ritual scoring, state machine, and persistence.
   * 
   * Wave 2 Features:
   * - Question bank loader (from quiz-questions.js)
   * - Branching logic engine (different questions based on answers)
   * - Ritual scoring engine (mc, dr, ss, cr weights)
   * - State machine v1 (intro → question → transition → results)
   * - Persistence (localStorage save & restore)
   * - Results object generation (dominant ritual, secondary ritual, insights)
   * 
   * Features:
   * - Performance Core v2 integration (afterLCP)
   * - Automatic question path calculation
   * - Transparent scoring (ritual weights visible)
   * - Save/restore on every answer
   * 
   * Future Tiles:
   * - UI rendering (Wave 3+)
   * - Email capture (Wave 3+)
   * - Result screens (Wave 3+)
   */
  
  function initQuizController() {
    const quizRoot = document.querySelector('[data-quiz-root]');
    if (!quizRoot) return;
    
    // ═══════════════════════════════════════════════════════════════════════════
    // TILE-041: QUESTION BANK LOADER
    // ═══════════════════════════════════════════════════════════════════════════
    
    // Load question bank from quiz-questions.js
    const questions = window.__QUIZ_QUESTIONS__ || [];
    const questionsMap = window.__QUIZ_QUESTIONS_MAP__ || {};
    
    if (!questions || questions.length === 0) {
      logger.warn('QuizController: No questions found. Ensure quiz-questions.js is loaded.');
      return;
    }
    
    // ═══════════════════════════════════════════════════════════════════════════
    // TILE-041: STATE MACHINE v1
    // ═══════════════════════════════════════════════════════════════════════════
    
    // Quiz states: 'intro', 'question', 'transition', 'results'
    let quizState = 'intro';
    
    // ═══════════════════════════════════════════════════════════════════════════
    // TILE-041: RITUAL SCORING ENGINE
    // ═══════════════════════════════════════════════════════════════════════════
    
    // Ritual scores: mc (Mind Calm), dr (Deep Restore), ss (Sacred Soothe), cr (Circadian Reset)
    let ritualScores = { mc: 0, dr: 0, ss: 0, cr: 0 };
    
    // ═══════════════════════════════════════════════════════════════════════════
    // TILE-041: QUIZ PATH & ANSWERS
    // ═══════════════════════════════════════════════════════════════════════════
    
    // Current question path (array of question IDs)
    let questionPath = [];
    
    // Current question index in path
    let currentQuestionIndex = 0;
    
    // Answers object: { questionId: { value, weights } }
    let answers = {};
    
    // ═══════════════════════════════════════════════════════════════════════════
    // TILE-041: PERSISTENCE (localStorage)
    // ═══════════════════════════════════════════════════════════════════════════
    
    const STORAGE_KEY = 'veluna_quiz_progress';
    
    // Try to restore from localStorage
    function restoreProgress() {
      try {
        const saved = localStorage.getItem(STORAGE_KEY);
        if (saved) {
          const data = JSON.parse(saved);
          if (data.ritualScores) ritualScores = data.ritualScores;
          if (data.questionPath) questionPath = data.questionPath;
          if (data.currentQuestionIndex !== undefined) currentQuestionIndex = data.currentQuestionIndex;
          if (data.answers) answers = data.answers;
          if (data.quizState) quizState = data.quizState;
          return true;
        }
      } catch (e) {
        logger.warn('QuizController: Failed to restore progress:', e);
      }
      return false;
    }
    
    // Save progress to localStorage
    function saveProgress() {
      try {
        const data = {
          ritualScores: ritualScores,
          questionPath: questionPath,
          currentQuestionIndex: currentQuestionIndex,
          answers: answers,
          quizState: quizState,
          timestamp: Date.now()
        };
        localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
      } catch (e) {
        logger.warn('QuizController: Failed to save progress:', e);
      }
    }
    
    // Clear saved progress
    function clearProgress() {
      try {
        localStorage.removeItem(STORAGE_KEY);
      } catch (e) {
        logger.warn('QuizController: Failed to clear progress:', e);
      }
    }
    
    // ═══════════════════════════════════════════════════════════════════════════
    // TILE-041: BRANCHING LOGIC ENGINE
    // ═══════════════════════════════════════════════════════════════════════════
    
    /**
     * Get next question based on current question and answer
     * @param {string} currentQuestionId - Current question ID
     * @param {string} answerValue - Selected answer value
     * @returns {string|null} - Next question ID or null if end of quiz
     */
    function getNextQuestion(currentQuestionId, answerValue) {
      const currentQuestion = questionsMap[currentQuestionId];
      if (!currentQuestion) return null;
      
      // If question has custom next rule, check if it's answer-specific
      if (currentQuestion.next) {
        // If next is a function or conditional, evaluate it
        // For now, assume next is either a question ID or null
        if (typeof currentQuestion.next === 'string') {
          return currentQuestion.next;
        }
      }
      
      // Branching logic: Check if answer value determines next question
      // For entry question, branch based on answer value
      if (currentQuestionId === 'sleep_quality') {
        if (answerValue === 'racing_thoughts') return 'stress_level';
        if (answerValue === 'unrested') return 'physical_restlessness';
        if (answerValue === 'schedule_off') return 'schedule_type';
        if (answerValue === 'enhance') return 'ritual_focus';
      }
      
      // Default: sequential (next question in array)
      const currentIndex = questions.findIndex(function(q) { return q.id === currentQuestionId; });
      if (currentIndex >= 0 && currentIndex < questions.length - 1) {
        return questions[currentIndex + 1].id;
      }
      
      // End of quiz
      return null;
    }
    
    /**
     * Initialize question path (build path based on branching rules)
     * Starts with first question, then builds path as user answers
     */
    function initializeQuestionPath() {
      if (questionPath.length === 0) {
        // Start with first question
        questionPath = ['sleep_quality'];
      }
    }
    
    /**
     * Add next question to path based on current answer
     * @param {string} currentQuestionId - Current question ID
     * @param {string} answerValue - Selected answer value
     */
    function addToPath(currentQuestionId, answerValue) {
      const nextQuestionId = getNextQuestion(currentQuestionId, answerValue);
      if (nextQuestionId) {
        // Remove any questions after current in path (if going back)
        questionPath = questionPath.slice(0, currentQuestionIndex + 1);
        // Add next question
        questionPath.push(nextQuestionId);
      }
    }
    
    // ═══════════════════════════════════════════════════════════════════════════
    // TILE-043: RITUAL CONTEXT & RATIONALE TEMPLATES
    // ═══════════════════════════════════════════════════════════════════════════
    
    /**
     * Ritual Context & Rationale Templates
     * Contains ritual metadata, pains, benefits, keywords, and rationale text templates
     */
    const RITUAL_CONTEXT = {
      mc: {
        name: 'Mind Calm Ritual',
        shortName: 'Mind Calm',
        pains: ['racing thoughts', 'stress at night', 'difficulty quieting mind', 'overthinking', 'mental restlessness', 'decision fatigue'],
        benefits: ['calm mind', 'peaceful sleep', 'mental clarity', 'stress relief', 'relaxation'],
        keywords: ['stress', 'racing thoughts', 'overthinking', 'mental', 'calm', 'peaceful'],
        rationaleTemplates: {
          short: 'Your answers strongly point toward Mind Calm Ritual.',
          long: 'Because you experience mental overstimulation at night, racing thoughts that keep you awake, and difficulty winding down after a busy day, your body knows you need calm support. Mind Calm Ritual is designed to quiet your mind and help you transition peacefully into restful sleep.'
        }
      },
      dr: {
        name: 'Deep Restore Ritual',
        shortName: 'Deep Restore',
        pains: ['physical restlessness', 'waking unrested', 'muscle tension', 'physical recovery needs', 'body aches', 'lack of deep sleep'],
        benefits: ['deep restoration', 'physical recovery', 'muscle restoration', 'rested awakening', 'body restoration'],
        keywords: ['physical', 'restlessness', 'recovery', 'muscle', 'deep sleep', 'restored'],
        rationaleTemplates: {
          short: 'Your answers point toward Deep Restore Ritual.',
          long: 'Because you wake up feeling unrested, experience physical restlessness or tension at night, and prioritize deep physical recovery, your body knows you need restorative support. Deep Restore Ritual is designed to support your body\'s natural restoration process and help you wake up feeling truly rested.'
        }
      },
      ss: {
        name: 'Sacred Soothe Ritual',
        shortName: 'Sacred Soothe',
        pains: ['lack of ritual', 'need for self-care', 'desire for transformation', 'beauty sleep needs', 'wellness focus'],
        benefits: ['beautiful ritual', 'transformation', 'self-care', 'beauty sleep', 'wellness journey', 'sacred practice'],
        keywords: ['beauty', 'transformation', 'self-care', 'ritual', 'wellness', 'sacred', 'soothing'],
        rationaleTemplates: {
          short: 'Your answers align with Sacred Soothe Ritual.',
          long: 'Because you value beautiful, transformative rituals, prioritize self-care and wellness, and want to enhance your sleep journey with intentional practice, your body knows you need sacred soothing. Sacred Soothe Ritual is designed to elevate your sleep routine into a meaningful ritual that supports both rest and transformation.'
        }
      },
      cr: {
        name: 'Circadian Reset Ritual',
        shortName: 'Circadian Reset',
        pains: ['irregular schedule', 'jet lag', 'shift work', 'sleep schedule issues', 'timing problems', 'circadian disruption'],
        benefits: ['better timing', 'circadian alignment', 'schedule support', 'rhythm restoration', 'timing mastery'],
        keywords: ['timing', 'schedule', 'circadian', 'jet lag', 'shift work', 'rhythm', 'timing'],
        rationaleTemplates: {
          short: 'Your answers suggest Circadian Reset Ritual.',
          long: 'Because your sleep schedule feels off, you travel frequently or work irregular hours, and you need help aligning your body\'s natural rhythm, your body knows you need timing support. Circadian Reset Ritual is designed to help your body find its natural rhythm and maintain consistent, restorative sleep regardless of your schedule.'
        }
      }
    };
    
    /**
     * Tie-breaking priority order (deterministic)
     * Used when scores are tied: MC > DR > SS > CR
     */
    const RITUAL_PRIORITY = ['mc', 'dr', 'ss', 'cr'];
    
    // ═══════════════════════════════════════════════════════════════════════════
    // TILE-043: RITUAL RESULT ENGINE
    // ═══════════════════════════════════════════════════════════════════════════
    
    /**
     * TILE-043: Normalize scores to 0-1 range
     * @param {Object} scores - Raw ritual scores { mc: number, dr: number, ss: number, cr: number }
     * @returns {Object} Normalized scores { mc: number, dr: number, ss: number, cr: number }
     */
    function normalizeScores(scores) {
      if (!scores || typeof scores !== 'object') {
        return { mc: 0, dr: 0, ss: 0, cr: 0 };
      }
      
      // Find maximum score
      const maxScore = Math.max(
        scores.mc || 0,
        scores.dr || 0,
        scores.ss || 0,
        scores.cr || 0,
        1 // Prevent division by zero
      );
      
      // Normalize each score (0-1 range)
      const normalized = {
        mc: maxScore > 0 ? (scores.mc || 0) / maxScore : 0,
        dr: maxScore > 0 ? (scores.dr || 0) / maxScore : 0,
        ss: maxScore > 0 ? (scores.ss || 0) / maxScore : 0,
        cr: maxScore > 0 ? (scores.cr || 0) / maxScore : 0
      };
      
      return normalized;
    }
    
    /**
     * TILE-043: Compute final ritual assignment with tie-breaking
     * @param {Object} scores - Raw ritual scores
     * @returns {string} Ritual code ('mc', 'dr', 'ss', or 'cr')
     */
    function computeFinalRitual(scores) {
      if (!scores || typeof scores !== 'object') {
        return 'mc'; // Default fallback
      }
      
      // Find highest score
      let maxScore = -Infinity;
      let candidates = [];
      
      for (var i = 0; i < RITUAL_PRIORITY.length; i++) {
        const ritualCode = RITUAL_PRIORITY[i];
        const score = scores[ritualCode] || 0;
        
        if (score > maxScore) {
          maxScore = score;
          candidates = [ritualCode];
        } else if (score === maxScore) {
          candidates.push(ritualCode);
        }
      }
      
      // If tie, use priority order (first in RITUAL_PRIORITY wins)
      if (candidates.length > 0) {
        return candidates[0]; // First candidate is highest priority
      }
      
      // Fallback to default
      return 'mc';
    }
    
    /**
     * TILE-043: Get secondary ritual match
     * @param {Object} scores - Raw ritual scores
     * @param {string} primaryRitual - Primary ritual code
     * @returns {Object|null} Secondary ritual object { ritual: string, ritualName: string, delta: number } or null
     */
    function getSecondaryMatch(scores, primaryRitual) {
      if (!scores || !primaryRitual) return null;
      
      // Create score array excluding primary
      const scoreArray = [];
      for (var i = 0; i < RITUAL_PRIORITY.length; i++) {
        const ritualCode = RITUAL_PRIORITY[i];
        if (ritualCode !== primaryRitual) {
          scoreArray.push({
            code: ritualCode,
            score: scores[ritualCode] || 0
          });
        }
      }
      
      // Sort by score descending
      scoreArray.sort(function(a, b) {
        if (b.score !== a.score) {
          return b.score - a.score;
        }
        // If tied, use priority order
        return RITUAL_PRIORITY.indexOf(a.code) - RITUAL_PRIORITY.indexOf(b.code);
      });
      
      if (scoreArray.length === 0 || scoreArray[0].score === 0) {
        return null;
      }
      
      const secondary = scoreArray[0];
      const primaryScore = scores[primaryRitual] || 0;
      const delta = primaryScore > 0 ? (primaryScore - secondary.score) / primaryScore : 1;
      
      return {
        ritual: secondary.code,
        ritualName: RITUAL_CONTEXT[secondary.code] ? RITUAL_CONTEXT[secondary.code].shortName : secondary.code,
        delta: Math.round(delta * 100) / 100 // Round to 2 decimals
      };
    }
    
    /**
     * TILE-043: Compute confidence level (0.0-1.0)
     * @param {Object} scores - Raw ritual scores
     * @param {Object} normalized - Normalized scores (0-1 range)
     * @param {string} primaryRitual - Primary ritual code
     * @returns {number} Confidence level (0.0-1.0)
     */
    function computeConfidence(scores, normalized, primaryRitual) {
      if (!scores || !normalized || !primaryRitual) {
        return 0.5; // Default moderate confidence
      }
      
      const primaryScore = normalized[primaryRitual] || 0;
      
      // Find second highest normalized score
      let secondHighest = 0;
      for (var i = 0; i < RITUAL_PRIORITY.length; i++) {
        const ritualCode = RITUAL_PRIORITY[i];
        if (ritualCode !== primaryRitual) {
          const score = normalized[ritualCode] || 0;
          if (score > secondHighest) {
            secondHighest = score;
          }
        }
      }
      
      // Confidence based on gap between primary and secondary
      // Larger gap = higher confidence
      const gap = primaryScore - secondHighest;
      
      // Base confidence: primary score itself (0-1)
      // Bonus confidence: gap between primary and secondary (0-0.3 max)
      const baseConfidence = primaryScore * 0.7; // Primary score contributes 70%
      const gapBonus = Math.min(gap * 0.3, 0.3); // Gap contributes up to 30%
      const confidence = Math.min(baseConfidence + gapBonus, 1.0);
      
      // Ensure minimum confidence if primary score is significant
      if (primaryScore >= 0.5 && confidence < 0.6) {
        return 0.6;
      }
      
      return Math.round(confidence * 100) / 100; // Round to 2 decimals
    }
    
    /**
     * TILE-043: Generate rationale text for ritual assignment
     * @param {string} ritualKey - Ritual code ('mc', 'dr', 'ss', or 'cr')
     * @param {Object} scores - Raw ritual scores
     * @returns {string} Long-form rationale text
     */
    function generateRationale(ritualKey, scores) {
      if (!ritualKey || !RITUAL_CONTEXT[ritualKey]) {
        return 'Your answers indicate a personalized ritual match.';
      }
      
      const context = RITUAL_CONTEXT[ritualKey];
      return context.rationaleTemplates.long || context.rationaleTemplates.short || 'Your answers point toward this ritual.';
    }
    
    /**
     * TILE-043: Build complete result payload
     * @param {Object} scores - Raw ritual scores
     * @returns {Object} Complete result payload object
     */
    function buildResultPayload(scores) {
      if (!scores || typeof scores !== 'object') {
        // Error fallback
        return {
          ritual: 'mc',
          ritualName: 'Mind Calm',
          confidence: 0.5,
          rationale: 'Unable to compute results. Please try again.',
          secondary: null,
          scores: { mc: 0, dr: 0, ss: 0, cr: 0 },
          normalized: { mc: 0, dr: 0, ss: 0, cr: 0 }
        };
      }
      
      // Normalize scores
      const normalized = normalizeScores(scores);
      
      // Compute final ritual
      const ritual = computeFinalRitual(scores);
      
      // Get ritual context
      const context = RITUAL_CONTEXT[ritual] || RITUAL_CONTEXT.mc;
      
      // Compute confidence
      const confidence = computeConfidence(scores, normalized, ritual);
      
      // Generate rationale
      const rationale = generateRationale(ritual, scores);
      
      // Get secondary match
      const secondary = getSecondaryMatch(scores, ritual);
      
      // Build payload
      const payload = {
        ritual: ritual,
        ritualName: context.shortName || context.name,
        confidence: confidence,
        rationale: rationale,
        secondary: secondary,
        scores: {
          mc: scores.mc || 0,
          dr: scores.dr || 0,
          ss: scores.ss || 0,
          cr: scores.cr || 0
        },
        normalized: normalized,
        // Additional metadata for future tiles
        context: {
          fullName: context.name,
          pains: context.pains,
          benefits: context.benefits,
          keywords: context.keywords
        }
      };
      
      return payload;
    }
    
    // ═══════════════════════════════════════════════════════════════════════════
    // TILE-041/043: RESULTS OBJECT GENERATION (Legacy + TILE-043)
    // ═══════════════════════════════════════════════════════════════════════════
    
    /**
     * Compute results object with dominant ritual, secondary ritual, insights
     * @returns {Object} Results object (TILE-043 format)
     */
    function computeResults() {
      // TILE-043: Use new Result Engine to build payload
      const payload = buildResultPayload(ritualScores);
      
      // Add additional metadata for backward compatibility and future use
      const results = {
        // TILE-043: New format
        ritual: payload.ritual,
        ritualName: payload.ritualName,
        confidence: payload.confidence,
        rationale: payload.rationale,
        secondary: payload.secondary,
        scores: payload.scores,
        normalized: payload.normalized,
        context: payload.context,
        
        // Legacy format (for backward compatibility)
        dominantRitual: {
          code: payload.ritual,
          name: payload.context.fullName,
          score: payload.scores[payload.ritual]
        },
        secondaryRitual: payload.secondary ? {
          code: payload.secondary.ritual,
          name: payload.secondary.ritualName,
          score: payload.scores[payload.secondary.ritual],
          delta: payload.secondary.delta
        } : null,
        allScores: payload.scores,
        summaryInsights: [payload.rationale], // Use rationale as insight
        recommendedProducts: getRecommendedProducts(payload.ritual),
        answers: answers,
        questionPath: questionPath
      };
      
      return results;
    }
    
    /**
     * Get recommended products based on ritual code
     * @param {string} ritualCode - Ritual code
     * @returns {Array} Array of product handles
     */
    function getRecommendedProducts(ritualCode) {
      // This will be expanded in future tiles with actual product matching
      const productMap = {
        mc: 'mind-calm-ritual-set',
        dr: 'deep-restore-ritual-set',
        ss: 'sacred-soothe-ritual-set',
        cr: 'circadian-reset-ritual-set'
      };
      
      return [productMap[ritualCode] || 'full-ritual-set'];
    }
    
    // ═══════════════════════════════════════════════════════════════════════════
    // UI ELEMENTS
    // ═══════════════════════════════════════════════════════════════════════════
    
    const introCta = quizRoot.querySelector('[data-quiz-start]');
    const progressContainer = quizRoot.querySelector('[data-quiz-progress-container]');
    const questionContainer = quizRoot.querySelector('[data-quiz-question-container]');
    const controlsContainer = quizRoot.querySelector('[data-quiz-controls-container]');
    const helperContainer = quizRoot.querySelector('[data-quiz-helper-container]');
    const resultsContainer = quizRoot.querySelector('[data-quiz-results-container]'); // Legacy placeholder
    const resultPanel = quizRoot.querySelector('[data-quiz-result-panel]'); // TILE-044: New result UI panel
    const emailBlock = quizRoot.querySelector('[data-quiz-email-block]'); // TILE-045: Email capture block
    
    const progressBar = quizRoot.querySelector('[data-quiz-progress-bar]');
    const progressCurrent = quizRoot.querySelector('[data-quiz-progress-current]');
    const progressTotal = quizRoot.querySelector('[data-quiz-progress-total]');
    
    const questionTitle = quizRoot.querySelector('[data-quiz-question-title]');
    const questionBody = quizRoot.querySelector('[data-quiz-question-body]');
    const questionStep = quizRoot.querySelector('[data-quiz-question-step]');
    const questionChoices = quizRoot.querySelector('[data-quiz-question-choices]');
    
    const backBtn = quizRoot.querySelector('[data-quiz-back]');
    const nextBtn = quizRoot.querySelector('[data-quiz-next]');
    const skipBtn = quizRoot.querySelector('[data-quiz-skip]');
    const exitBtn = quizRoot.querySelector('[data-quiz-exit]');
    
    // ═══════════════════════════════════════════════════════════════════════════
    // UI UPDATE FUNCTIONS
    // ═══════════════════════════════════════════════════════════════════════════
    
    /**
     * Update progress bar based on current question index
     */
    function updateProgress() {
      const totalQuestions = questionPath.length;
      const currentQuestionNum = currentQuestionIndex + 1;
      const percent = (currentQuestionNum / totalQuestions) * 100;
      
      if (progressBar) {
        progressBar.style.width = percent + '%';
      }
      
      if (progressCurrent) {
        progressCurrent.textContent = currentQuestionNum;
      }
      
      if (progressTotal) {
        progressTotal.textContent = totalQuestions;
      }
      
      // Update ARIA
      if (quizRoot.querySelector('[data-quiz-progress]')) {
        quizRoot.querySelector('[data-quiz-progress]').setAttribute('aria-valuenow', currentQuestionNum);
        quizRoot.querySelector('[data-quiz-progress]').setAttribute('aria-valuemax', totalQuestions);
      }
    }
    
    /**
     * Update question view with actual question data
     * @param {string} questionId - Question ID to display
     */
    function updateQuestionView(questionId) {
      const question = questionsMap[questionId];
      if (!question) {
        logger.warn('QuizController: Question not found:', questionId);
        return;
      }
      
      // Update question text
      if (questionTitle) {
        questionTitle.textContent = question.text;
      }
      
      // Clear question body (not used in Wave 2)
      if (questionBody) {
        questionBody.textContent = '';
      }
      
      // Update step number
      if (questionStep) {
        questionStep.textContent = currentQuestionIndex + 1;
      }
      
      // Render answer choices
      if (questionChoices) {
        renderAnswerChoices(question, questionId);
      }
    }
    
    /**
     * TILE-042: Render answer choices for a question (supports single, multi, scale)
     * @param {Object} question - Question object
     * @param {string} questionId - Question ID
     */
    function renderAnswerChoices(question, questionId) {
      if (!questionChoices) return;
      
      // Clear existing choices
      questionChoices.innerHTML = '';
      
      // Determine question type (default to 'single')
      const questionType = question.type || 'single';
      questionChoices.setAttribute('data-quiz-answer-type', questionType);
      
      // Get current answer(s) (if any)
      const currentAnswer = answers[questionId];
      let selectedValues = [];
      if (currentAnswer) {
        if (questionType === 'multi' && Array.isArray(currentAnswer.value)) {
          selectedValues = currentAnswer.value;
        } else if (currentAnswer.value) {
          selectedValues = [currentAnswer.value];
        }
      }
      
      // Render based on question type
      if (questionType === 'scale') {
        renderScaleAnswer(question, questionId, currentAnswer);
      } else if (questionType === 'multi') {
        renderMultiAnswer(question, questionId, selectedValues);
      } else {
        // Default: single-select
        renderSingleAnswer(question, questionId, selectedValues);
      }
    }
    
    /**
     * TILE-042: Render single-select answer choices (radio-like)
     * @param {Object} question - Question object
     * @param {string} questionId - Question ID
     * @param {Array} selectedValues - Array of selected answer values
     */
    function renderSingleAnswer(question, questionId, selectedValues) {
      questionChoices.setAttribute('role', 'radiogroup');
      questionChoices.setAttribute('aria-labelledby', 'quiz-question-title');
      questionChoices.className = 'v-quiz-answers v-quiz-answers--single';
      
      question.answers.forEach(function(answer, index) {
        const choiceId = 'quiz-choice-' + questionId + '-' + index;
        const isSelected = selectedValues.indexOf(answer.value) !== -1;
        
        const choiceEl = document.createElement('button');
        choiceEl.type = 'button';
        choiceEl.className = 'v-quiz-answer v-quiz-answer--single' + (isSelected ? ' v-quiz-answer--selected' : '');
        choiceEl.id = choiceId;
        choiceEl.setAttribute('role', 'radio');
        choiceEl.setAttribute('aria-checked', isSelected ? 'true' : 'false');
        choiceEl.setAttribute('data-quiz-answer', 'true');
        choiceEl.setAttribute('data-question-id', questionId);
        choiceEl.setAttribute('data-answer-value', answer.value);
        choiceEl.setAttribute('data-answer-type', 'single');
        choiceEl.setAttribute('tabindex', isSelected ? '0' : '-1');
        
        // Answer content
        const answerContent = document.createElement('span');
        answerContent.className = 'v-quiz-answer__label type-body';
        answerContent.textContent = answer.label;
        choiceEl.appendChild(answerContent);
        
        // Selected indicator (check icon)
        if (isSelected) {
          const checkIcon = document.createElement('span');
          checkIcon.className = 'v-quiz-answer__check';
          checkIcon.setAttribute('aria-hidden', 'true');
          checkIcon.innerHTML = '✓'; // Simple check mark, can use v-icon later
          choiceEl.appendChild(checkIcon);
        }
        
        // Add click handler
        window.PerformanceCore.event('click', function() {
          selectAnswer(questionId, answer, 'single');
        }, { target: choiceEl });
        
        // Add keyboard handler
        window.PerformanceCore.event('keydown', function(e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            selectAnswer(questionId, answer, 'single');
          }
        }, { target: choiceEl });
        
        questionChoices.appendChild(choiceEl);
      });
      
      // Make first unselected answer or first selected answer focusable
      const firstFocusable = questionChoices.querySelector('[aria-checked="true"]') || questionChoices.querySelector('.v-quiz-answer');
      if (firstFocusable) {
        firstFocusable.setAttribute('tabindex', '0');
      }
    }
    
    /**
     * TILE-042: Render multi-select answer choices (checkbox-like)
     * @param {Object} question - Question object
     * @param {string} questionId - Question ID
     * @param {Array} selectedValues - Array of selected answer values
     */
    function renderMultiAnswer(question, questionId, selectedValues) {
      questionChoices.setAttribute('role', 'group');
      questionChoices.setAttribute('aria-labelledby', 'quiz-question-title');
      questionChoices.className = 'v-quiz-answers v-quiz-answers--multi';
      
      question.answers.forEach(function(answer, index) {
        const choiceId = 'quiz-choice-' + questionId + '-' + index;
        const isSelected = selectedValues.indexOf(answer.value) !== -1;
        
        const choiceEl = document.createElement('button');
        choiceEl.type = 'button';
        choiceEl.className = 'v-quiz-answer v-quiz-answer--multi' + (isSelected ? ' v-quiz-answer--selected' : '');
        choiceEl.id = choiceId;
        choiceEl.setAttribute('role', 'checkbox');
        choiceEl.setAttribute('aria-checked', isSelected ? 'true' : 'false');
        choiceEl.setAttribute('data-quiz-answer', 'true');
        choiceEl.setAttribute('data-question-id', questionId);
        choiceEl.setAttribute('data-answer-value', answer.value);
        choiceEl.setAttribute('data-answer-type', 'multi');
        choiceEl.setAttribute('tabindex', '0');
        
        // Answer content
        const answerContent = document.createElement('span');
        answerContent.className = 'v-quiz-answer__label type-body';
        answerContent.textContent = answer.label;
        choiceEl.appendChild(answerContent);
        
        // Selected indicator (check icon)
        const checkIcon = document.createElement('span');
        checkIcon.className = 'v-quiz-answer__check';
        checkIcon.setAttribute('aria-hidden', 'true');
        checkIcon.innerHTML = '✓';
        checkIcon.style.display = isSelected ? 'block' : 'none';
        choiceEl.appendChild(checkIcon);
        
        // Add click handler (toggles selection)
        window.PerformanceCore.event('click', function() {
          toggleAnswer(questionId, answer, 'multi');
        }, { target: choiceEl });
        
        // Add keyboard handler
        window.PerformanceCore.event('keydown', function(e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            toggleAnswer(questionId, answer, 'multi');
          }
        }, { target: choiceEl });
        
        questionChoices.appendChild(choiceEl);
      });
    }
    
    /**
     * TILE-042: Render scale/slider answer (1-10 slider)
     * @param {Object} question - Question object
     * @param {string} questionId - Question ID
     * @param {Object} currentAnswer - Current answer object
     */
    function renderScaleAnswer(question, questionId, currentAnswer) {
      questionChoices.setAttribute('role', 'group');
      questionChoices.setAttribute('aria-labelledby', 'quiz-question-title');
      questionChoices.className = 'v-quiz-answers v-quiz-answers--scale';
      
      // Scale config (default 1-10)
      const scaleMin = question.scaleMin || 1;
      const scaleMax = question.scaleMax || 10;
      const scaleValue = currentAnswer ? parseInt(currentAnswer.value, 10) || scaleMin : scaleMin;
      
      // Scale container
      const scaleContainer = document.createElement('div');
      scaleContainer.className = 'v-quiz-answer-scale';
      
      // Slider input
      const slider = document.createElement('input');
      slider.type = 'range';
      slider.min = scaleMin;
      slider.max = scaleMax;
      slider.value = scaleValue;
      slider.className = 'v-quiz-answer-scale__slider';
      slider.setAttribute('data-quiz-answer', 'true');
      slider.setAttribute('data-question-id', questionId);
      slider.setAttribute('data-answer-type', 'scale');
      slider.setAttribute('aria-valuemin', scaleMin);
      slider.setAttribute('aria-valuemax', scaleMax);
      slider.setAttribute('aria-valuenow', scaleValue);
      slider.setAttribute('aria-label', 'Select value from ' + scaleMin + ' to ' + scaleMax);
      slider.setAttribute('tabindex', '0');
      
      // Scale labels (min and max)
      const scaleLabels = document.createElement('div');
      scaleLabels.className = 'v-quiz-answer-scale__labels';
      
      const minLabel = document.createElement('span');
      minLabel.className = 'v-quiz-answer-scale__label type-caption type-caption--muted';
      minLabel.textContent = question.scaleMinLabel || scaleMin.toString();
      
      const maxLabel = document.createElement('span');
      maxLabel.className = 'v-quiz-answer-scale__label type-caption type-caption--muted';
      maxLabel.textContent = question.scaleMaxLabel || scaleMax.toString();
      
      const currentLabel = document.createElement('span');
      currentLabel.className = 'v-quiz-answer-scale__value type-body-lg';
      currentLabel.textContent = scaleValue;
      currentLabel.setAttribute('aria-live', 'polite');
      
      // Update current label on slider change
      window.PerformanceCore.event('input', function() {
        const value = parseInt(slider.value, 10);
        currentLabel.textContent = value;
        slider.setAttribute('aria-valuenow', value);
        
        // Create answer object for scale
        const scaleAnswer = {
          value: value.toString(),
          weights: calculateScaleWeights(value, scaleMin, scaleMax, question)
        };
        
        selectAnswer(questionId, scaleAnswer, 'scale');
      }, { target: slider });
      
      scaleLabels.appendChild(minLabel);
      scaleLabels.appendChild(currentLabel);
      scaleLabels.appendChild(maxLabel);
      
      scaleContainer.appendChild(slider);
      scaleContainer.appendChild(scaleLabels);
      
      questionChoices.appendChild(scaleContainer);
    }
    
    /**
     * TILE-042: Calculate ritual weights for scale answer based on value
     * Higher values generally indicate more need across all rituals
     * @param {number} value - Scale value (1-10)
     * @param {number} min - Minimum scale value
     * @param {number} max - Maximum scale value
     * @param {Object} question - Question object
     * @returns {Object} Ritual weights object
     */
    function calculateScaleWeights(value, min, max, question) {
      // Normalize value to 0-4 range for weights
      const normalized = ((value - min) / (max - min)) * 4;
      const weight = Math.round(normalized);
      
      // Distribute weight across rituals based on question context
      // For scale questions, weight distribution can be more balanced
      // Higher values = more need across all rituals
      return {
        mc: weight,
        dr: weight,
        ss: weight,
        cr: weight
      };
    }
    
    /**
     * TILE-042: Select an answer for a question (supports single and scale)
     * @param {string} questionId - Question ID
     * @param {Object} answer - Answer object with value and weights
     * @param {string} answerType - Answer type: 'single', 'multi', or 'scale'
     */
    function selectAnswer(questionId, answer, answerType) {
      answerType = answerType || 'single';
      const question = questionsMap[questionId];
      const questionType = question ? (question.type || 'single') : 'single';
      
      // For single-select: replace previous answer
      if (questionType === 'single') {
        // Remove previous answer weights (if any)
        const previousAnswer = answers[questionId];
        if (previousAnswer && previousAnswer.weights) {
          for (var prevKey in previousAnswer.weights) {
            if (previousAnswer.weights.hasOwnProperty(prevKey) && ritualScores.hasOwnProperty(prevKey)) {
              ritualScores[prevKey] -= previousAnswer.weights[prevKey];
            }
          }
        }
        
        // Save new answer
        answers[questionId] = {
          value: answer.value,
          weights: answer.weights
        };
        
        // Add new answer weights
        if (answer.weights) {
          for (var key in answer.weights) {
            if (answer.weights.hasOwnProperty(key) && ritualScores.hasOwnProperty(key)) {
              ritualScores[key] += answer.weights[key];
            }
          }
        }
        
        // Update UI (highlight selected, clear others)
        updateAnswerSelection(questionId, answer.value, 'single');
        
        // Add next question to path (for single-select)
        addToPath(questionId, answer.value);
      } else if (questionType === 'scale') {
        // For scale: replace previous answer (similar to single)
        const previousAnswer = answers[questionId];
        if (previousAnswer && previousAnswer.weights) {
          for (var prevKey in previousAnswer.weights) {
            if (previousAnswer.weights.hasOwnProperty(prevKey) && ritualScores.hasOwnProperty(prevKey)) {
              ritualScores[prevKey] -= previousAnswer.weights[prevKey];
            }
          }
        }
        
        // Save new answer
        answers[questionId] = {
          value: answer.value,
          weights: answer.weights
        };
        
        // Add new answer weights
        if (answer.weights) {
          for (var key in answer.weights) {
            if (answer.weights.hasOwnProperty(key) && ritualScores.hasOwnProperty(key)) {
              ritualScores[key] += answer.weights[key];
            }
          }
        }
        
        // Update UI (scale updates automatically via input event)
        // No need to call updateAnswerSelection for scale
        
        // Add next question to path (for scale, use value for routing)
        addToPath(questionId, answer.value);
      }
      
      // Save progress
      saveProgress();
      
      // Track answer
      if (window.dataLayer) {
        window.dataLayer.push({
          'event': 'quiz_answer_selected',
          'question_id': questionId,
          'answer_value': answer.value,
          'answer_type': answerType,
          'ritual_scores': ritualScores
        });
      }
      
      // Enable Next button (for single and scale, multi is handled separately)
      if (nextBtn && questionType !== 'multi') {
        nextBtn.disabled = false;
        nextBtn.removeAttribute('aria-disabled');
      }
    }
    
    /**
     * TILE-042: Toggle answer for multi-select questions
     * @param {string} questionId - Question ID
     * @param {Object} answer - Answer object with value and weights
     * @param {string} answerType - Answer type (should be 'multi')
     */
    function toggleAnswer(questionId, answer, answerType) {
      const question = questionsMap[questionId];
      if (!question || (question.type || 'single') !== 'multi') return;
      
      // Get current answer (array of selected values)
      let currentAnswer = answers[questionId];
      let selectedValues = currentAnswer && Array.isArray(currentAnswer.value) ? currentAnswer.value.slice() : [];
      let selectedWeights = currentAnswer && currentAnswer.weights ? JSON.parse(JSON.stringify(currentAnswer.weights)) : { mc: 0, dr: 0, ss: 0, cr: 0 };
      
      // Toggle selection
      const index = selectedValues.indexOf(answer.value);
      if (index !== -1) {
        // Deselect: remove from array and subtract weights
        selectedValues.splice(index, 1);
        if (answer.weights) {
          for (var key in answer.weights) {
            if (answer.weights.hasOwnProperty(key) && selectedWeights.hasOwnProperty(key)) {
              selectedWeights[key] -= answer.weights[key];
            }
          }
        }
        if (answer.weights) {
          for (var key in answer.weights) {
            if (answer.weights.hasOwnProperty(key) && ritualScores.hasOwnProperty(key)) {
              ritualScores[key] -= answer.weights[key];
            }
          }
        }
      } else {
        // Select: add to array and add weights
        selectedValues.push(answer.value);
        if (answer.weights) {
          for (var key in answer.weights) {
            if (answer.weights.hasOwnProperty(key) && selectedWeights.hasOwnProperty(key)) {
              selectedWeights[key] += answer.weights[key];
            }
          }
        }
        if (answer.weights) {
          for (var key in answer.weights) {
            if (answer.weights.hasOwnProperty(key) && ritualScores.hasOwnProperty(key)) {
              ritualScores[key] += answer.weights[key];
            }
          }
        }
      }
      
      // Save answer
      answers[questionId] = {
        value: selectedValues,
        weights: selectedWeights
      };
      
      // Update UI (highlight selected answers)
      updateAnswerSelection(questionId, selectedValues, 'multi');
      
      // Save progress
      saveProgress();
      
      // Track answer toggle
      if (window.dataLayer) {
        window.dataLayer.push({
          'event': 'quiz_answer_toggled',
          'question_id': questionId,
          'answer_value': answer.value,
          'selected_values': selectedValues,
          'is_selected': index === -1,
          'ritual_scores': ritualScores
        });
      }
      
      // Enable Next button if at least one answer selected
      if (nextBtn) {
        if (selectedValues.length > 0) {
          nextBtn.disabled = false;
          nextBtn.removeAttribute('aria-disabled');
        } else {
          nextBtn.disabled = true;
          nextBtn.setAttribute('aria-disabled', 'true');
        }
      }
    }
    
    /**
     * TILE-042: Update answer selection UI (supports single, multi, scale)
     * @param {string} questionId - Question ID
     * @param {string|Array} answerValue - Selected answer value(s)
     * @param {string} answerType - Answer type: 'single', 'multi', or 'scale'
     */
    function updateAnswerSelection(questionId, answerValue, answerType) {
      if (!questionChoices) return;
      
      answerType = answerType || 'single';
      
      if (answerType === 'scale') {
        // Scale is handled via input event, no UI update needed
        return;
      }
      
      const choices = questionChoices.querySelectorAll('[data-quiz-answer]');
      const selectedValues = Array.isArray(answerValue) ? answerValue : [answerValue];
      
      choices.forEach(function(choice) {
        const choiceValue = choice.getAttribute('data-answer-value');
        const isSelected = selectedValues.indexOf(choiceValue) !== -1;
        const checkIcon = choice.querySelector('.v-quiz-answer__check');
        
        if (isSelected) {
          choice.classList.add('v-quiz-answer--selected');
          choice.setAttribute('aria-checked', 'true');
          choice.setAttribute('tabindex', '0');
          
          // Show check icon if it exists
          if (checkIcon) {
            checkIcon.style.display = 'block';
          } else if (answerType === 'single' || answerType === 'multi') {
            // Add check icon if it doesn't exist
            const newCheckIcon = document.createElement('span');
            newCheckIcon.className = 'v-quiz-answer__check';
            newCheckIcon.setAttribute('aria-hidden', 'true');
            newCheckIcon.innerHTML = '✓';
            choice.appendChild(newCheckIcon);
          }
        } else {
          choice.classList.remove('v-quiz-answer--selected');
          choice.setAttribute('aria-checked', 'false');
          
          // Hide check icon
          if (checkIcon) {
            checkIcon.style.display = 'none';
          }
          
          // For single-select: set unselected to tabindex -1 (except first)
          if (answerType === 'single') {
            const isFirst = choice === choices[0];
            choice.setAttribute('tabindex', isFirst ? '0' : '-1');
          }
        }
      });
      
      // For single-select: ensure selected answer is focusable
      if (answerType === 'single') {
        const selected = questionChoices.querySelector('[aria-checked="true"]');
        if (selected) {
          selected.setAttribute('tabindex', '0');
          // Set all others to -1
          choices.forEach(function(choice) {
            if (choice !== selected) {
              choice.setAttribute('tabindex', '-1');
            }
          });
        }
      }
    }
    
    // ═══════════════════════════════════════════════════════════════════════════
    // STATE MACHINE TRANSITIONS
    // ═══════════════════════════════════════════════════════════════════════════
    
    /**
     * Sync controls (enable/disable buttons based on state)
     */
    function syncControls() {
      const currentQuestionId = questionPath[currentQuestionIndex];
      const currentAnswer = currentQuestionId ? answers[currentQuestionId] : null;
      const question = currentQuestionId ? questionsMap[currentQuestionId] : null;
      const questionType = question ? (question.type || 'single') : 'single';
      
      // Check if question has answer(s)
      let hasAnswer = false;
      if (currentAnswer) {
        if (questionType === 'multi') {
          hasAnswer = Array.isArray(currentAnswer.value) && currentAnswer.value.length > 0;
        } else {
          hasAnswer = !!currentAnswer.value;
        }
      }
      
      const isFirstQuestion = currentQuestionIndex === 0;
      const isLastQuestion = currentQuestionIndex === questionPath.length - 1;
      
      // Back button: disabled on first question
      if (backBtn) {
        if (isFirstQuestion) {
          backBtn.disabled = true;
          backBtn.setAttribute('aria-disabled', 'true');
        } else {
          backBtn.disabled = false;
          backBtn.removeAttribute('aria-disabled');
        }
      }
      
      // Next button: disabled if no answer selected, change text on last question
      if (nextBtn) {
        const nextBtnText = nextBtn.querySelector('span') || nextBtn;
        
        if (!hasAnswer) {
          nextBtn.disabled = true;
          nextBtn.setAttribute('aria-disabled', 'true');
        } else {
          nextBtn.disabled = false;
          nextBtn.removeAttribute('aria-disabled');
        }
        
        if (isLastQuestion && hasAnswer) {
          // Last question with answer - show "Get Results" text
          const lastStepText = 'Get Results';
          if (nextBtnText.tagName === 'SPAN') {
            nextBtnText.textContent = lastStepText;
          } else {
            nextBtn.textContent = lastStepText;
          }
        } else {
          // Regular question - show "Next" text
          const nextText = 'Next';
          if (nextBtnText.tagName === 'SPAN') {
            nextBtnText.textContent = nextText;
          } else {
            nextBtn.textContent = nextText;
          }
        }
      }
    }
    
    /**
     * Go to specific question in path
     * @param {number} index - Question index in path
     */
    function goToQuestion(index) {
      // Clamp between 0 and path length - 1
      currentQuestionIndex = Math.max(0, Math.min(questionPath.length - 1, index));
      
      const currentQuestionId = questionPath[currentQuestionIndex];
      if (!currentQuestionId) return;
      
      // Update UI
      updateProgress();
      updateQuestionView(currentQuestionId);
      syncControls();
      
      // Save progress
      saveProgress();
      
      // Track question view
      if (window.dataLayer) {
        window.dataLayer.push({
          'event': 'quiz_question_view',
          'question_id': currentQuestionId,
          'question_index': currentQuestionIndex + 1,
          'total_questions': questionPath.length
        });
      }
    }
    
    /**
     * TILE-042: Handle Next button click (supports all answer types)
     */
    function handleNext() {
      const currentQuestionId = questionPath[currentQuestionIndex];
      if (!currentQuestionId) return;
      
      const question = questionsMap[currentQuestionId];
      const questionType = question ? (question.type || 'single') : 'single';
      const currentAnswer = answers[currentQuestionId];
      
      // Check if answer is selected
      if (!currentAnswer) {
        return; // No answer selected - can't proceed
      }
      
      // For multi-select: check if at least one answer selected
      if (questionType === 'multi') {
        if (!Array.isArray(currentAnswer.value) || currentAnswer.value.length === 0) {
          return; // No answers selected - can't proceed
        }
        
        // For multi-select, add next question to path using first selected value (or all)
        // Note: Branching logic may need adjustment for multi-select
        if (currentAnswer.value.length > 0) {
          addToPath(currentQuestionId, currentAnswer.value[0]); // Use first value for now
        }
      }
      
      // Check if this is the last question
      if (currentQuestionIndex === questionPath.length - 1) {
        // Last question - compute results and show
        goToResults();
      } else {
        // Move to next question
        goToQuestion(currentQuestionIndex + 1);
      }
    }
    
    /**
     * Handle Back button click
     */
    function handleBack() {
      if (currentQuestionIndex > 0) {
        goToQuestion(currentQuestionIndex - 1);
      }
    }
    
    /**
     * Handle Skip button click
     */
    function handleSkip() {
      // Skip behaves like Next (but flagged for future logic)
      const currentQuestionId = questionPath[currentQuestionIndex];
      
      // Track skip
      if (window.dataLayer) {
        window.dataLayer.push({
          'event': 'quiz_question_skip',
          'question_id': currentQuestionId,
          'question_index': currentQuestionIndex + 1
        });
      }
      
      // Move to next question (or results if last)
      handleNext();
    }
    
    /**
     * Handle Exit button click
     */
    function handleExit(e) {
      if (e) e.preventDefault();
      
      const exitLink = exitBtn ? exitBtn.getAttribute('href') || '/collections/all' : '/collections/all';
      
      // Track exit
      if (window.dataLayer) {
        window.dataLayer.push({
          'event': 'quiz_exit',
          'question_index': currentQuestionIndex + 1,
          'total_questions': questionPath.length,
          'ritual_scores': ritualScores
        });
      }
      
      // Redirect
      window.location.href = exitLink;
    }
    
    /**
     * Go to Results state
     */
    function goToResults() {
      quizState = 'results';
      quizRoot.setAttribute('data-quiz-state', 'results');
      
      // TILE-043: Compute results using Result Engine
      const results = computeResults();
      
      // TILE-043: Build payload using Result Engine
      const payload = buildResultPayload(ritualScores);
      
      // TILE-043: Store results in window for future tiles
      window.QuizResults = payload;
      window.__QUIZ_RESULTS__ = results; // Legacy compatibility
      
      // TILE-046: Update global ritual state
      try {
        if (window.VelunaRitualState && typeof window.VelunaRitualState.set === 'function') {
          window.VelunaRitualState.set(payload);
        }
      } catch (e) {
        logger.warn('VelunaRitualState.set failed', e);
      }
      
      // TILE-043: Persist results to localStorage
      try {
        localStorage.setItem('veluna_quiz_result', JSON.stringify(payload));
        // Also store in legacy format for compatibility
        localStorage.setItem('veluna_quiz_results', JSON.stringify({
          category: payload.ritualCode,
          ritual: payload.ritualName,
          confidence: payload.confidence,
          completed: true,
          timestamp: new Date().toISOString()
        }));
      } catch (e) {
        logger.warn('QuizController: Failed to save results to localStorage:', e);
      }
      
      // TILE-043: Dispatch event for Wave 5 UI
      try {
        window.dispatchEvent(new CustomEvent('quiz:results-ready', { 
          detail: payload,
          bubbles: true,
          cancelable: true
        }));
      } catch (e) {
        logger.warn('QuizController: Failed to dispatch results-ready event:', e);
      }
      
      // Track quiz completion
      if (window.dataLayer) {
        window.dataLayer.push({
          'event': 'quiz_complete',
          'ritual_match': payload.ritualCode,
          'confidence': payload.confidence
        });
      }
      
      // Redirect to My Ritual page with category parameter
      // Use replace() to avoid adding quiz page to history (prevents back button issues)
      const redirectUrl = `/pages/my-ritual?from_quiz=true&category=${payload.ritualCode}`;
      logger.info('Quiz complete. Redirecting to:', redirectUrl);
      window.location.replace(redirectUrl);
      
      // Clear saved progress (quiz complete)
      clearProgress();
      
      // TILE-043: Track results view with payload data
      if (window.dataLayer) {
        window.dataLayer.push({
          'event': 'quiz_complete',
          'ritual': payload.ritual,
          'ritual_name': payload.ritualName,
          'confidence': payload.confidence,
          'secondary_ritual': payload.secondary ? payload.secondary.ritual : null,
          'ritual_scores': payload.scores,
          'normalized_scores': payload.normalized,
          'total_questions': questionPath.length
        });
      }
    }
    
    /**
     * Start quiz (hide intro, show quiz)
     */
    function startQuiz(e) {
      if (e) e.preventDefault();
      
      // Initialize question path if not restored
      if (questionPath.length === 0) {
        initializeQuestionPath();
      }
      
      // Transition to question state
      quizState = 'question';
      quizRoot.setAttribute('data-quiz-state', 'active');
      
      // Hide intro
      if (introCta && introCta.closest('.quiz-shell__intro-cta')) {
        introCta.closest('.quiz-shell__intro-cta').hidden = true;
      }
      if (quizRoot.querySelector('.quiz-shell__intro')) {
        quizRoot.querySelector('.quiz-shell__intro').hidden = true;
      }
      
      // Show quiz elements
      if (progressContainer) progressContainer.hidden = false;
      if (questionContainer) questionContainer.hidden = false;
      if (controlsContainer) controlsContainer.hidden = false;
      if (helperContainer) helperContainer.hidden = false;
      
      // Go to first question
      goToQuestion(0);
      
      // Track quiz start
      if (window.dataLayer) {
        window.dataLayer.push({
          'event': 'quiz_start',
          'total_questions': questionPath.length
        });
      }
    }
    
    // ═══════════════════════════════════════════════════════════════════════════
    // TILE-044: RESULT UI HELPERS
    // ═══════════════════════════════════════════════════════════════════════════
    
    /**
     * TILE-044: Get quiz result payload from window or localStorage
     * @returns {Object|null} Result payload or null if not found
     */
    function getQuizResult() {
      // Try window.QuizResults first (primary source)
      if (window.QuizResults && typeof window.QuizResults === 'object') {
        return window.QuizResults;
      }
      
      // Try localStorage fallback
      try {
        const saved = localStorage.getItem('veluna_quiz_result');
        if (saved) {
          return JSON.parse(saved);
        }
      } catch (e) {
        logger.warn('QuizController: Failed to parse saved result from localStorage:', e);
      }
      
      return null;
    }
    
    // ═══════════════════════════════════════════════════════════════════════════
    // TILE-045: EMAIL CAPTURE HELPERS
    // ═══════════════════════════════════════════════════════════════════════════
    
    /**
     * TILE-045: Check if email has already been captured for this quiz result
     * @returns {boolean} True if email was already captured
     */
    function hasCapturedQuizEmail() {
      try {
        return localStorage.getItem('veluna_quiz_email_captured') === '1';
      } catch (e) {
        return false;
      }
    }
    
    /**
     * TILE-045: Mark email as captured
     */
    function markQuizEmailCaptured() {
      try {
        localStorage.setItem('veluna_quiz_email_captured', '1');
      } catch (e) {
        logger.warn('QuizController: Failed to mark email as captured:', e);
      }
    }
    
    /**
     * TILE-045: Build email submission payload with quiz result data
     * @param {string} email - User's email address
     * @returns {Object} Payload object
     */
    function buildEmailPayload(email) {
      const result = getQuizResult();
      
      if (!result) {
        return null;
      }
      
      const ritualCode = (result.ritual || 'mc').toLowerCase();
      const bundleByRitual = {
        mc: 'mind-calm-stater-set',
        dr: 'deep-restore-starter-set',
        ss: 'sacred-soothe-starter-pack',
        cr: 'circadian-reset-starter-set'
      };
      const params = new URLSearchParams(window.location.search || '');
      const articleParam = params.get('article') || '';
      const articleHandle = articleParam.split('/').pop() || '';
      const sourceParam = (params.get('source') || '').toLowerCase();
      const source = sourceParam === 'article' ? 'article_quiz' : 'quiz_results';
      const recommendedBundle = bundleByRitual[ritualCode] || 'deep-restore-starter-set';
      const tags = ['quiz-capture', 'quiz-result', 'concern_' + ritualCode, recommendedBundle];
      if (articleHandle) {
        tags.push('article-' + articleHandle);
      }

      // Build payload for /apps/jarvis/email/subscribe intake.
      const payload = {
        email: email,
        topic: 'popup_subscribe',
        source: source,
        email_sequence: sourceParam === 'article' ? 'article_welcome' : 'welcome',
        tags: tags,
        fields: {
          sleep_concern: ritualCode,
          acquisition: sourceParam === 'article' ? 'article_quiz' : 'quiz',
          lead_magnet: 'ritual_quiz_plan',
          article_handle: articleHandle,
          ritual_code: ritualCode,
          ritual_name: result.ritualName || '',
          confidence: String(result.confidence || 0),
          recommended_bundle: recommendedBundle
        },
        metadata: {
          path: window.location.pathname,
          referrer: document.referrer || '',
          timestamp: Date.now(),
          secondary: result.secondary || null,
          scores: result.scores || {},
          normalized: result.normalized || {}
        }
      };
      
      return payload;
    }
    
    /**
     * TILE-045: Submit quiz email with result data
     * @param {string} email - User's email address
     * @param {Function} onSuccess - Success callback
     * @param {Function} onError - Error callback
     */
    function submitQuizEmail(email, onSuccess, onError) {
      // Validate email
      if (!email || typeof email !== 'string') {
        onError('Please enter a valid email address.');
        return;
      }
      
      // Basic email validation
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(email.trim())) {
        onError('Please enter a valid email address.');
        return;
      }
      
      // Check if quiz result exists
      const result = getQuizResult();
      if (!result) {
        onError('Please complete the quiz first.');
        return;
      }
      
      // Build payload
      const payload = buildEmailPayload(email.trim());
      if (!payload) {
        onError('Unable to retrieve quiz results. Please try again.');
        return;
      }
      
      // Get endpoint URL from section settings or fallback
      const endpointAttr = quizRoot.getAttribute('data-quiz-email-endpoint');
      const methodAttr = quizRoot.getAttribute('data-quiz-email-method') || 'POST';
      
      // Default fallback endpoint (Shopify contact form or similar)
      let endpointUrl = endpointAttr || window.VelunaThemeSettings.emailSubscribeEndpoint || '/apps/jarvis/email/subscribe';
      
      // Submit via fetch
      const submitOptions = {
        method: methodAttr,
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
      };
      
      // For GET requests, encode payload in URL params
      if (methodAttr === 'GET') {
        const params = new URLSearchParams();
        params.append('email', payload.email);
        params.append('ritual', payload.ritual || '');
        params.append('ritualName', payload.ritualName || '');
        params.append('confidence', payload.confidence.toString());
        params.append('source', payload.source);
        params.append('path', payload.path);
        params.append('timestamp', payload.timestamp.toString());
        
        if (payload.secondary) {
          params.append('secondaryRitual', payload.secondary.ritual || '');
          params.append('secondaryDelta', payload.secondary.delta ? payload.secondary.delta.toString() : '');
        }
        
        delete submitOptions.body;
        submitOptions.method = 'GET';
        endpointUrl = endpointUrl + (endpointUrl.indexOf('?') > -1 ? '&' : '?') + params.toString();
      }
      
      fetch(endpointUrl, submitOptions)
        .then(function(response) {
          if (!response.ok) {
            throw new Error('Network response was not ok');
          }
          return response.json().catch(function() {
            // If response is not JSON, still consider it success if status is 200
            return { success: true };
          });
        })
        .then(function(data) {
          // Mark as captured
          markQuizEmailCaptured();
          
          // Call success callback
          if (onSuccess) {
            onSuccess(data);
          }
        })
        .catch(function(error) {
          logger.warn('QuizController: Email submission failed:', error);
          
          // Call error callback
          if (onError) {
            onError('Something went wrong. Please try again.');
          }
        });
    }
    
    /**
     * TILE-045: Bind email capture form events
     */
    function bindEmailCapture() {
      if (!emailBlock) return;
      
      // Check if email already captured
      if (hasCapturedQuizEmail()) {
        // Show success state instead of form
        const form = emailBlock.querySelector('[data-quiz-email-form]');
        const success = emailBlock.querySelector('[data-quiz-email-success]');
        
        if (form) form.hidden = true;
        if (success) success.hidden = false;
        
        return;
      }
      
      const emailInput = emailBlock.querySelector('[data-quiz-email-input]');
      const emailSubmit = emailBlock.querySelector('[data-quiz-email-submit]');
      const emailStatus = emailBlock.querySelector('[data-quiz-email-status]');
      const emailForm = emailBlock.querySelector('[data-quiz-email-form]');
      const emailSuccess = emailBlock.querySelector('[data-quiz-email-success]');
      
      if (!emailInput || !emailSubmit || !emailStatus || !emailForm) return;
      
      // Handle form submission
      function handleEmailSubmit(e) {
        if (e) e.preventDefault();
        
        const email = emailInput.value.trim();
        
        // Clear previous status
        emailStatus.hidden = true;
        emailStatus.setAttribute('aria-live', 'off');
        
        // Update UI: sending state
        emailSubmit.disabled = true;
        emailSubmit.setAttribute('aria-disabled', 'true');
        const submitText = emailSubmit.querySelector('[data-quiz-email-submit-text]');
        if (submitText) {
          submitText.textContent = 'Sending...';
        }
        
        // Submit email
        submitQuizEmail(
          email,
          function(data) {
            // Success
            emailForm.hidden = true;
            emailSuccess.hidden = false;
            emailInput.value = '';
            
            // Reset button
            emailSubmit.disabled = false;
            emailSubmit.removeAttribute('aria-disabled');
            if (submitText) {
              const ctaLabel = quizRoot.getAttribute('data-quiz-email-cta-label') || 'Send It to My Email';
              submitText.textContent = ctaLabel;
            }
            
            // Track success
            if (window.dataLayer) {
              window.dataLayer.push({
                'event': 'quiz_email_captured',
                'email': email,
                'ritual': data.ritual || null,
                'confidence': data.confidence || 0
              });
            }
          },
          function(errorMessage) {
            // Error
            const statusText = emailStatus.querySelector('[data-quiz-email-status-text]');
            if (statusText) {
              const errorCopy = quizRoot.getAttribute('data-quiz-email-error-copy') || 'Something went wrong. Please try again.';
              statusText.textContent = errorMessage || errorCopy;
            }
            
            emailStatus.hidden = false;
            emailStatus.setAttribute('aria-live', 'polite');
            emailStatus.setAttribute('role', 'alert');
            
            // Reset button
            emailSubmit.disabled = false;
            emailSubmit.removeAttribute('aria-disabled');
            if (submitText) {
              const ctaLabel = quizRoot.getAttribute('data-quiz-email-cta-label') || 'Send It to My Email';
              submitText.textContent = ctaLabel;
            }
            
            // Focus input for correction
            emailInput.focus();
            emailInput.setAttribute('aria-invalid', 'true');
          }
        );
      }
      
      // Bind submit events
      window.PerformanceCore.event('submit', handleEmailSubmit, { target: emailForm });
      
      // Also bind click on submit button (for browsers that don't fire submit)
      window.PerformanceCore.event('click', function(e) {
        e.preventDefault();
        handleEmailSubmit(e);
      }, { target: emailSubmit });
      
      // Clear validation on input change
      window.PerformanceCore.event('input', function() {
        emailInput.setAttribute('aria-invalid', 'false');
        if (emailStatus.hidden === false) {
          emailStatus.hidden = true;
        }
      }, { target: emailInput });
    }
    
    /**
     * TILE-044: Get ritual icon name from ritual code
     * @param {string} ritualCode - Ritual code ('mc', 'dr', 'ss', or 'cr')
     * @returns {string} Icon name
     */
    function getRitualIcon(ritualCode) {
      const iconMap = {
        mc: 'moon',
        dr: 'sparkle',
        ss: 'star',
        cr: 'arrow-down'
      };
      return iconMap[ritualCode] || 'moon';
    }
    
    /**
     * TILE-044: Get ritual product URLs from section settings or fallback
     * @param {string} ritualCode - Ritual code
     * @returns {Object} URLs object { pdp: string, collection: string }
     */
    function getRitualUrls(ritualCode) {
      // Try to get from data attributes on quiz root (set by section settings)
      const pdpAttr = quizRoot.getAttribute('data-ritual-' + ritualCode + '-pdp');
      const collectionAttr = quizRoot.getAttribute('data-ritual-' + ritualCode + '-collection');
      
      // Fallback mapping (can be overridden by section settings)
      const fallbackUrls = {
        mc: { pdp: '/products/mind-calm-ritual-set', collection: '/collections/mind-calm' },
        dr: { pdp: '/products/deep-restore-ritual-set', collection: '/collections/deep-restore' },
        ss: { pdp: '/products/sacred-soothe-ritual-set', collection: '/collections/sacred-soothe' },
        cr: { pdp: '/products/circadian-reset-ritual-set', collection: '/collections/circadian-reset' }
      };
      
      return {
        pdp: pdpAttr || fallbackUrls[ritualCode].pdp || '/collections/all',
        collection: collectionAttr || fallbackUrls[ritualCode].collection || '/collections/all'
      };
    }
    
    /**
     * TILE-044: Render result view with payload data
     * @param {Object} payload - Result payload from Result Engine
     */
    function renderResultView(payload) {
      if (!payload || !resultPanel) return;
      
      const ritualCode = payload.ritual || 'mc';
      const context = RITUAL_CONTEXT[ritualCode] || RITUAL_CONTEXT.mc;
      const ritualIcon = getRitualIcon(ritualCode);
      const urls = getRitualUrls(ritualCode);
      
      // Zone 1: Result Hero Strip
      const heroIcon = resultPanel.querySelector('[data-quiz-result-icon]');
      const heroTitle = resultPanel.querySelector('[data-quiz-result-title]');
      const ritualNameSpan = resultPanel.querySelector('[data-quiz-result-ritual-name]');
      const confidenceValue = resultPanel.querySelector('[data-quiz-result-confidence-value]');
      
      // Update icon by replacing v-icon component
      if (heroIcon) {
        heroIcon.setAttribute('data-ritual-icon', ritualIcon);
        const iconSpan = heroIcon.querySelector('.v-icon');
        if (iconSpan) {
          // Replace with correct icon by re-rendering v-icon structure
          heroIcon.innerHTML = '';
          const newIconWrapper = document.createElement('span');
          newIconWrapper.className = 'v-icon v-icon--xl v-icon--accent';
          newIconWrapper.setAttribute('aria-hidden', 'true');
          newIconWrapper.innerHTML = getRitualIconSvg(ritualIcon);
          heroIcon.appendChild(newIconWrapper);
        }
      }
      
      if (ritualNameSpan) {
        ritualNameSpan.textContent = payload.ritualName || context.shortName;
      }
      
      if (confidenceValue) {
        const confidencePercent = Math.round((payload.confidence || 0.5) * 100);
        confidenceValue.textContent = confidencePercent + '%';
        // Update aria-label for screen readers
        const confidenceEl = resultPanel.querySelector('[data-quiz-result-confidence]');
        if (confidenceEl) {
          confidenceEl.setAttribute('aria-label', 'Confidence: ' + confidencePercent + ' percent');
        }
      }
      
      // Zone 2: Rationale & Feel Block
      const rationaleText = resultPanel.querySelector('[data-quiz-result-rationale]');
      const benefitsList = resultPanel.querySelector('[data-quiz-result-benefits]');
      
      if (rationaleText) {
        rationaleText.textContent = payload.rationale || context.rationaleTemplates.long;
      }
      
      if (benefitsList && context.benefits) {
        benefitsList.innerHTML = '';
        context.benefits.slice(0, 3).forEach(function(benefit) {
          const li = document.createElement('li');
          li.className = 'v-quiz-result__benefit type-body';
          li.innerHTML = '<span class="v-quiz-result__benefit-icon" aria-hidden="true">' + 
            getCheckIconSvg() + 
            '</span><span data-quiz-result-benefit-item>' + benefit + '</span>';
          benefitsList.appendChild(li);
        });
      }
      
      // Zone 3: Primary Ritual Card
      const cardIcon = resultPanel.querySelector('[data-quiz-result-card-icon]');
      const cardTitle = resultPanel.querySelector('[data-quiz-result-card-title]');
      const cardDescription = resultPanel.querySelector('[data-quiz-result-card-description]');
      const cardForYouList = resultPanel.querySelector('[data-quiz-result-card-for-you-list]');
      
      // Update card icon
      if (cardIcon) {
        const iconSpan = cardIcon.querySelector('.v-icon');
        if (iconSpan) {
          cardIcon.innerHTML = '';
          const newIconWrapper = document.createElement('span');
          newIconWrapper.className = 'v-icon v-icon--lg v-icon--accent';
          newIconWrapper.setAttribute('aria-hidden', 'true');
          newIconWrapper.innerHTML = getRitualIconSvg(ritualIcon);
          cardIcon.appendChild(newIconWrapper);
        }
      }
      
      if (cardTitle) {
        cardTitle.textContent = context.name || payload.ritualName;
      }
      
      if (cardDescription) {
        cardDescription.textContent = context.rationaleTemplates.long || payload.rationale;
      }
      
      if (cardForYouList && context.pains) {
        cardForYouList.innerHTML = '';
        context.pains.slice(0, 2).forEach(function(pain) {
          const li = document.createElement('li');
          li.className = 'type-body-sm';
          li.textContent = 'You experience ' + pain;
          cardForYouList.appendChild(li);
        });
      }
      
      // Zone 4: Secondary Ritual Hint (if applicable)
      const secondaryCard = resultPanel.querySelector('[data-quiz-result-secondary]');
      if (payload.secondary && payload.secondary.delta < 0.5) {
        // Show secondary if delta is below threshold (close match)
        const secondaryContext = RITUAL_CONTEXT[payload.secondary.ritual] || null;
        if (secondaryCard && secondaryContext) {
          secondaryCard.hidden = false;
          
          const secondaryIcon = resultPanel.querySelector('[data-quiz-result-secondary-icon]');
          const secondaryName = resultPanel.querySelector('[data-quiz-result-secondary-name]');
          const secondaryDescription = resultPanel.querySelector('[data-quiz-result-secondary-description]');
          
          // Update secondary icon
          if (secondaryIcon) {
            const secondaryIconName = getRitualIcon(payload.secondary.ritual);
            const iconSpan = secondaryIcon.querySelector('.v-icon');
            if (iconSpan) {
              secondaryIcon.innerHTML = '';
              const newIconWrapper = document.createElement('span');
              newIconWrapper.className = 'v-icon v-icon--md v-icon--muted';
              newIconWrapper.setAttribute('aria-hidden', 'true');
              newIconWrapper.innerHTML = getRitualIconSvg(secondaryIconName);
              secondaryIcon.appendChild(newIconWrapper);
            }
          }
          
          if (secondaryName) {
            secondaryName.textContent = payload.secondary.ritualName;
          }
          
          if (secondaryDescription && secondaryContext.pains && secondaryContext.pains.length > 0) {
            secondaryDescription.textContent = 'Sometimes your responses also matched this pattern when you prioritize ' + secondaryContext.pains[0] + '.';
          }
        }
      } else if (secondaryCard) {
        secondaryCard.hidden = true;
      }
      
      // Zone 5: Product CTA Row
      const ctaPrimaryLink = resultPanel.querySelector('[data-quiz-result-cta-primary]');
      const ctaPrimaryText = resultPanel.querySelector('[data-quiz-result-cta-primary-text]');
      const ctaSecondaryLink = resultPanel.querySelector('[data-quiz-result-cta-secondary]');
      const ctaSecondaryText = resultPanel.querySelector('[data-quiz-result-cta-secondary-text]');
      
      if (ctaPrimaryLink && ctaPrimaryText) {
        ctaPrimaryLink.href = urls.pdp;
        ctaPrimaryText.textContent = 'Start My ' + payload.ritualName + ' Ritual';
      }
      
      if (ctaSecondaryLink && ctaSecondaryText) {
        ctaSecondaryLink.href = urls.collection;
        ctaSecondaryText.textContent = 'See all ' + payload.ritualName + ' sets';
      }
      
      // Zone 6: Helper Strip (already populated in Liquid, no updates needed)
      
      // Retake button handler
      const retakeBtn = resultPanel.querySelector('[data-quiz-result-retake]');
      if (retakeBtn) {
        window.PerformanceCore.event('click', function(e) {
          e.preventDefault();
          resetQuiz();
        }, { target: retakeBtn });
      }
    }
    
    /**
     * TILE-044: Get ritual icon SVG (simplified - matches v-icon component)
     * @param {string} iconName - Icon name
     * @returns {string} SVG markup
     */
    function getRitualIconSvg(iconName) {
      const iconSvgs = {
        moon: '<svg width="100%" height="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="none"/></svg>',
        sparkle: '<svg width="100%" height="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 2L13.5 8.5L20 10L13.5 11.5L12 18L10.5 11.5L4 10L10.5 8.5L12 2Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="none"/><path d="M6 6L7.5 7.5L9 6L7.5 4.5L6 6Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" fill="none"/><path d="M15 15L16.5 16.5L18 15L16.5 13.5L15 15Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" fill="none"/></svg>',
        star: '<svg width="100%" height="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="none"/></svg>',
        'arrow-down': '<svg width="100%" height="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 5V19M12 19L5 12M12 19L19 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>'
      };
      return iconSvgs[iconName] || iconSvgs.moon;
    }
    
    /**
     * TILE-044: Get check icon SVG
     * @returns {string} SVG markup
     */
    function getCheckIconSvg() {
      return '<svg width="100%" height="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20 6L9 17L4 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    }
    
    /**
     * TILE-044: Reset quiz (retake functionality)
     */
    function resetQuiz() {
      // Reset state
      currentQuestionIndex = 0;
      questionPath = [];
      answers = {};
      ritualScores = { mc: 0, dr: 0, ss: 0, cr: 0 };
      quizState = 'intro';
      
      // Clear saved progress
      clearProgress();
      try {
        localStorage.removeItem('veluna_quiz_result');
      } catch (e) {
        logger.warn('QuizController: Failed to clear result from localStorage:', e);
      }
      
      // Clear window globals
      window.QuizResults = null;
      window.__QUIZ_RESULTS__ = null;
      
      // Hide result panel, show intro
      if (resultPanel) resultPanel.hidden = true;
      if (resultsContainer) resultsContainer.hidden = true;
      
      if (progressContainer) progressContainer.hidden = true;
      if (questionContainer) questionContainer.hidden = true;
      if (controlsContainer) controlsContainer.hidden = true;
      if (helperContainer) helperContainer.hidden = true;
      
      // Show intro
      if (quizRoot.querySelector('.quiz-shell__intro')) {
        quizRoot.querySelector('.quiz-shell__intro').hidden = false;
      }
      
      quizRoot.setAttribute('data-quiz-state', 'intro');
      
      // Scroll to top
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
    
    // ═══════════════════════════════════════════════════════════════════════════
    // INITIALIZATION
    // ═══════════════════════════════════════════════════════════════════════════
    
    // TILE-044: Check for existing result first (if user visits results page directly)
    checkForExistingResult();
    
    // Try to restore progress (only if not showing results)
    if (quizState !== 'results') {
      const restored = restoreProgress();
      
      // If restored and in active state, show quiz immediately
      if (restored && quizState === 'question') {
        // Re-show quiz elements
        if (progressContainer) progressContainer.hidden = false;
        if (questionContainer) questionContainer.hidden = false;
        if (controlsContainer) controlsContainer.hidden = false;
        if (helperContainer) helperContainer.hidden = false;
        
        // Hide intro
        if (quizRoot.querySelector('.quiz-shell__intro')) {
          quizRoot.querySelector('.quiz-shell__intro').hidden = true;
        }
        
        // Go to current question
        goToQuestion(currentQuestionIndex);
      } else {
        // Initialize question path
        initializeQuestionPath();
      }
    }
    
    // TILE-045: Bind email capture form (after LCP for non-critical functionality)
    window.PerformanceCore.afterLCP(function() {
      bindEmailCapture();
    });
    
    // Event listeners
    if (introCta) {
      // Start quiz button
      const startButton = introCta.closest('a') || introCta.closest('button');
      if (startButton) {
        window.PerformanceCore.event('click', function(e) {
          e.preventDefault();
          startQuiz();
        }, { target: startButton });
      }
    }
    
    if (backBtn) {
      window.PerformanceCore.event('click', handleBack, { target: backBtn });
    }
    
    if (nextBtn) {
      window.PerformanceCore.event('click', handleNext, { target: nextBtn });
    }
    
    if (skipBtn) {
      window.PerformanceCore.event('click', handleSkip, { target: skipBtn });
    }
    
    if (exitBtn) {
      window.PerformanceCore.event('click', function(e) {
        e.preventDefault();
        handleExit();
      }, { target: exitBtn });
    }
    
    // Keyboard navigation (arrow keys)
    window.PerformanceCore.event('keydown', function(e) {
      if (quizState !== 'active') return;
      
      if (e.key === 'ArrowLeft' && currentStep > 0) {
        e.preventDefault();
        handleBack();
      } else if (e.key === 'ArrowRight' && currentStep < totalSteps - 1) {
        e.preventDefault();
        handleNext();
      }
    }, { target: document });
  }
  
  // Initialize quiz controller after DOM ready (TILE-040)
  window.PerformanceCore.afterLCP(function() {
    initQuizController();
  });

})();

// ═══════════════════════════════════════════════════════════════════════════
// TILE-046: GLOBAL RITUAL STATE & PERSONALIZATION BRIDGE
// ═══════════════════════════════════════════════════════════════════════════

/**
 * TILE-046: RitualState - Single source of truth for user's ritual state
 * 
 * Provides:
 * - Global ritual state accessible via window.VelunaRitualState
 * - window.VelunaRitual for direct access to current state
 * - DOM hooks via data attributes on <body>
 * - Subscription API for other scripts
 */
(function() {
  'use strict';
  
  var RitualState = (function() {
    var current = null;
    var subscribers = [];
    
    /**
     * Set ritual state from quiz result payload
     * @param {Object} result - Quiz result payload from TILE-043
     */
    function set(result) {
      if (!result || typeof result !== 'object') {
        logger.warn('RitualState.set: Invalid result payload');
        return;
      }
      
      // Normalize into minimal shape
      current = {
        ritual: result.ritual || null,               // "mc" | "dr" | "ss" | "cr"
        ritualName: result.ritualName || null,       // "Mind Calm", etc.
        confidence: result.confidence || 0,          // 0-1
        scores: result.scores || {},
        normalized: result.normalized || {},
        secondary: result.secondary || null,
        source: result.source || 'veluna-quiz',
        timestamp: result.timestamp || Date.now()
      };
      
      // Expose to window
      window.VelunaRitual = current;
      
      // Update DOM attributes
      updateDOMAttributes();
      
      // Persist to storage (sync with existing veluna_quiz_result)
      persist();
      
      // Notify all subscribers
      notifySubscribers();
    }
    
    /**
     * Get current ritual state
     * @returns {Object|null} Current ritual state or null
     */
    function get() {
      return current;
    }
    
    /**
     * Load ritual state from localStorage
     */
    function loadFromStorage() {
      try {
        var saved = localStorage.getItem('veluna_quiz_result');
        if (!saved) {
          return; // No saved data
        }
        
        var parsed = JSON.parse(saved);
        if (parsed && typeof parsed === 'object') {
          set(parsed); // Normalize and set
        }
      } catch (e) {
        logger.warn('RitualState.loadFromStorage: Failed to load from storage', e);
        // Fail silently - no ritual state is valid
      }
    }
    
    /**
     * Persist current state to localStorage (sync with existing key)
     */
    function persist() {
      if (!current) return;
      
      try {
        // Sync with existing veluna_quiz_result key (don't overwrite if more recent data exists)
        var existing = localStorage.getItem('veluna_quiz_result');
        if (existing) {
          try {
            var existingParsed = JSON.parse(existing);
            // Only update if our timestamp is newer or if existing data is missing key fields
            if (existingParsed && existingParsed.timestamp && existingParsed.timestamp > current.timestamp) {
              return; // Existing data is more recent
            }
          } catch (e) {
            // Existing data is corrupted, we'll overwrite it
          }
        }
        
        // Store as JSON (compatible with quiz result payload format)
        localStorage.setItem('veluna_quiz_result', JSON.stringify(current));
      } catch (e) {
        logger.warn('RitualState.persist: Failed to persist to storage', e);
      }
    }
    
    /**
     * Update DOM data attributes on <body>
     */
    function updateDOMAttributes() {
      var body = document.body;
      if (!body) return;
      
      if (current && current.ritual) {
        body.dataset.ritual = current.ritual;
        body.dataset.ritualName = current.ritualName || '';
        body.dataset.ritualConfidence = String(Math.round((current.confidence || 0) * 100));
      } else {
        // Clear attributes if no ritual state
        delete body.dataset.ritual;
        delete body.dataset.ritualName;
        delete body.dataset.ritualConfidence;
      }
    }
    
    /**
     * Notify all subscribers of state change
     */
    function notifySubscribers() {
      subscribers.forEach(function(fn) {
        try {
          fn(current);
        } catch (e) {
          logger.warn('RitualState subscriber error', e);
        }
      });
    }
    
    /**
     * Subscribe to ritual state changes
     * @param {Function} fn - Callback function that receives (state) or null
     * @returns {Function} Unsubscribe function
     */
    function subscribe(fn) {
      if (typeof fn !== 'function') {
        logger.warn('RitualState.subscribe: Callback must be a function');
        return function() {}; // Return no-op unsubscribe
      }
      
      subscribers.push(fn);
      
      // Immediately invoke with current state if available
      if (current) {
        try {
          fn(current);
        } catch (e) {
          logger.warn('RitualState.subscribe: Error invoking initial callback', e);
        }
      }
      
      // Return unsubscribe function
      return function() {
        var index = subscribers.indexOf(fn);
        if (index > -1) {
          subscribers.splice(index, 1);
        }
      };
    }
    
    // Public API
    return {
      set: set,
      get: get,
      subscribe: subscribe,
      loadFromStorage: loadFromStorage
    };
  })();
  
  // Expose to window
  window.VelunaRitualState = RitualState;
  window.VelunaRitual = null; // Will be set when state is loaded
  
  // ═══════════════════════════════════════════════════════════════════════════
  // TILE-046: GLOBAL INITIALIZATION
  // ═══════════════════════════════════════════════════════════════════════════
  
  /**
   * Global initialization: Load ritual state on every page
   * Runs after LCP to avoid blocking critical rendering
   */
  window.PerformanceCore.afterLCP(function() {
    try {
      if (window.VelunaRitualState && typeof window.VelunaRitualState.loadFromStorage === 'function') {
        window.VelunaRitualState.loadFromStorage();
      }
    } catch (e) {
      logger.warn('VelunaRitualState global load failed', e);
    }
  });
  
  // ═══════════════════════════════════════════════════════════════════════════
  // TILE-046: MICRO-PERSONALIZATION HOOK (Header)
  // ═══════════════════════════════════════════════════════════════════════════
  
  /**
   * Subscribe to ritual state changes and update header microcopy
   * Safe, text-only personalization that doesn't affect layout
   */
  if (window.VelunaRitualState) {
    window.VelunaRitualState.subscribe(function(state) {
      var el = document.querySelector('[data-ritual-microcopy]');
      if (!el) return; // Element doesn't exist, that's ok
      
      if (!state || !state.ritualName) {
        // No ritual state - show default text
        el.textContent = 'Personalized sleep rituals when you\'re ready.';
        return;
      }
      
      // Update with ritual name
      el.textContent = 'You\'re aligned with the ' + state.ritualName + ' Ritual.';
    });
  }
  
})();

// ═══════════════════════════════════════════════════════════════════════════
// TILE-047: GLOBAL RITUAL-AWARE PERSONALIZATION HOOKS (Phase 2)
// ═══════════════════════════════════════════════════════════════════════════

/**
 * TILE-047: PersonalizationHook API
 * 
 * Lightweight API for applying ritual-aware personalization to any element.
 * All personalization is optional, text-only, and fails gracefully.
 */
(function() {
  'use strict';
  
  /**
   * PersonalizationHook API
   * Provides simple methods to personalize elements based on ritual state
   */
  window.VelunaPersonalize = {
    /**
     * Apply a function to an element if it exists and ritual state is available
     * @param {string} selector - CSS selector for target element
     * @param {Function} fn - Function that receives (element, state)
     */
    applyTo: function(selector, fn) {
      try {
        var el = document.querySelector(selector);
        if (!el) return; // Element doesn't exist, that's ok
        
        var state = window.VelunaRitualState && typeof window.VelunaRitualState.get === 'function' 
          ? window.VelunaRitualState.get() 
          : null;
        
        if (!state || !state.ritual) return; // No ritual state, skip personalization
        
        fn(el, state);
      } catch (e) {
        logger.warn('Personalization hook failed:', e);
      }
    },
    
    /**
     * Update text content of an element based on ritual state
     * @param {string} selector - CSS selector for target element
     * @param {Function} generator - Function that receives (state) and returns string
     */
    text: function(selector, generator) {
      this.applyTo(selector, function(el, state) {
        try {
          el.textContent = generator(state);
        } catch (e) {
          logger.warn('Personalization text generator failed:', e);
        }
      });
    },
    
    /**
     * Update an attribute of an element based on ritual state
     * @param {string} selector - CSS selector for target element
     * @param {string} attrName - Attribute name to set
     * @param {Function} generator - Function that receives (state) and returns string
     */
    attr: function(selector, attrName, generator) {
      this.applyTo(selector, function(el, state) {
        try {
          el.setAttribute(attrName, generator(state));
        } catch (e) {
          logger.warn('Personalization attr generator failed:', e);
        }
      });
    },
    
    /**
     * Add a CSS class to an element based on ritual state
     * @param {string} selector - CSS selector for target element
     * @param {string|Function} className - Class name or function that returns class name
     */
    addClass: function(selector, className) {
      this.applyTo(selector, function(el, state) {
        try {
          var classToAdd = typeof className === 'function' ? className(state) : className;
          if (classToAdd) {
            el.classList.add(classToAdd);
          }
        } catch (e) {
          logger.warn('Personalization addClass failed:', e);
        }
      });
    }
  };
  
  // ═══════════════════════════════════════════════════════════════════════════
  // TILE-047: GLOBAL PERSONALIZATION INITIALIZATION
  // ═══════════════════════════════════════════════════════════════════════════
  
  /**
   * Initialize personalization hooks after LCP
   * All personalization is non-critical and should not block rendering
   */
  window.PerformanceCore.afterLCP(function() {
    try {
      // Ensure body has data-ritual attribute if state exists
      var state = window.VelunaRitualState && typeof window.VelunaRitualState.get === 'function'
        ? window.VelunaRitualState.get()
        : null;
      
      if (state && state.ritual && document.body) {
        document.body.setAttribute('data-ritual', state.ritual);
      }
      
      // Apply all personalization hooks
      applyPersonalizationHooks();
    } catch (e) {
      logger.warn('Personalization initialization failed:', e);
    }
  });
  
  /**
   * Apply all personalization hooks across the storefront
   */
  function applyPersonalizationHooks() {
    // Homepage Hero
    window.VelunaPersonalize.text('[data-pz="hero-eyebrow"]', function(state) {
      return 'Welcome back, ' + state.ritualName + ' Seeker.';
    });
    
    window.VelunaPersonalize.text('[data-pz="hero-cta-hint"]', function(state) {
      return 'Aligned with your ' + state.ritualName + ' rhythm';
    });
    
    // Value Proposition Section
    window.VelunaPersonalize.text('[data-pz="vp-hint"]', function(state) {
      return 'Most ' + state.ritualName + ' seekers love this.';
    });
    
    // PLP Filter Auto-open
    if (window.VelunaRitualState) {
      var plpState = window.VelunaRitualState.get();
      if (plpState && plpState.ritual) {
        var pill = document.querySelector('[data-ritual-pill="' + plpState.ritual + '"]');
        if (pill) {
          pill.classList.add('active');
        }
      }
    }
    
    // PDP Section
    window.VelunaPersonalize.text('[data-pz="pdp-cta-hint"]', function(state) {
      return 'Aligned with your ' + state.ritualName + ' Ritual';
    });
    
    window.VelunaPersonalize.text('[data-pz="pdp-ribbon-hint"]', function(state) {
      return 'Recommended for ' + state.ritualName + ' seekers';
    });
    
    // Cart Drawer
    window.VelunaPersonalize.text('[data-pz="cart-upsell"]', function(state) {
      return 'Complete your ' + state.ritualName + ' Ritual';
    });
    
    // Quiz Page (if returning)
    window.VelunaPersonalize.text('[data-pz="quiz-hero"]', function(state) {
      return 'Your ' + state.ritualName + ' alignment looks good today.';
    });
    
    // Footer
    window.VelunaPersonalize.text('[data-pz="footer-science"]', function(state) {
      return 'Explore ' + state.ritualName + ' science';
    });
    
    // TILE-048: Homepage Personalization Hooks
    window.VelunaPersonalize.text('[data-pz="home-hero-eyebrow"]', function(state) {
      return 'Welcome back, ' + state.ritualName + ' Seeker.';
    });
    
    window.VelunaPersonalize.text('[data-pz="home-vp-hint"]', function(state) {
      return 'Most ' + state.ritualName + ' seekers love this.';
    });
    
    window.VelunaPersonalize.text('[data-pz="home-three-blocks-cta-title"]', function(state) {
      return 'Your ' + state.ritualName + ' ritual awaits.';
    });
    
    window.VelunaPersonalize.text('[data-pz="home-ritual-showcase-hint"]', function(state) {
      return 'You\'re aligned with the ' + state.ritualName + ' Ritual.';
    });
    
    window.VelunaPersonalize.text('[data-pz="home-cta-band-title"]', function(state) {
      return 'Ready to deepen your ' + state.ritualName + ' Ritual?';
    });
    
    window.VelunaPersonalize.text('[data-pz="home-cta-band-hint"]', function(state) {
      return 'Complete your ' + state.ritualName + ' ritual journey.';
    });
    
    window.VelunaPersonalize.text('[data-pz="home-ingredient-banner-hint"]', function(state) {
      return 'Aligned with the ' + state.ritualName + ' Ritual\'s needs.';
    });
  }
  
  // Also subscribe to ritual state changes (in case state loads after page init)
  if (window.VelunaRitualState) {
    window.VelunaRitualState.subscribe(function(state) {
      if (state && state.ritual) {
        // Re-apply personalization when state changes
        applyPersonalizationHooks();
      }
    });
  }
  
  /**
   * TILE-050: Homepage Ritual-Aware Motion & Animation Engine (Wave 3)
   * 
   * HomeMotionController: Manages scroll-based reveal animations for homepage sections
   * Uses IntersectionObserver with PerformanceCore v2 integration
   * Respects prefers-reduced-motion and ritual-aware variants
   */
  var HomeMotionController = {
    observer: null,
    sections: [],
    prefersReducedMotion: false,
    
    /**
     * Check if user prefers reduced motion
     */
    checkReducedMotion: function() {
      try {
        this.prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      } catch (e) {
        this.prefersReducedMotion = false;
      }
    },
    
    /**
     * Initialize IntersectionObserver or fallback scroll listener
     */
    initObserver: function() {
      // Check for reduced motion first
      this.checkReducedMotion();
      
      // If reduced motion, mark all sections visible immediately
      if (this.prefersReducedMotion) {
        var sections = document.querySelectorAll('[data-home-motion]');
        for (var i = 0; i < sections.length; i++) {
          sections[i].classList.add('is-visible');
        }
        return;
      }
      
      // Check if IntersectionObserver is supported
      if (!('IntersectionObserver' in window)) {
        // Fallback to scroll listener via PerformanceCore
        this.initScrollFallback();
        return;
      }
      
      // Create IntersectionObserver with calm thresholds
      var options = {
        root: null,
        rootMargin: '0px 0px -100px 0px',  // Trigger slightly before entering viewport
        threshold: 0.1  // Trigger when 10% visible
      };
      
      var self = this;
      this.observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            // Unobserve once visible (performance optimization)
            self.observer.unobserve(entry.target);
          }
        });
      }, options);
      
      // Observe all sections
      var sections = document.querySelectorAll('[data-home-motion]');
      for (var i = 0; i < sections.length; i++) {
        this.observer.observe(sections[i]);
      }
    },
    
    /**
     * Fallback scroll listener (if IntersectionObserver not available)
     */
    initScrollFallback: function() {
      var self = this;
      var checkVisibility = function() {
        var sections = document.querySelectorAll('[data-home-motion]');
        var viewportHeight = window.innerHeight;
        
        for (var i = 0; i < sections.length; i++) {
          var section = sections[i];
          if (section.classList.contains('is-visible')) {
            continue;  // Already visible
          }
          
          var rect = section.getBoundingClientRect();
          // Check if section is in viewport (with offset)
          if (rect.top < viewportHeight - 100) {
            section.classList.add('is-visible');
          }
        }
      };
      
      // Use PerformanceCore.event for scroll handling
      if (window.PerformanceCore && window.PerformanceCore.event) {
        window.PerformanceCore.event('scroll', checkVisibility, { passive: true });
      } else {
        // Fallback to standard scroll listener
        window.addEventListener('scroll', checkVisibility, { passive: true });
      }
      
      // Check on initial load
      checkVisibility();
    },
    
    /**
     * Initialize HomeMotionController
     */
    init: function() {
      // Only run on homepage (check for homepage sections)
      var hasHomepageSections = document.querySelectorAll('[data-home-motion]').length > 0;
      if (!hasHomepageSections) {
        return;
      }
      
      // Check for reduced motion
      this.checkReducedMotion();
      
      // If reduced motion, mark sections visible immediately
      if (this.prefersReducedMotion) {
        var sections = document.querySelectorAll('[data-home-motion]');
        for (var i = 0; i < sections.length; i++) {
          sections[i].classList.add('is-visible');
        }
        return;
      }
      
      // Initialize observer or fallback
      this.initObserver();
    }
  };
  
  // Expose globally (optional, for debugging)
  window.HomeMotionController = HomeMotionController;
  
  // Initialize after LCP
  if (window.PerformanceCore) {
    window.PerformanceCore.afterLCP(function() {
      HomeMotionController.init();
    });
  } else {
    // Fallback if PerformanceCore not available
    if (document.readyState === 'complete') {
      HomeMotionController.init();
    } else {
      window.addEventListener('load', function() {
        HomeMotionController.init();
      });
    }
  }
  
  /**
   * TILE-051: Homepage Ritual-Aware PDP Pre-Personalization Bridge (Wave 4)
   * 
   * Soft Ritual Engine: Computes predictive ritual personalization based on
   * homepage intent signals (scroll, hover, clicks). Never overrides official
   * quiz results (hard state). Only activates if confidence ≥ 0.65.
   */
  
  /**
   * Ingredient → Ritual Mapping
   * Maps ingredients to ritual weights based on Veluna product formulations
   */
  var INGREDIENT_RITUAL_MAP = {
    'magnesium-glycinate': { mc: 0.1, dr: 0.3, ss: 0.1, cr: 0.1 },
    'magnesium': { mc: 0.1, dr: 0.3, ss: 0.1, cr: 0.1 },
    'ashwagandha': { mc: 0.3, dr: 0.1, ss: 0.2, cr: 0.1 },
    'gaba': { mc: 0.4, dr: 0.1, ss: 0.2, cr: 0.05 },
    'l-theanine': { mc: 0.4, dr: 0.05, ss: 0.15, cr: 0.1 },
    'theanine': { mc: 0.4, dr: 0.05, ss: 0.15, cr: 0.1 },
    'melatonin': { cr: 0.3, ss: 0.2, mc: 0.1, dr: 0.05 },
    'valerian': { ss: 0.3, mc: 0.2, dr: 0.1, cr: 0.1 },
    'chamomile': { ss: 0.3, mc: 0.15, dr: 0.05, cr: 0.1 }
  };
  
  /**
   * Soft Ritual State Manager
   * Manages predictive ritual personalization based on intent signals
   */
  var SoftRitualState = {
    weights: { mc: 0, dr: 0, ss: 0, cr: 0 },
    confidence: 0,
    ritual: null,
    subscribers: [],
    storageKey: 'veluna_soft_ritual_state',
    
    /**
     * Initialize soft ritual state from sessionStorage
     */
    init: function() {
      try {
        var stored = sessionStorage.getItem(this.storageKey);
        if (stored) {
          var data = JSON.parse(stored);
          this.weights = data.weights || { mc: 0, dr: 0, ss: 0, cr: 0 };
          this.confidence = data.confidence || 0;
          this.ritual = data.ritual || null;
        }
      } catch (e) {
        logger.warn('SoftRitualState: Failed to load from storage', e);
      }
    },
    
    /**
     * Add intent weight to a ritual
     */
    addWeight: function(ritual, weight) {
      if (this.weights[ritual] !== undefined) {
        this.weights[ritual] += weight;
        this.compute();
      }
    },
    
    /**
     * Add multiple weights at once (from ingredient map, etc.)
     */
    addWeights: function(weights) {
      for (var ritual in weights) {
        if (this.weights[ritual] !== undefined && weights[ritual]) {
          this.weights[ritual] += weights[ritual];
        }
      }
      this.compute();
    },
    
    /**
     * Compute soft ritual from accumulated weights
     * Rules:
     * - Never override official quiz result (hard state)
     * - Only activate if confidence ≥ 0.65
     * - Confidence = max weight / total weights
     */
    compute: function() {
      // Check if hard state (quiz result) exists
      var hardState = null;
      if (window.VelunaRitualState) {
        var hard = window.VelunaRitualState.get();
        if (hard && hard.ritual) {
          hardState = hard.ritual;
        }
      }
      
      // Never override hard state
      if (hardState) {
        this.ritual = null;
        this.confidence = 0;
        this.save();
        this.notify();
        return;
      }
      
      // Find max weight and total
      var maxWeight = 0;
      var totalWeight = 0;
      var maxRitual = null;
      
      for (var ritual in this.weights) {
        var weight = this.weights[ritual];
        totalWeight += weight;
        if (weight > maxWeight) {
          maxWeight = weight;
          maxRitual = ritual;
        }
      }
      
      // Compute confidence
      if (totalWeight > 0) {
        this.confidence = maxWeight / totalWeight;
      } else {
        this.confidence = 0;
      }
      
      // Only activate if confidence ≥ 0.65
      if (this.confidence >= 0.65 && maxRitual) {
        this.ritual = maxRitual;
      } else {
        this.ritual = null;
        this.confidence = 0;
      }
      
      this.save();
      this.notify();
    },
    
    /**
     * Save state to sessionStorage
     */
    save: function() {
      try {
        sessionStorage.setItem(this.storageKey, JSON.stringify({
          weights: this.weights,
          confidence: this.confidence,
          ritual: this.ritual,
          timestamp: Date.now()
        }));
      } catch (e) {
        logger.warn('SoftRitualState: Failed to save', e);
      }
    },
    
    /**
     * Get current soft ritual state
     */
    get: function() {
      return {
        ritual: this.ritual,
        confidence: this.confidence,
        weights: Object.assign({}, this.weights)
      };
    },
    
    /**
     * Subscribe to state changes
     */
    subscribe: function(fn) {
      if (typeof fn === 'function') {
        this.subscribers.push(fn);
      }
    },
    
    /**
     * Notify subscribers of state changes
     */
    notify: function() {
      var state = this.get();
      this.subscribers.forEach(function(fn) {
        try {
          fn(state);
        } catch (e) {
          logger.warn('SoftRitualState: Subscriber error', e);
        }
      });
    },
    
    /**
     * Reset all weights (for testing/debugging)
     */
    reset: function() {
      this.weights = { mc: 0, dr: 0, ss: 0, cr: 0 };
      this.confidence = 0;
      this.ritual = null;
      this.save();
      this.notify();
    }
  };
  
  /**
   * Intent Signal Tracker
   * Captures homepage interactions and converts them to ritual weights
   */
  var IntentTracker = {
    debounceTimers: {},
    debounceDelay: 300,  // ms
    
    /**
     * Initialize intent tracking on homepage
     */
    init: function() {
      // Only run on homepage
      var hasHomepageSections = document.querySelectorAll('[data-home-motion]').length > 0;
      if (!hasHomepageSections) {
        return;
      }
      
      // Initialize soft ritual state
      SoftRitualState.init();
      
      // Track ritual showcase interactions
      this.trackRitualShowcase();
      
      // Track ingredient banner interactions
      this.trackIngredientBanner();
      
      // Track CTA clicks
      this.trackCTAClicks();
      
      // Track scroll depth
      this.trackScrollDepth();
      
      // Update body attributes when soft state changes
      SoftRitualState.subscribe(function(state) {
        IntentTracker.updateBodyAttributes(state);
      });
      
      // Initial body update
      this.updateBodyAttributes(SoftRitualState.get());
    },
    
    /**
     * Track ritual showcase hover/click interactions
     */
    trackRitualShowcase: function() {
      var cards = document.querySelectorAll('[data-intent-ritual][data-intent-weight]');
      var self = this;
      
      cards.forEach(function(card) {
        var ritual = card.dataset.intentRitual;
        var weight = parseFloat(card.dataset.intentWeight) || 0;
        
        if (!ritual || !weight) return;
        
        // Hover tracking (debounced)
        card.addEventListener('mouseenter', function() {
          self.debouncedSignal(ritual, weight * 0.15, 'hover');
        }, { passive: true });
        
        // Click tracking
        card.addEventListener('click', function() {
          SoftRitualState.addWeight(ritual, weight);
        }, { passive: true });
      });
    },
    
    /**
     * Track ingredient banner interactions
     */
    trackIngredientBanner: function() {
      var ingredients = document.querySelectorAll('[data-intent-ingredient]');
      var self = this;
      
      ingredients.forEach(function(item) {
        var ingredientName = item.dataset.intentIngredient;
        
        if (!ingredientName) return;
        
        // Normalize ingredient name
        var normalized = ingredientName.toLowerCase()
          .replace(/\s+/g, '-')
          .replace(/[^a-z0-9-]/g, '');
        
        // Get ritual weights from map
        var weights = INGREDIENT_RITUAL_MAP[normalized];
        if (!weights) return;
        
        // Hover tracking (debounced)
        item.addEventListener('mouseenter', function() {
          self.debouncedSignal(null, 0, 'hover', weights);
        }, { passive: true });
        
        // Click tracking
        item.addEventListener('click', function() {
          SoftRitualState.addWeights(weights);
        }, { passive: true });
      });
    },
    
    /**
     * Track CTA clicks (hero, value prop, three blocks, CTA band)
     */
    trackCTAClicks: function() {
      var ctas = document.querySelectorAll('[data-intent-ritual][data-intent-weight]');
      var self = this;
      
      ctas.forEach(function(cta) {
        var ritual = cta.dataset.intentRitual;
        var weight = parseFloat(cta.dataset.intentWeight) || 0;
        
        if (!ritual || !weight) return;
        
        // Find button/link within CTA element
        var button = cta.querySelector('a, button, [role="button"]');
        if (!button) button = cta;
        
        button.addEventListener('click', function() {
          SoftRitualState.addWeight(ritual, weight);
        }, { passive: true });
      });
    },
    
    /**
     * Track scroll depth (adds weights based on sections viewed)
     */
    trackScrollDepth: function() {
      var self = this;
      var sections = document.querySelectorAll('[data-home-motion]');
      var viewedSections = new Set();
      
      if (!sections.length) return;
      
      // Use IntersectionObserver for scroll tracking
      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function(entries) {
          entries.forEach(function(entry) {
            if (entry.isIntersecting) {
              var section = entry.target;
              var sectionId = section.dataset.homeMotion;
              
              if (!viewedSections.has(sectionId)) {
                viewedSections.add(sectionId);
                
                // Add small weights based on section
                var weights = self.getScrollWeights(sectionId);
                if (weights) {
                  SoftRitualState.addWeights(weights);
                }
              }
            }
          });
        }, {
          root: null,
          rootMargin: '0px',
          threshold: 0.3  // 30% visible
        });
        
        sections.forEach(function(section) {
          observer.observe(section);
        });
      }
    },
    
    /**
     * Get ritual weights based on scroll depth section
     */
    getScrollWeights: function(sectionId) {
      // Small weights for viewing sections
      var weights = {
        'hero': { mc: 0.05, dr: 0.05, ss: 0.05, cr: 0.05 },
        'value-prop': { mc: 0.1, dr: 0.1, ss: 0.1, cr: 0.1 },
        'three-blocks': { mc: 0.1, dr: 0.1, ss: 0.1, cr: 0.1 },
        'ritual-grid': { mc: 0.1, dr: 0.1, ss: 0.1, cr: 0.1 },
        'ingredient-banner': { ss: 0.1, dr: 0.05, mc: 0.05, cr: 0.05 },
        'cta-band': { mc: 0.1, dr: 0.1, ss: 0.1, cr: 0.1 }
      };
      
      return weights[sectionId] || null;
    },
    
    /**
     * Debounced signal (prevents spam from rapid hovers)
     */
    debouncedSignal: function(ritual, weight, type, weights) {
      var key = ritual || 'ingredient-' + type;
      
      if (this.debounceTimers[key]) {
        clearTimeout(this.debounceTimers[key]);
      }
      
      var self = this;
      this.debounceTimers[key] = setTimeout(function() {
        if (weights) {
          SoftRitualState.addWeights(weights);
        } else if (ritual && weight) {
          SoftRitualState.addWeight(ritual, weight);
        }
        delete self.debounceTimers[key];
      }, this.debounceDelay);
    },
    
    /**
     * Update body attributes with soft ritual state
     */
    updateBodyAttributes: function(state) {
      if (!state || !state.ritual) {
        // Remove soft ritual attributes if no soft state
        if (document.body.hasAttribute('data-soft-ritual')) {
          document.body.removeAttribute('data-soft-ritual');
          document.body.removeAttribute('data-soft-confidence');
        }
        return;
      }
      
      // Only add soft ritual if no hard state (quiz result)
      var hardState = null;
      if (window.VelunaRitualState) {
        var hard = window.VelunaRitualState.get();
        if (hard && hard.ritual) {
          hardState = hard.ritual;
        }
      }
      
      if (!hardState) {
        document.body.setAttribute('data-soft-ritual', state.ritual);
        document.body.setAttribute('data-soft-confidence', state.confidence.toFixed(2));
      }
    }
  };
  
  /**
   * PDP Bridge: Update PDP with soft ritual attributes
   */
  var PDPBridge = {
    /**
     * Initialize PDP bridge (adds soft ritual attributes to PDP root)
     */
    init: function() {
      // Only run on product pages
      var isProductPage = document.body.classList.contains('template-product') ||
                          document.querySelector('.product') ||
                          window.location.pathname.includes('/products/');
      
      if (!isProductPage) return;
      
      // Get soft ritual state
      SoftRitualState.init();
      var softState = SoftRitualState.get();
      
      if (!softState || !softState.ritual) return;
      
      // Check if hard state exists (never override)
      var hardState = null;
      if (window.VelunaRitualState) {
        var hard = window.VelunaRitualState.get();
        if (hard && hard.ritual) {
          hardState = hard.ritual;
        }
      }
      
      // Only add soft ritual if no hard state
      if (!hardState && softState.ritual) {
        var productRoot = document.querySelector('[data-product-root], .product, main');
        if (productRoot) {
          productRoot.setAttribute('data-soft-ritual', softState.ritual);
          productRoot.setAttribute('data-soft-confidence', softState.confidence.toFixed(2));
        }
      }
    }
  };
  
  // Expose globally
  window.VelunaRitualPredict = SoftRitualState.weights;  // For debugging
  window.VelunaSoftRitualState = SoftRitualState;
  
  // Initialize after LCP
  if (window.PerformanceCore) {
    window.PerformanceCore.afterLCP(function() {
      // Intent tracking (homepage only)
      IntentTracker.init();
      
      // PDP bridge (product pages only)
      PDPBridge.init();
      
      // Subscribe to ritual state changes (update body attributes when hard state loads)
      if (window.VelunaRitualState) {
        window.VelunaRitualState.subscribe(function(state) {
          if (state && state.ritual) {
            // Hard state exists, remove soft ritual
            document.body.removeAttribute('data-soft-ritual');
            document.body.removeAttribute('data-soft-confidence');
          }
        });
      }
    });
  } else {
    // Fallback
    if (document.readyState === 'complete') {
      IntentTracker.init();
      PDPBridge.init();
    } else {
      window.addEventListener('load', function() {
        IntentTracker.init();
        PDPBridge.init();
      });
    }
  }
  
})();

// ═══════════════════════════════════════════════════════════════════════════
// TILE-052: PDP RITUAL-AWARE LAYOUT ENGINE (Wave 1: Section & Block Reordering)
// ═══════════════════════════════════════════════════════════════════════════

(function () {
  'use strict';
  
  if (!window.PerformanceCore) return;

  /**
   * PDP Layout Rules
   * Defines the ordering of blocks and sections for each ritual type
   */
  const PDP_LAYOUT_RULES = {
    mc: {
      secondaryInfoOrder: [
        'safety',
        'how_to',
        'social_proof',
        'ingredients',
        'science',
        'secondary_trust',
        'cta'
      ],
      neighborSectionsOrder: ['pdp-reviews', 'pdp-faq', 'pdp-cross-sell']
    },
    dr: {
      secondaryInfoOrder: [
        'ingredients',
        'science',
        'how_to',
        'secondary_trust',
        'safety',
        'social_proof',
        'cta'
      ],
      neighborSectionsOrder: ['pdp-reviews', 'pdp-cross-sell', 'pdp-faq']
    },
    ss: {
      secondaryInfoOrder: [
        'social_proof',
        'how_to',
        'ingredients',
        'safety',
        'science',
        'secondary_trust',
        'cta'
      ],
      neighborSectionsOrder: ['pdp-reviews', 'pdp-faq', 'pdp-cross-sell']
    },
    cr: {
      secondaryInfoOrder: [
        'how_to',
        'ingredients',
        'science',
        'cta',
        'secondary_trust',
        'safety',
        'social_proof'
      ],
      neighborSectionsOrder: ['pdp-faq', 'pdp-reviews', 'pdp-cross-sell']
    },
    default: {
      secondaryInfoOrder: [
        'ingredients',
        'how_to',
        'science',
        'safety',
        'social_proof',
        'secondary_trust',
        'cta'
      ],
      neighborSectionsOrder: ['pdp-reviews', 'pdp-faq', 'pdp-cross-sell']
    }
  };

  /**
   * PDP Layout Engine
   * Reorders blocks and sections based on ritual state
   */
  const PDPLayoutEngine = {
    /**
     * Initialize the layout engine
     */
    init() {
      try {
        const root = document.querySelector('[data-pdp-layout-root="secondary-info"]');
        if (!root) return;

        // Get ritual state (hard state takes precedence)
        const ritualState = (window.VelunaRitualState && window.VelunaRitualState.get && window.VelunaRitualState.get()) || null;
        const softState = (window.VelunaSoftRitualState && window.VelunaSoftRitualState.get && window.VelunaSoftRitualState.get()) || null;

        // Resolve ritual key
        const ritualKey = this.resolveRitualKey(ritualState, softState);
        const rules = PDP_LAYOUT_RULES[ritualKey] || PDP_LAYOUT_RULES.default;

        // Reorder blocks and sections
        this.reorderSecondaryInfo(root, rules.secondaryInfoOrder);
        this.reorderNeighborSections(rules.neighborSectionsOrder);
      } catch (e) {
        logger.warn('PDPLayoutEngine init error', e);
      }
    },

    /**
     * Resolve ritual key from hard and soft state
     * Priority: hard state > soft state (if confidence >= 0.65) > default
     */
    resolveRitualKey(hard, soft) {
      if (hard && hard.ritual) {
        // Normalize ritual key (e.g., 'mind-calm' -> 'mc')
        const ritual = hard.ritual.toLowerCase();
        if (ritual.includes('mind') || ritual === 'mc') return 'mc';
        if (ritual.includes('deep') || ritual === 'dr') return 'dr';
        if (ritual.includes('sacred') || ritual === 'ss') return 'ss';
        if (ritual.includes('circadian') || ritual === 'cr') return 'cr';
        return 'default';
      }
      
      if (soft && soft.ritual && soft.confidence >= 0.65) {
        // Normalize ritual key from soft state
        const ritual = soft.ritual.toLowerCase();
        if (ritual.includes('mind') || ritual === 'mc') return 'mc';
        if (ritual.includes('deep') || ritual === 'dr') return 'dr';
        if (ritual.includes('sacred') || ritual === 'ss') return 'ss';
        if (ritual.includes('circadian') || ritual === 'cr') return 'cr';
        return 'default';
      }
      
      return 'default';
    },

    /**
     * Reorder secondary info blocks
     */
    reorderSecondaryInfo(root, order) {
      const blocks = Array.from(root.querySelectorAll('[data-pdp-block]'));
      if (!blocks.length) return;

      // Create map of blocks by data-pdp-block value
      const map = new Map();
      blocks.forEach(block => {
        const key = block.getAttribute('data-pdp-block');
        if (key) {
          map.set(key, block);
        }
      });

      // Create document fragment with reordered blocks
      const frag = document.createDocumentFragment();
      
      // Add blocks in specified order (move from DOM to fragment)
      order.forEach(key => {
        const node = map.get(key);
        if (node && node.parentNode) {
          node.parentNode.removeChild(node);
          frag.appendChild(node);
          map.delete(key); // Remove from map so we don't duplicate
        }
      });

      // Append any leftover blocks (not in order array)
      map.forEach((node) => {
        if (node && node.parentNode) {
          node.parentNode.removeChild(node);
          frag.appendChild(node);
        }
      });

      // Append reordered blocks to root
      root.appendChild(frag);
    },

    /**
     * Reorder neighbor sections
     */
    reorderNeighborSections(order) {
      // Find container (try data-main-product-layout-root, then main, then body)
      const container = document.querySelector('[data-main-product-layout-root]') || 
                       document.querySelector('main') || 
                       document.body;
      
      if (!container) return;

      const sections = Array.from(container.querySelectorAll('[data-pdp-section]'));
      if (!sections.length) return;

      // Find the first section's parent (all sections should share same parent)
      const firstSection = sections[0];
      if (!firstSection || !firstSection.parentNode) return;

      const parent = firstSection.parentNode;

      // Create map of sections by data-pdp-section value
      const sectionMap = new Map();
      sections.forEach(section => {
        const key = section.getAttribute('data-pdp-section');
        if (key) {
          sectionMap.set(key, section);
        }
      });

      // Find insertion point (after pdp-secondary-info section, or after first section)
      const secondaryInfoRoot = document.querySelector('[data-pdp-layout-root="secondary-info"]');
      const secondaryInfoSection = secondaryInfoRoot ? secondaryInfoRoot.closest('section') : null;
      const insertionPoint = secondaryInfoSection || firstSection;

      // Find where to insert (after insertion point)
      const insertAfter = insertionPoint.nextSibling;

      // Create document fragment with reordered sections
      const orderedFrag = document.createDocumentFragment();
      
      // Add sections in specified order (remove from DOM, add to fragment)
      order.forEach(key => {
        const section = sectionMap.get(key);
        if (section && section.parentNode) {
          section.parentNode.removeChild(section);
          orderedFrag.appendChild(section);
          sectionMap.delete(key);
        }
      });

      // Add remaining sections (not in order array)
      sectionMap.forEach((section) => {
        if (section && section.parentNode) {
          section.parentNode.removeChild(section);
          orderedFrag.appendChild(section);
        }
      });

      // Insert reordered sections after insertion point
      if (insertAfter) {
        parent.insertBefore(orderedFrag, insertAfter);
      } else {
        parent.appendChild(orderedFrag);
      }
    }
  };

  // Expose globally
  window.PDPLayoutEngine = PDPLayoutEngine;
  window.PDP_LAYOUT_RULES = PDP_LAYOUT_RULES; // For debugging

  // Initialize after LCP (consolidated with other PDP engines in TILE-054)
  // Note: Actual initialization happens in TILE-054 section below

})();

// ═══════════════════════════════════════════════════════════════════════════
// TILE-053: PDP RITUAL-AWARE EDITORIAL ENGINE (Wave 2: Copy System)
// ═══════════════════════════════════════════════════════════════════════════

(function () {
  'use strict';
  
  if (!window.PerformanceCore) return;

  /**
   * PDP Editorial Copy Map
   * Ritual-aware editorial copy for each secondary-info block
   * Tone: Premium sleep ritual × neuroscience × quiet luxury × calm authority × editorial mystique
   */
  const PDP_EDITORIAL_COPY = {
    mc: {
      ingredients: {
        heading: 'Ingredients That Quiet Your Mind',
        copy: 'Evidence-backed nutrients that calm racing thoughts and support nervous system recovery. Gentle, non-drowsy, designed for anxious minds.'
      },
      how_to: {
        heading: 'Your Mind Calm Practice',
        copy: 'A simple evening ritual to help your nervous system settle. Take thirty minutes before bed, create calm space, let your body guide you.'
      },
      science: {
        heading: 'How Your Nervous System Responds',
        copy: 'These ingredients work with your body\'s natural calming mechanisms. L-Theanine supports alpha brain waves, magnesium supports GABA pathways, helping quiet mental chatter.'
      },
      safety: {
        heading: 'Gentle on Your System',
        copy: 'Non-drowsy, non-habit-forming, tested for purity. Safe for daily use, even if you\'re sensitive to supplements.'
      },
      social_proof: {
        heading: 'Trusted by Anxious Minds',
        copy: 'Real stories from people who found calm without sedation. Members report quieter thoughts, easier sleep, clearer mornings.'
      },
      secondary_trust: {
        heading: 'Certified, Transparent, Trusted',
        copy: 'Third-party tested supplements, ethically sourced, clean ingredients. Quality you can verify, every single night.'
      },
      cta: {
        heading: 'Start Your Mind Calm Practice',
        copy: 'Begin your nightly ritual tonight. Take the first step toward quieter thoughts and deeper rest.'
      }
    },
    dr: {
      ingredients: {
        heading: 'Recovery-Focused Ingredients',
        copy: 'Bioavailable nutrients designed for physical restoration. Magnesium glycinate for muscle repair, amino acids for deep tissue recovery, supporting your body\'s nightly restoration process.'
      },
      how_to: {
        heading: 'Your Deep Restore Practice',
        copy: 'Take thirty to sixty minutes before your target bedtime. Pair with gentle movement or stretching. Allow your body time to shift into recovery mode.'
      },
      science: {
        heading: 'How Physical Recovery Unfolds',
        copy: 'These ingredients support muscle repair, reduce inflammation, and enhance sleep quality. Magnesium glycinate is highly bioavailable, entering tissues where recovery happens.'
      },
      safety: {
        heading: 'Clean, Athlete-Tested Formula',
        copy: 'Clean ingredients, third-party tested, made in FDA-registered GMP-compliant facilities.'
      },
      social_proof: {
        heading: 'Trusted by Active Bodies',
        copy: 'Athletes and active individuals report deeper sleep, better recovery, reduced muscle tension. Real results from real people.'
      },
      secondary_trust: {
        heading: 'Performance-Grade Quality',
        copy: 'Third-party tested supplements, ethically sourced, clean ingredients.'
      },
      cta: {
        heading: 'Start Your Deep Restore Practice',
        copy: 'Elevate your recovery. Begin tonight and feel the difference in your morning restoration.'
      }
    },
    ss: {
      ingredients: {
        heading: 'Ingredients for Emotional Softness',
        copy: 'Calming botanicals and gentle nutrients that soothe anxious hearts. Chamomile, passionflower, L-Theanine-ingredients that support emotional regulation and self-care.'
      },
      how_to: {
        heading: 'Your Sacred Soothe Practice',
        copy: 'Create space for yourself an hour before bed. Take your ritual, dim lights, breathe. This is time for you, for softness, for landing safely at night.'
      },
      science: {
        heading: 'How Your Body Finds Calm',
        copy: 'These botanicals support parasympathetic activation-your body\'s rest-and-digest system. They help shift your nervous system from alert to calm, supporting emotional regulation.'
      },
      safety: {
        heading: 'Gentle, Nourishing, Safe',
        copy: 'All botanicals are well-researched, gentle on your system, safe for daily use. No interactions, no harsh side effects.'
      },
      social_proof: {
        heading: 'Trusted by Sensitive Hearts',
        copy: 'People who struggle with anxiety and overwhelm find solace here. Real stories of calm evenings, peaceful sleep, mornings that feel softer.'
      },
      secondary_trust: {
        heading: 'Quality That Honors Your Sensitivity',
        copy: 'Ethically sourced, third-party tested supplements, clean ingredients. Made with care for people who need gentleness.'
      },
      cta: {
        heading: 'Start Your Sacred Soothe Practice',
        copy: 'Give yourself permission to slow down. Begin tonight, create space for softness, for calm, for you.'
      }
    },
    cr: {
      ingredients: {
        heading: 'Rhythm-Supporting Ingredients',
        copy: 'Circadian-aligned nutrients that help reset your internal clock. Melatonin for timing signals, magnesium for rhythm support, helping your body find its natural sleep-wake cycle.'
      },
      how_to: {
        heading: 'Your Circadian Reset Practice',
        copy: 'Take at the same time each evening-consistency is everything. Choose your target bedtime, take thirty minutes before, maintain this rhythm for three to five days.'
      },
      science: {
        heading: 'How Circadian Rhythm Resets',
        copy: 'These ingredients signal your brain\'s master clock. Melatonin tells your body it\'s time to sleep, magnesium supports the deeper stages of rest, helping align your internal rhythm with your desired schedule.'
      },
      safety: {
        heading: 'Safe for Frequent Travel',
        copy: 'Non-habit-forming, gentle on your system, safe for temporary use. Perfect for jet lag, shift work, schedule resets.'
      },
      social_proof: {
        heading: 'Trusted by Travelers and Shift Workers',
        copy: 'Frequent flyers and night-shift workers report faster adaptation, easier schedule shifts, more predictable sleep.'
      },
      secondary_trust: {
        heading: 'Travel-Tested, Rhythm-Focused',
        copy: 'Third-party tested supplements, ethically sourced, designed for people who need rhythm support.'
      },
      cta: {
        heading: 'Start Your Circadian Reset Practice',
        copy: 'Reset your rhythm tonight. Take at your target bedtime, stay consistent, let your body adapt.'
      }
    },
    default: {
      ingredients: {
        heading: 'The Ritual Ingredients',
        copy: 'Clean, evidence-backed ingredients that support your nightly ritual. Gentle, non-drowsy, designed to work with your body\'s natural rhythms.'
      },
      how_to: {
        heading: 'Your Nightly Ritual in 3 Steps',
        copy: 'Take thirty minutes before bed, pair with calm cues, let your body guide you. A simple practice that supports deeper rest.'
      },
      science: {
        heading: 'Why This Ritual Works for Your Body',
        copy: 'Evidence-backed mechanisms that support deeper sleep. These ingredients work with your nervous system, supporting natural calming and recovery processes.'
      },
      safety: {
        heading: 'Safe, Gentle, Trusted',
        copy: 'Quality you can verify, every single night. Third-party tested supplements, ethically sourced, clean ingredients.'
      },
      social_proof: {
        heading: 'Loved by People Like You',
        copy: 'Real reviews from real members of the Veluna community. People who found deeper sleep, quieter minds, clearer mornings.'
      },
      secondary_trust: {
        heading: 'Quality You Can Feel Good About',
        copy: 'Certified, tested, and trusted by thousands. Non-drowsy, ethically sourced, clean ingredients.'
      },
      cta: {
        heading: 'Start Your Ritual Tonight',
        copy: 'Begin your nightly practice. Take the first step toward deeper sleep and clearer mornings.'
      }
    }
  };

  /**
   * PDP Editorial Engine
   * Applies ritual-aware editorial copy to secondary-info blocks
   */
  const PDPEditorialEngine = {
    /**
     * Resolve ritual key from hard and soft state
     * Priority: hard state > soft state (if confidence >= 0.65) > default
     */
    resolveRitualKey() {
      // Check for hard state (quiz result)
      if (window.VelunaRitualState && typeof window.VelunaRitualState.get === 'function') {
        const hardState = window.VelunaRitualState.get();
        if (hardState && hardState.ritual) {
          const ritual = hardState.ritual.toLowerCase();
          if (ritual.includes('mind') || ritual === 'mc') return 'mc';
          if (ritual.includes('deep') || ritual === 'dr') return 'dr';
          if (ritual.includes('sacred') || ritual === 'ss') return 'ss';
          if (ritual.includes('circadian') || ritual === 'cr') return 'cr';
        }
      }

      // Check for soft state (TILE-051) if confidence >= 0.65
      if (window.VelunaSoftRitualState && typeof window.VelunaSoftRitualState.get === 'function') {
        const softState = window.VelunaSoftRitualState.get();
        if (softState && softState.ritual && softState.confidence >= 0.65) {
          const ritual = softState.ritual.toLowerCase();
          if (ritual.includes('mind') || ritual === 'mc') return 'mc';
          if (ritual.includes('deep') || ritual === 'dr') return 'dr';
          if (ritual.includes('sacred') || ritual === 'ss') return 'ss';
          if (ritual.includes('circadian') || ritual === 'cr') return 'cr';
        }
      }

      return 'default';
    },

    /**
     * Apply editorial copy to all blocks
     */
    applyCopy() {
      try {
        const ritualKey = this.resolveRitualKey();
        const editorial = PDP_EDITORIAL_COPY[ritualKey] || PDP_EDITORIAL_COPY.default;
        if (!editorial) return;

        const root = document.querySelector('[data-pdp-layout-root="secondary-info"]');
        if (!root) return;

        // Block keys to process
        const blockKeys = ['ingredients', 'how_to', 'science', 'safety', 'social_proof', 'secondary_trust', 'cta'];

        blockKeys.forEach(blockKey => {
          if (!editorial[blockKey]) return;

          // Find block by data-pdp-block attribute
          const block = root.querySelector(`[data-pdp-block="${blockKey}"]`);
          if (!block) return;

          const blockCopy = editorial[blockKey];

          // Find heading element - priority order
          let headingEl = null;
          
          // Priority 1: Direct data-pdp-heading attribute
          headingEl = block.querySelector(`[data-pdp-heading="${blockKey}"]`);
          
          // Priority 2: Within data-pdp-heading-block container (for v-section-heading blocks)
          if (!headingEl) {
            const headingContainer = block.querySelector(`[data-pdp-heading-block="${blockKey}"]`);
            if (headingContainer) {
              headingEl = headingContainer.querySelector('.v-section-heading__title');
            }
          }
          
          // Priority 3: Fallback to any heading within block
          if (!headingEl) {
            headingEl = block.querySelector('.v-section-heading__title') || 
                       block.querySelector('.pdp-secondary-info__how-to-title') ||
                       block.querySelector(`[data-pdp-heading]`) ||
                       block.querySelector('h1, h2, h3, h4, h5, h6');
          }

          // Update heading if found
          if (headingEl && blockCopy.heading) {
            headingEl.textContent = blockCopy.heading;
          }

          // Find copy/subtitle element - priority order
          let copyEl = null;
          
          // Priority 1: Direct data-pdp-copy attribute
          copyEl = block.querySelector(`[data-pdp-copy="${blockKey}"]`);
          
          // Priority 2: Within data-pdp-heading-block container (for v-section-heading blocks)
          if (!copyEl) {
            const headingContainer = block.querySelector(`[data-pdp-heading-block="${blockKey}"]`);
            if (headingContainer) {
              copyEl = headingContainer.querySelector('.v-section-heading__subtitle');
            }
          }
          
          // Priority 3: Fallback to subtitle elements within block
          if (!copyEl) {
            copyEl = block.querySelector('.v-section-heading__subtitle') ||
                    block.querySelector('.pdp-secondary-info__how-to-subtitle') ||
                    block.querySelector(`[data-pdp-copy]`);
          }

          // Update copy if found
          if (copyEl && blockCopy.copy) {
            copyEl.textContent = blockCopy.copy;
          }
        });
      } catch (error) {
        logger.warn('[PDPEditorialEngine] Failed to apply PDP editorial copy', error);
      }
    },

    /**
     * Initialize the editorial engine
     */
    init() {
      if (typeof document === 'undefined') return;
      const root = document.querySelector('[data-pdp-layout-root="secondary-info"]');
      if (!root) return;
      this.applyCopy();
    }
  };

  // Expose globally
  window.PDPEditorialEngine = PDPEditorialEngine;
  window.PDP_EDITORIAL_COPY = PDP_EDITORIAL_COPY; // For debugging

  // Initialize after LCP (consolidated with other PDP engines in TILE-054)
  // Note: Actual initialization happens in TILE-054 section below

})();

// ═══════════════════════════════════════════════════════════════════════════
// TILE-054: PDP RITUAL-AWARE VISUAL ACCENT ENGINE (Wave 3: Visual Accents)
// ═══════════════════════════════════════════════════════════════════════════

(function () {
  'use strict';
  
  if (!window.PerformanceCore) return;

  /**
   * PDP Visual Accents Map
   * Ritual-aware visual accent tokens (borders, glow effects)
   * All values use CSS custom properties for token-driven styling
   */
  const PDP_VISUAL_ACCENTS = {
    mc: {
      border: 'var(--color-accent-mc-border, var(--color-accent))',
      glow: 'var(--color-accent-mc-glow, transparent)'
    },
    dr: {
      border: 'var(--color-accent-dr-border, var(--color-accent))',
      glow: 'var(--color-accent-dr-glow, transparent)'
    },
    ss: {
      border: 'var(--color-accent-ss-border, var(--color-accent))',
      glow: 'var(--color-accent-ss-glow, transparent)'
    },
    cr: {
      border: 'var(--color-accent-cr-border, var(--color-accent))',
      glow: 'var(--color-accent-cr-glow, transparent)'
    },
    default: {
      border: 'var(--color-border-subtle, var(--color-border-muted))',
      glow: 'transparent'
    }
  };

  /**
   * PDP Accent Engine
   * Applies ritual-aware visual accents to PDP blocks
   */
  const PDPAcentEngine = {
    /**
     * Resolve ritual key from hard and soft state
     * Priority: hard state > soft state (if confidence >= 0.65) > default
     * (Same logic as TILE-052 and TILE-053)
     */
    resolveRitualKey() {
      // Check for hard state (quiz result)
      if (window.VelunaRitualState && typeof window.VelunaRitualState.get === 'function') {
        const hardState = window.VelunaRitualState.get();
        if (hardState && hardState.ritual) {
          const ritual = hardState.ritual.toLowerCase();
          if (ritual.includes('mind') || ritual === 'mc') return 'mc';
          if (ritual.includes('deep') || ritual === 'dr') return 'dr';
          if (ritual.includes('sacred') || ritual === 'ss') return 'ss';
          if (ritual.includes('circadian') || ritual === 'cr') return 'cr';
        }
      }

      // Check for soft state (TILE-051) if confidence >= 0.65
      if (window.VelunaSoftRitualState && typeof window.VelunaSoftRitualState.get === 'function') {
        const softState = window.VelunaSoftRitualState.get();
        if (softState && softState.ritual && softState.confidence >= 0.65) {
          const ritual = softState.ritual.toLowerCase();
          if (ritual.includes('mind') || ritual === 'mc') return 'mc';
          if (ritual.includes('deep') || ritual === 'dr') return 'dr';
          if (ritual.includes('sacred') || ritual === 'ss') return 'ss';
          if (ritual.includes('circadian') || ritual === 'cr') return 'cr';
        }
      }

      return 'default';
    },

    /**
     * Apply visual accents to all blocks
     */
    applyAccents() {
      try {
        const ritualKey = this.resolveRitualKey();
        const accents = PDP_VISUAL_ACCENTS[ritualKey] || PDP_VISUAL_ACCENTS.default;
        if (!accents) return;

        // Find all blocks with data-pdp-accent attribute
        const blocks = document.querySelectorAll('[data-pdp-accent]');
        if (!blocks.length) return;

        blocks.forEach(block => {
          // Set CSS custom properties for accent styling
          block.style.setProperty('--pdp-accent-border', accents.border);
          block.style.setProperty('--pdp-accent-glow', accents.glow);
        });
      } catch (error) {
        logger.warn('[PDPAcentEngine] Failed to apply visual accents', error);
      }
    },

    /**
     * Initialize the accent engine
     */
    init() {
      if (typeof document === 'undefined') return;
      const root = document.querySelector('[data-pdp-layout-root="secondary-info"]');
      if (!root) return;
      this.applyAccents();
    }
  };

  // Expose globally
  window.PDPAcentEngine = PDPAcentEngine;
  window.PDP_VISUAL_ACCENTS = PDP_VISUAL_ACCENTS; // For debugging

  // Initialize all PDP engines after LCP (TILE-052, TILE-053, TILE-054, TILE-055)
  // Run in sequence: Layout → Editorial → Accents → Benefits
  window.PerformanceCore.afterLCP(() => {
    try {
      // TILE-052: Layout engine (reorders blocks/sections)
      if (window.PDPLayoutEngine && typeof window.PDPLayoutEngine.init === 'function') {
        window.PDPLayoutEngine.init();
      }
      // TILE-053: Editorial engine (updates headings/copy)
      if (window.PDPEditorialEngine && typeof window.PDPEditorialEngine.init === 'function') {
        window.PDPEditorialEngine.init();
      }
      // TILE-054: Accent engine (applies visual accents)
      if (PDPAcentEngine && typeof PDPAcentEngine.init === 'function') {
        PDPAcentEngine.init();
      }
      // TILE-055: Benefit engine (reorders and emphasizes benefits)
      if (window.PDPBenefitEngine && typeof window.PDPBenefitEngine.init === 'function') {
        window.PDPBenefitEngine.init();
      }
      // TILE-059: Trust engine (applies ritual-aware trust/objection copy)
      if (window.PDPTrustEngine && typeof window.PDPTrustEngine.init === 'function') {
        window.PDPTrustEngine.init();
      }
      // TILE-060: Micro-objection engine (applies ritual-aware micro-objection copy)
      if (window.PDPObjectionEngine && typeof window.PDPObjectionEngine.init === 'function') {
        window.PDPObjectionEngine.init();
      }
      // TILE-061: Price & Value engine (applies ritual-aware price/value framing)
      if (window.PDPPriceValueEngine && typeof window.PDPPriceValueEngine.init === 'function') {
        window.PDPPriceValueEngine.init();
      }
      // TILE-056: Motion engine (scroll reveals and animations)
      if (window.PDPMotionController && typeof window.PDPMotionController.init === 'function') {
        window.PDPMotionController.init();
      }
      // TILE-057: Ingredient engine (reorders and emphasizes ingredients)
      if (window.PDPIngredientEngine && typeof window.PDPIngredientEngine.init === 'function') {
        window.PDPIngredientEngine.init();
      }
      // TILE-058: CTA engine (applies ritual-aware CTA copy and emphasis)
      if (window.PDPCTAEngine && typeof window.PDPCTAEngine.init === 'function') {
        window.PDPCTAEngine.init();
      }
    } catch (error) {
      logger.warn('[GlobalInit] PDP engines init failed', error);
    }
  });

})();

// ═══════════════════════════════════════════════════════════════════════════
// TILE-055: PDP RITUAL-AWARE BENEFITS PRIORITIZATION ENGINE (Wave 5)
// ═══════════════════════════════════════════════════════════════════════════

(function () {
  'use strict';
  
  if (!window.PerformanceCore) return;

  /**
   * PDP Benefit Priorities Map
   * Ritual-aware weight multipliers for benefit prioritization
   * Values range from 0.2 (low priority) to 2.0 (high priority)
   */
  const PDP_BENEFIT_PRIORITIES = {
    mc: {
      stress_relief: 2.0,
      calm: 1.8,
      sleep_speed: 1.5,
      morning_clarity: 1.3,
      deep_sleep: 1.0,
      gentle_formula: 0.8,
      muscle_recovery: 0.5,
      inflammation: 0.3
    },
    dr: {
      muscle_recovery: 2.0,
      inflammation: 1.8,
      deep_sleep: 1.6,
      morning_clarity: 1.4,
      sleep_speed: 1.2,
      gentle_formula: 1.0,
      stress_relief: 0.7,
      calm: 0.5
    },
    ss: {
      stress_relief: 2.0,
      calm: 1.9,
      gentle_formula: 1.6,
      sleep_speed: 1.3,
      morning_clarity: 1.2,
      deep_sleep: 1.0,
      muscle_recovery: 0.4,
      inflammation: 0.3
    },
    cr: {
      sleep_speed: 2.0,
      morning_clarity: 1.8,
      deep_sleep: 1.5,
      gentle_formula: 1.2,
      stress_relief: 1.0,
      calm: 0.9,
      muscle_recovery: 0.5,
      inflammation: 0.4
    },
    default: {
      sleep_speed: 1.0,
      morning_clarity: 1.0,
      deep_sleep: 1.0,
      stress_relief: 1.0,
      calm: 1.0,
      gentle_formula: 1.0,
      muscle_recovery: 1.0,
      inflammation: 1.0
    }
  };

  /**
   * PDP Benefit Engine
   * Re-ranks, reorders, and visually emphasizes benefits based on ritual state
   */
  const PDPBenefitEngine = {
    /**
     * Resolve ritual key from hard and soft state
     * Priority: hard state > soft state (if confidence >= 0.65) > default
     * (Same logic as TILE-052, TILE-053, TILE-054)
     */
    resolveRitualKey() {
      // Check for hard state (quiz result)
      if (window.VelunaRitualState && typeof window.VelunaRitualState.get === 'function') {
        const hardState = window.VelunaRitualState.get();
        if (hardState && hardState.ritual) {
          const ritual = hardState.ritual.toLowerCase();
          if (ritual.includes('mind') || ritual === 'mc') return 'mc';
          if (ritual.includes('deep') || ritual === 'dr') return 'dr';
          if (ritual.includes('sacred') || ritual === 'ss') return 'ss';
          if (ritual.includes('circadian') || ritual === 'cr') return 'cr';
        }
      }

      // Check for soft state (TILE-051) if confidence >= 0.65
      if (window.VelunaSoftRitualState && typeof window.VelunaSoftRitualState.get === 'function') {
        const softState = window.VelunaSoftRitualState.get();
        if (softState && softState.ritual && softState.confidence >= 0.65) {
          const ritual = softState.ritual.toLowerCase();
          if (ritual.includes('mind') || ritual === 'mc') return 'mc';
          if (ritual.includes('deep') || ritual === 'dr') return 'dr';
          if (ritual.includes('sacred') || ritual === 'ss') return 'ss';
          if (ritual.includes('circadian') || ritual === 'cr') return 'cr';
        }
      }

      return 'default';
    },

    /**
     * Collect all benefit items from the page
     */
    collectBenefits() {
      const benefitGroups = document.querySelectorAll('[data-pdp-benefit-group]');
      const allBenefits = [];

      benefitGroups.forEach(group => {
        const items = group.querySelectorAll('[data-pdp-benefit]');
        items.forEach(item => {
          const key = item.getAttribute('data-pdp-benefit');
          const baseWeight = parseFloat(item.getAttribute('data-pdp-benefit-weight')) || 1.0;
          
          if (key) {
            allBenefits.push({
              element: item,
              key: key,
              baseWeight: baseWeight,
              group: group
            });
          }
        });
      });

      return allBenefits;
    },

    /**
     * Score benefits based on ritual priorities
     */
    scoreBenefits(benefits, ritualKey) {
      const priorities = PDP_BENEFIT_PRIORITIES[ritualKey] || PDP_BENEFIT_PRIORITIES.default;
      
      return benefits.map(benefit => {
        const multiplier = priorities[benefit.key] || 1.0;
        const score = benefit.baseWeight * multiplier;
        
        return {
          ...benefit,
          score: score,
          multiplier: multiplier
        };
      });
    },

    /**
     * Reorder benefits by score (descending)
     */
    reorderBenefits(scoredBenefits) {
      // Group by benefit group
      const groups = new Map();
      
      scoredBenefits.forEach(benefit => {
        const groupId = benefit.group.getAttribute('data-pdp-benefit-group') || 'default';
        if (!groups.has(groupId)) {
          groups.set(groupId, []);
        }
        groups.get(groupId).push(benefit);
      });

      // Reorder within each group
      groups.forEach((benefits, groupId) => {
        // Sort by score (descending)
        benefits.sort((a, b) => b.score - a.score);
        
        // Reorder DOM nodes (use DOM move, not innerHTML)
        const group = benefits[0].group;
        const fragment = document.createDocumentFragment();
        
        // Move elements to fragment (removes from DOM automatically)
        benefits.forEach(benefit => {
          fragment.appendChild(benefit.element);
        });
        
        // Append fragment to group (moves all nodes at once)
        group.appendChild(fragment);
      });
    },

    /**
     * Apply visual emphasis classes to top-ranked benefits
     */
    emphasizeBenefits(scoredBenefits) {
      // Group by benefit group
      const groups = new Map();
      
      scoredBenefits.forEach(benefit => {
        const groupId = benefit.group.getAttribute('data-pdp-benefit-group') || 'default';
        if (!groups.has(groupId)) {
          groups.set(groupId, []);
        }
        groups.get(groupId).push(benefit);
      });

      // Apply emphasis classes within each group
      groups.forEach((benefits, groupId) => {
        // Sort by score (descending)
        benefits.sort((a, b) => b.score - a.score);
        
        benefits.forEach((benefit, index) => {
          // Remove existing emphasis classes
          benefit.element.classList.remove('pdp-benefit-top', 'pdp-benefit-mid', 'pdp-benefit-low');
          
          // Apply new class based on rank
          if (index === 0) {
            benefit.element.classList.add('pdp-benefit-top');
          } else if (index === 1) {
            benefit.element.classList.add('pdp-benefit-mid');
          } else if (index === 2) {
            benefit.element.classList.add('pdp-benefit-mid');
          } else {
            benefit.element.classList.add('pdp-benefit-low');
          }
        });
      });
    },

    /**
     * Apply benefit prioritization
     */
    applyPrioritization() {
      try {
        const ritualKey = this.resolveRitualKey();
        const benefits = this.collectBenefits();
        
        if (!benefits.length) return;
        
        const scoredBenefits = this.scoreBenefits(benefits, ritualKey);
        this.reorderBenefits(scoredBenefits);
        this.emphasizeBenefits(scoredBenefits);
      } catch (error) {
        logger.warn('[PDPBenefitEngine] Failed to prioritize benefits', error);
      }
    },

    /**
     * Initialize the benefit engine
     */
    init() {
      if (typeof document === 'undefined') return;
      this.applyPrioritization();
    }
  };

  // Expose globally
  window.PDPBenefitEngine = PDPBenefitEngine;
  window.PDP_BENEFIT_PRIORITIES = PDP_BENEFIT_PRIORITIES; // For debugging

})();

// ═══════════════════════════════════════════════════════════════════════════
// TILE-056: PDP RITUAL-AWARE MOTION & ANIMATION ENGINE (Wave 6)
// ═══════════════════════════════════════════════════════════════════════════

(function () {
  'use strict';
  
  if (!window.PerformanceCore) return;

  /**
   * PDPMotionController: Manages scroll-based reveal animations for PDP sections
   * Uses IntersectionObserver with PerformanceCore v2 integration
   * Respects prefers-reduced-motion and ritual-aware variants
   * Follows same pattern as HomeMotionController (TILE-050)
   */
  const PDPMotionController = {
    observer: null,
    sections: [],
    prefersReducedMotion: false,
    
    /**
     * Check if user prefers reduced motion
     */
    checkReducedMotion() {
      try {
        this.prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      } catch (e) {
        this.prefersReducedMotion = false;
      }
    },
    
    /**
     * Initialize IntersectionObserver or fallback scroll listener
     */
    initObserver() {
      // Check for reduced motion first
      this.checkReducedMotion();
      
      // If reduced motion, mark all sections visible immediately
      if (this.prefersReducedMotion) {
        const sections = document.querySelectorAll('[data-pdp-motion]');
        for (let i = 0; i < sections.length; i++) {
          sections[i].classList.add('is-visible');
        }
        return;
      }
      
      // Check if IntersectionObserver is supported
      if (!('IntersectionObserver' in window)) {
        // Fallback to scroll listener via PerformanceCore
        this.initScrollFallback();
        return;
      }
      
      // Create IntersectionObserver with calm thresholds
      const options = {
        root: null,
        rootMargin: '0px 0px -100px 0px',  // Trigger slightly before entering viewport
        threshold: 0.1  // Trigger when 10% visible
      };
      
      const self = this;
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            // Unobserve once visible (performance optimization)
            self.observer.unobserve(entry.target);
          }
        });
      }, options);
      
      // Observe all PDP motion sections
      const sections = document.querySelectorAll('[data-pdp-motion]');
      for (let i = 0; i < sections.length; i++) {
        this.observer.observe(sections[i]);
      }
    },
    
    /**
     * Fallback scroll listener (if IntersectionObserver not available)
     */
    initScrollFallback() {
      const self = this;
      const checkVisibility = () => {
        const sections = document.querySelectorAll('[data-pdp-motion]');
        const viewportHeight = window.innerHeight;
        
        for (let i = 0; i < sections.length; i++) {
          const section = sections[i];
          if (section.classList.contains('is-visible')) {
            continue;  // Already visible
          }
          
          const rect = section.getBoundingClientRect();
          // Check if section is in viewport (with offset)
          if (rect.top < viewportHeight - 100) {
            section.classList.add('is-visible');
          }
        }
      };
      
      // Use PerformanceCore.event for scroll handling
      if (window.PerformanceCore && window.PerformanceCore.event) {
        window.PerformanceCore.event('scroll', checkVisibility, { passive: true });
      } else {
        // Fallback to standard scroll listener
        window.addEventListener('scroll', checkVisibility, { passive: true });
      }
      
      // Check on initial load
      checkVisibility();
    },
    
    /**
     * Initialize PDPMotionController
     */
    init() {
      // Only run on PDP (check for PDP motion sections)
      const hasPDPSections = document.querySelectorAll('[data-pdp-motion]').length > 0;
      if (!hasPDPSections) {
        return;
      }
      
      // Check for reduced motion
      this.checkReducedMotion();
      
      // If reduced motion, mark sections visible immediately
      if (this.prefersReducedMotion) {
        const sections = document.querySelectorAll('[data-pdp-motion]');
        for (let i = 0; i < sections.length; i++) {
          sections[i].classList.add('is-visible');
        }
        return;
      }
      
      // Initialize observer or fallback
      this.initObserver();
    }
  };
  
  // Expose globally (for debugging and integration)
  window.PDPMotionController = PDPMotionController;

})();

// ═══════════════════════════════════════════════════════════════════════════
// TILE-057: PDP RITUAL-AWARE INGREDIENT SPOTLIGHT ENGINE (Wave 7)
// ═══════════════════════════════════════════════════════════════════════════

(function () {
  'use strict';
  
  if (!window.PerformanceCore) return;

  /**
   * PDP Ingredient Priorities Map
   * Ritual-aware weight multipliers for ingredient prioritization
   * Values range from 0.2 (low priority) to 2.0 (high priority)
   */
  const PDP_INGREDIENT_PRIORITIES = {
    mc: {
      ashwagandha: 2.0,
      gaba: 1.8,
      theanine: 1.7,
      chamomile: 1.4,
      magnesium: 1.2,
      valerian: 1.0,
      melatonin: 0.5,
      'l-glycine': 0.8
    },
    dr: {
      magnesium: 2.0,
      'l-glycine': 1.7,
      valerian: 1.5,
      theanine: 1.3,
      gaba: 1.1,
      chamomile: 1.0,
      ashwagandha: 0.8,
      melatonin: 0.4
    },
    ss: {
      chamomile: 2.0,
      ashwagandha: 1.8,
      gaba: 1.6,
      valerian: 1.5,
      theanine: 1.3,
      magnesium: 1.0,
      melatonin: 0.5,
      'l-glycine': 0.7
    },
    cr: {
      melatonin: 2.0,
      theanine: 1.8,
      magnesium: 1.5,
      gaba: 1.3,
      chamomile: 1.2,
      ashwagandha: 0.9,
      valerian: 1.0,
      'l-glycine': 1.1
    },
    default: {
      magnesium: 1.0,
      ashwagandha: 1.0,
      gaba: 1.0,
      theanine: 1.0,
      chamomile: 1.0,
      valerian: 1.0,
      melatonin: 1.0,
      'l-glycine': 1.0
    }
  };

  /**
   * PDP Ingredient Engine
   * Re-ranks, reorders, and visually emphasizes ingredients based on ritual state
   */
  const PDPIngredientEngine = {
    /**
     * Resolve ritual key from hard and soft state
     * Priority: hard state > soft state (if confidence >= 0.65) > default
     * (Same logic as TILE-052, TILE-053, TILE-054, TILE-055)
     */
    resolveRitualKey() {
      // Check for hard state (quiz result)
      if (window.VelunaRitualState && typeof window.VelunaRitualState.get === 'function') {
        const hardState = window.VelunaRitualState.get();
        if (hardState && hardState.ritual) {
          const ritual = hardState.ritual.toLowerCase();
          if (ritual.includes('mind') || ritual === 'mc') return 'mc';
          if (ritual.includes('deep') || ritual === 'dr') return 'dr';
          if (ritual.includes('sacred') || ritual === 'ss') return 'ss';
          if (ritual.includes('circadian') || ritual === 'cr') return 'cr';
        }
      }

      // Check for soft state (TILE-051) if confidence >= 0.65
      if (window.VelunaSoftRitualState && typeof window.VelunaSoftRitualState.get === 'function') {
        const softState = window.VelunaSoftRitualState.get();
        if (softState && softState.ritual && softState.confidence >= 0.65) {
          const ritual = softState.ritual.toLowerCase();
          if (ritual.includes('mind') || ritual === 'mc') return 'mc';
          if (ritual.includes('deep') || ritual === 'dr') return 'dr';
          if (ritual.includes('sacred') || ritual === 'ss') return 'ss';
          if (ritual.includes('circadian') || ritual === 'cr') return 'cr';
        }
      }

      return 'default';
    },

    /**
     * Collect all ingredient items from the page
     */
    collectIngredients() {
      const ingredientGroups = document.querySelectorAll('[data-pdp-ingredient-group]');
      const allIngredients = [];

      ingredientGroups.forEach(group => {
        const items = group.querySelectorAll('[data-pdp-ingredient]');
        items.forEach(item => {
          const key = item.getAttribute('data-pdp-ingredient');
          const baseWeight = parseFloat(item.getAttribute('data-pdp-ingredient-weight')) || 1.0;
          
          if (key) {
            allIngredients.push({
              element: item,
              key: key,
              baseWeight: baseWeight,
              group: group
            });
          }
        });
      });

      return allIngredients;
    },

    /**
     * Score ingredients based on ritual priorities
     */
    scoreIngredients(ingredients, ritualKey) {
      const priorities = PDP_INGREDIENT_PRIORITIES[ritualKey] || PDP_INGREDIENT_PRIORITIES.default;
      
      return ingredients.map(ingredient => {
        const multiplier = priorities[ingredient.key] || 1.0;
        const score = ingredient.baseWeight * multiplier;
        
        return {
          ...ingredient,
          score: score,
          multiplier: multiplier
        };
      });
    },

    /**
     * Reorder ingredients by score (descending)
     */
    reorderIngredients(scoredIngredients) {
      // Group by ingredient group
      const groups = new Map();
      
      scoredIngredients.forEach(ingredient => {
        const groupId = ingredient.group.getAttribute('data-pdp-ingredient-group') || 'default';
        if (!groups.has(groupId)) {
          groups.set(groupId, []);
        }
        groups.get(groupId).push(ingredient);
      });

      // Reorder within each group
      groups.forEach((ingredients, groupId) => {
        // Sort by score (descending)
        ingredients.sort((a, b) => b.score - a.score);
        
        // Reorder DOM nodes (use DOM move, not innerHTML)
        const group = ingredients[0].group;
        const fragment = document.createDocumentFragment();
        
        // Move elements to fragment (removes from DOM automatically)
        ingredients.forEach(ingredient => {
          fragment.appendChild(ingredient.element);
        });
        
        // Append fragment to group (moves all nodes at once)
        group.appendChild(fragment);
      });
    },

    /**
     * Apply visual emphasis classes to top-ranked ingredients
     */
    emphasizeIngredients(scoredIngredients) {
      // Group by ingredient group
      const groups = new Map();
      
      scoredIngredients.forEach(ingredient => {
        const groupId = ingredient.group.getAttribute('data-pdp-ingredient-group') || 'default';
        if (!groups.has(groupId)) {
          groups.set(groupId, []);
        }
        groups.get(groupId).push(ingredient);
      });

      // Apply emphasis classes within each group
      groups.forEach((ingredients, groupId) => {
        // Sort by score (descending)
        ingredients.sort((a, b) => b.score - a.score);
        
        ingredients.forEach((ingredient, index) => {
          // Find the ingredient card or item element
          let targetElement = ingredient.element;
          
          // If it's a wrapper div, find the inner card
          const card = ingredient.element.querySelector('.pdp-ingredient-card') || 
                      ingredient.element.querySelector('.pdp-ingredient-item');
          if (card) {
            targetElement = card;
          }
          
          // Remove existing emphasis classes
          targetElement.classList.remove('pdp-ingredient-top', 'pdp-ingredient-mid', 'pdp-ingredient-low');
          
          // Apply new class based on rank
          if (index === 0) {
            targetElement.classList.add('pdp-ingredient-top');
          } else if (index === 1) {
            targetElement.classList.add('pdp-ingredient-mid');
          } else if (index === 2) {
            targetElement.classList.add('pdp-ingredient-mid');
          } else {
            targetElement.classList.add('pdp-ingredient-low');
          }
        });
      });
    },

    /**
     * Apply ingredient prioritization
     */
    applyPrioritization() {
      try {
        const ritualKey = this.resolveRitualKey();
        const ingredients = this.collectIngredients();
        
        if (!ingredients.length) return;
        
        const scoredIngredients = this.scoreIngredients(ingredients, ritualKey);
        this.reorderIngredients(scoredIngredients);
        this.emphasizeIngredients(scoredIngredients);
      } catch (error) {
        logger.warn('[PDPIngredientEngine] Failed to prioritize ingredients', error);
      }
    },

    /**
     * Initialize the ingredient engine
     */
    init() {
      if (typeof document === 'undefined') return;
      this.applyPrioritization();
    }
  };

  // Expose globally
  window.PDPIngredientEngine = PDPIngredientEngine;
  window.PDP_INGREDIENT_PRIORITIES = PDP_INGREDIENT_PRIORITIES; // For debugging

})();

// ═══════════════════════════════════════════════════════════════════════════
// TILE-058: PDP RITUAL-AWARE CTA ENGINE (Wave 7)
// ═══════════════════════════════════════════════════════════════════════════

(function () {
  'use strict';
  
  if (!window.PerformanceCore) return;

  /**
   * PDP CTA Copy Map
   * Ritual-aware CTA text for primary and secondary CTAs
   * Tone: Premium sleep ritual × calm authority × editorial excellence
   */
  const PDP_CTA_COPY = {
    mc: {
      primary: 'Start My Mind Calm Practice',
      secondary: 'Find My Ritual First'
    },
    dr: {
      primary: 'Start My Deep Restore Practice',
      secondary: 'Find My Ritual First'
    },
    ss: {
      primary: 'Start My Sacred Soothe Practice',
      secondary: 'Find My Ritual First'
    },
    cr: {
      primary: 'Start My Circadian Reset Practice',
      secondary: 'Find My Ritual First'
    },
    default: {
      primary: 'Start My Ritual',
      secondary: 'Find My Ritual First'
    }
  };

  /**
   * PDP CTA Engine
   * Applies ritual-aware CTA copy and visual emphasis based on ritual state
   */
  const PDPCTAEngine = {
    /**
     * Resolve ritual key from hard and soft state
     * Priority: hard state > soft state (if confidence >= 0.65) > default
     * (Same logic as TILE-052, TILE-053, TILE-054, TILE-055, TILE-056, TILE-057)
     */
    resolveRitualKey() {
      // Check for hard state (quiz result)
      if (window.VelunaRitualState && typeof window.VelunaRitualState.get === 'function') {
        const hardState = window.VelunaRitualState.get();
        if (hardState && hardState.ritual) {
          const ritual = hardState.ritual.toLowerCase();
          if (ritual.includes('mind') || ritual === 'mc') return 'mc';
          if (ritual.includes('deep') || ritual === 'dr') return 'dr';
          if (ritual.includes('sacred') || ritual === 'ss') return 'ss';
          if (ritual.includes('circadian') || ritual === 'cr') return 'cr';
        }
      }

      // Check for soft state (TILE-051) if confidence >= 0.65
      if (window.VelunaSoftRitualState && typeof window.VelunaSoftRitualState.get === 'function') {
        const softState = window.VelunaSoftRitualState.get();
        if (softState && softState.ritual && softState.confidence >= 0.65) {
          const ritual = softState.ritual.toLowerCase();
          if (ritual.includes('mind') || ritual === 'mc') return 'mc';
          if (ritual.includes('deep') || ritual === 'dr') return 'dr';
          if (ritual.includes('sacred') || ritual === 'ss') return 'ss';
          if (ritual.includes('circadian') || ritual === 'cr') return 'cr';
        }
      }

      return 'default';
    },

    /**
     * Collect all CTA elements from the page
     */
    collectCTAs() {
      const ctaGroups = document.querySelectorAll('[data-pdp-cta-group]');
      const allCTAs = [];

      ctaGroups.forEach(group => {
        const items = group.querySelectorAll('[data-pdp-cta]');
        items.forEach(item => {
          const ctaType = item.getAttribute('data-pdp-cta');
          const defaultCopy = item.getAttribute('data-pdp-cta-copy') || '';
          
          if (ctaType) {
            allCTAs.push({
              element: item,
              type: ctaType,
              defaultCopy: defaultCopy,
              group: group
            });
          }
        });
      });

      return allCTAs;
    },

    /**
     * Apply ritual-aware CTA copy
     */
    applyCopy() {
      try {
        const ritualKey = this.resolveRitualKey();
        const ctaCopy = PDP_CTA_COPY[ritualKey] || PDP_CTA_COPY.default;
        if (!ctaCopy) return;

        const ctas = this.collectCTAs();
        if (!ctas.length) return;

        ctas.forEach(cta => {
          const targetElement = cta.element;
          const newCopy = ctaCopy[cta.type] || cta.defaultCopy;
          
          if (!newCopy) return;
          
          // Find the text content element (usually <span> inside button/link)
          const textElement = targetElement.querySelector('span');
          
          if (textElement) {
            // Update textContent only (DOM-safe, no innerHTML)
            // Preserve any icons that may be siblings
            textElement.textContent = newCopy;
          } else {
            // Fallback: update button/link text directly if no span found
            // Only update if element contains text nodes (preserve structure)
            const existingText = targetElement.textContent.trim();
            if (existingText && (targetElement.tagName === 'BUTTON' || targetElement.tagName === 'A')) {
              // Find first text node and replace it
              let textNodeFound = false;
              Array.from(targetElement.childNodes).forEach(node => {
                if (node.nodeType === Node.TEXT_NODE && !textNodeFound) {
                  node.textContent = newCopy;
                  textNodeFound = true;
                }
              });
              
              // If no text node found, create a span with the new copy
              if (!textNodeFound) {
                const span = document.createElement('span');
                span.textContent = newCopy;
                // Insert before first non-text node (preserve icons)
                const firstElement = targetElement.querySelector('svg, [class*="icon"], .v-icon');
                if (firstElement) {
                  targetElement.insertBefore(span, firstElement);
                } else {
                  targetElement.appendChild(span);
                }
              }
            }
          }
        });
      } catch (error) {
        logger.warn('[PDPCTAEngine] Failed to apply CTA copy', error);
      }
    },

    /**
     * Apply visual emphasis to primary CTAs
     */
    emphasizePrimary() {
      try {
        const ritualKey = this.resolveRitualKey();
        if (ritualKey === 'default') return; // Only emphasize if ritual state exists

        const ctas = this.collectCTAs();
        if (!ctas.length) return;

        ctas.forEach(cta => {
          if (cta.type === 'primary') {
            // Add ritual-aware class to primary CTA
            cta.element.classList.add('pdp-cta-primary-ritual');
          }
        });
      } catch (error) {
        logger.warn('[PDPCTAEngine] Failed to emphasize primary CTA', error);
      }
    },

    /**
     * Apply CTA personalization
     */
    applyPersonalization() {
      try {
        this.applyCopy();
        this.emphasizePrimary();
      } catch (error) {
        logger.warn('[PDPCTAEngine] Failed to personalize CTAs', error);
      }
    },

    /**
     * Initialize the CTA engine
     */
    init() {
      if (typeof document === 'undefined') return;
      this.applyPersonalization();
    }
  };

  // Expose globally
  window.PDPCTAEngine = PDPCTAEngine;
  window.PDP_CTA_COPY = PDP_CTA_COPY; // For debugging

})();

// ═══════════════════════════════════════════════════════════════════════════
// TILE-059: PDP RITUAL-AWARE TRUST & OBJECTION ENGINE (Wave 8)
// ═══════════════════════════════════════════════════════════════════════════

(function () {
  'use strict';
  
  if (!window.PerformanceCore) return;

  /**
   * PDP Trust Copy Map
   * Ritual-aware trust and objection messaging
   * Tone: Premium sleep ritual × calm authority × editorial excellence
   */
  const PDP_TRUST_COPY = {
    default: {
      primary: {
        guarantee: { line: 'Free shipping · 30-day renewal guarantee' },
        safety: { line: 'Non-drowsy, gentle formula' },
        science: { line: 'Designed for nightly use' }
      },
      secondary: {
        safety_block: {
          heading: 'Safe, Gentle, Trusted',
          body: 'Quality you can feel good about, every single night.'
        },
        science_block: {
          heading: 'Why This Ritual Works for Your Body',
          body: 'Evidence-backed mechanisms that support deeper sleep.'
        },
        social_proof_block: {
          heading: 'Loved by People Like You',
          body: 'Real reviews from real members of the Veluna community.'
        }
      }
    },
    mc: {
      primary: {
        guarantee: { line: 'Free shipping · 30-day renewal guarantee' },
        safety: { line: 'Non-drowsy, supports calm mind' },
        science: { line: 'Designed to quiet racing thoughts' }
      },
      secondary: {
        safety_block: {
          heading: 'Safe, Gentle, Trusted',
          body: 'Quality you can feel good about, every single night. Supports mental calm without next-day fog.'
        },
        science_block: {
          heading: 'Why This Ritual Works for Your Mind',
          body: 'Evidence-backed mechanisms that support mental calm and reduce stress-related sleep disruption.'
        },
        social_proof_block: {
          heading: 'Loved by People Like You',
          body: 'Real reviews from real members of the Veluna community who value calm, focused sleep.'
        }
      }
    },
    dr: {
      primary: {
        guarantee: { line: 'Free shipping · 30-day renewal guarantee' },
        safety: { line: 'Non-drowsy, supports physical recovery' },
        science: { line: 'Designed for deep restorative sleep' }
      },
      secondary: {
        safety_block: {
          heading: 'Safe, Gentle, Trusted',
          body: 'Quality you can feel good about, every single night. Supports physical recovery without dependency.'
        },
        science_block: {
          heading: 'Why This Ritual Works for Your Body',
          body: 'Evidence-backed mechanisms that support deep sleep and physical restoration through the night.'
        },
        social_proof_block: {
          heading: 'Loved by People Like You',
          body: 'Real reviews from real members of the Veluna community who value deep, restorative sleep.'
        }
      }
    },
    ss: {
      primary: {
        guarantee: { line: 'Free shipping · 30-day renewal guarantee' },
        safety: { line: 'Non-drowsy, supports emotional calm' },
        science: { line: 'Designed for gentle nightly ritual' }
      },
      secondary: {
        safety_block: {
          heading: 'Safe, Gentle, Trusted',
          body: 'Quality you can feel good about, every single night. Supports emotional calm and gentle relaxation.'
        },
        science_block: {
          heading: 'Why This Ritual Works for Your Well-Being',
          body: 'Evidence-backed mechanisms that support emotional balance and gentle sleep onset.'
        },
        social_proof_block: {
          heading: 'Loved by People Like You',
          body: 'Real reviews from real members of the Veluna community who value gentle, emotionally supportive sleep.'
        }
      }
    },
    cr: {
      primary: {
        guarantee: { line: 'Free shipping · 30-day renewal guarantee' },
        safety: { line: 'Non-drowsy, supports circadian rhythm' },
        science: { line: 'Designed to align your sleep cycle' }
      },
      secondary: {
        safety_block: {
          heading: 'Safe, Gentle, Trusted',
          body: 'Quality you can feel good about, every single night. Supports natural circadian rhythm without disruption.'
        },
        science_block: {
          heading: 'Why This Ritual Works for Your Sleep Cycle',
          body: 'Evidence-backed mechanisms that support circadian alignment and natural sleep-wake rhythm.'
        },
        social_proof_block: {
          heading: 'Loved by People Like You',
          body: 'Real reviews from real members of the Veluna community who value aligned, rhythm-based sleep.'
        }
      }
    }
  };

  /**
   * PDP Trust Engine
   * Applies ritual-aware trust and objection messaging based on ritual state
   */
  const PDPTrustEngine = {
    /**
     * Resolve ritual key from hard and soft state
     * Priority: hard state > soft state (if confidence >= 0.65) > default
     * (Same logic as TILE-052, TILE-053, TILE-054, TILE-055, TILE-056, TILE-057, TILE-058)
     */
    resolveRitualKey() {
      // Check for hard state (quiz result)
      if (window.VelunaRitualState && typeof window.VelunaRitualState.get === 'function') {
        const hardState = window.VelunaRitualState.get();
        if (hardState && hardState.ritual) {
          const ritual = hardState.ritual.toLowerCase();
          if (ritual.includes('mind') || ritual === 'mc') return 'mc';
          if (ritual.includes('deep') || ritual === 'dr') return 'dr';
          if (ritual.includes('sacred') || ritual === 'ss') return 'ss';
          if (ritual.includes('circadian') || ritual === 'cr') return 'cr';
        }
      }

      // Check for soft state (TILE-051) if confidence >= 0.65
      if (window.VelunaSoftRitualState && typeof window.VelunaSoftRitualState.get === 'function') {
        const softState = window.VelunaSoftRitualState.get();
        if (softState && softState.ritual && softState.confidence >= 0.65) {
          const ritual = softState.ritual.toLowerCase();
          if (ritual.includes('mind') || ritual === 'mc') return 'mc';
          if (ritual.includes('deep') || ritual === 'dr') return 'dr';
          if (ritual.includes('sacred') || ritual === 'ss') return 'ss';
          if (ritual.includes('circadian') || ritual === 'cr') return 'cr';
        }
      }

      return 'default';
    },

    /**
     * Collect all trust elements from the page
     */
    collectTrustElements() {
      const primaryGroup = document.querySelector('[data-pdp-trust-group="primary"]');
      const primaryElements = primaryGroup ? primaryGroup.querySelectorAll('[data-pdp-trust]') : [];
      
      const secondaryBlocks = document.querySelectorAll('[data-pdp-trust-block]');
      
      return {
        primary: Array.from(primaryElements).map(el => ({
          element: el,
          key: el.getAttribute('data-pdp-trust')
        })),
        secondary: Array.from(secondaryBlocks).map(block => ({
          element: block,
          key: block.getAttribute('data-pdp-trust-block')
        }))
      };
    },

    /**
     * Apply ritual-aware copy to primary trust strip
     */
    applyPrimaryStripCopy(trustElements, ritualKey) {
      try {
        const trustCopy = PDP_TRUST_COPY[ritualKey] || PDP_TRUST_COPY.default;
        if (!trustCopy || !trustCopy.primary) return;

        trustElements.primary.forEach(trustEl => {
          const trustKey = trustEl.key;
          const copy = trustCopy.primary[trustKey];
          
          if (copy && copy.line) {
            // Update textContent only (DOM-safe, no innerHTML)
            trustEl.element.textContent = copy.line;
          }
        });

        // Also update helper text (guarantee line)
        const helperText = document.querySelector('[data-pdp-trust="guarantee"]');
        if (helperText && trustCopy.primary.guarantee) {
          helperText.textContent = trustCopy.primary.guarantee.line;
        }
      } catch (error) {
        logger.warn('[PDPTrustEngine] Failed to apply primary strip copy', error);
      }
    },

    /**
     * Apply ritual-aware copy to secondary trust blocks
     */
    applySecondaryBlockCopy(blockElements, ritualKey) {
      try {
        const trustCopy = PDP_TRUST_COPY[ritualKey] || PDP_TRUST_COPY.default;
        if (!trustCopy || !trustCopy.secondary) return;

        blockElements.secondary.forEach(blockEl => {
          const blockKey = blockEl.key;
          const copy = trustCopy.secondary[blockKey];
          
          if (!copy) return;

          // Find heading and body elements within the block
          const headingWrapper = blockEl.element.querySelector('[data-pdp-trust-heading]');
          if (headingWrapper) {
            // Find title and subtitle within v-section-heading
            const titleEl = headingWrapper.querySelector('.v-section-heading__title');
            const subtitleEl = headingWrapper.querySelector('.v-section-heading__subtitle');
            
            if (titleEl && copy.heading) {
              titleEl.textContent = copy.heading;
            }
            if (subtitleEl && copy.body) {
              subtitleEl.textContent = copy.body;
            }
          }
        });
      } catch (error) {
        logger.warn('[PDPTrustEngine] Failed to apply secondary block copy', error);
      }
    },

    /**
     * Apply trust personalization
     */
    applyPersonalization() {
      try {
        const ritualKey = this.resolveRitualKey();
        const trustElements = this.collectTrustElements();
        
        if (!trustElements.primary.length && !trustElements.secondary.length) return;

        this.applyPrimaryStripCopy(trustElements, ritualKey);
        this.applySecondaryBlockCopy(trustElements, ritualKey);
      } catch (error) {
        logger.warn('[PDPTrustEngine] Failed to personalize trust messaging', error);
      }
    },

    /**
     * Initialize the trust engine
     */
    init() {
      if (typeof document === 'undefined') return;
      this.applyPersonalization();
    }
  };

  // Expose globally
  window.PDPTrustEngine = PDPTrustEngine;
  window.PDP_TRUST_COPY = PDP_TRUST_COPY; // For debugging

})();

// ═══════════════════════════════════════════════════════════════════════════
// TILE-060: PDP RITUAL-AWARE MICRO-OBJECTION NEUTRALIZER ENGINE (Wave 9)
// ═══════════════════════════════════════════════════════════════════════════

(function () {
  'use strict';
  
  if (!window.PerformanceCore) return;

  /**
   * PDP Objection Copy Map
   * Ritual-aware micro-objection messaging
   * Tone: Premium sleep ritual × calm authority × editorial excellence
   */
  const PDP_OBJECTION_COPY = {
    default: {
      safety: { line: 'Non-drowsy, gentle formula', body: 'Gentle formula, no next-day fog.' },
      habit: { line: 'Non-habit forming', body: 'Designed for nightly use without dependency.' },
      effectiveness: { line: 'Designed for nightly use', body: 'Works with your body\'s natural rhythm.' },
      speed: { line: 'Supports natural sleep', body: 'Most members notice results within 7-14 nights.' },
      refund: { line: 'Free shipping · 30-day renewal guarantee', body: '30-day money-back guarantee. No questions asked.' },
      fit: { line: 'Works with your natural rhythm', body: 'Designed to support your unique sleep pattern.' }
    },
    mc: {
      safety: { line: 'Non-drowsy, supports calm mind', body: 'Gentle formula, no next-day fog. Supports mental calm without heaviness.' },
      habit: { line: 'Non-habit forming, daily-safe', body: 'Designed for long-term calm without dependency. Safe for nightly use.' },
      effectiveness: { line: 'Designed to quiet racing thoughts', body: 'Works with your mind\'s natural calm mechanisms.' },
      speed: { line: 'Supports calm focus', body: 'Most members notice calmer evenings within 7-14 nights.' },
      refund: { line: 'Free shipping · 30-day renewal guarantee', body: '30-day money-back guarantee. No questions asked.' },
      fit: { line: 'Works with overthinking minds', body: 'Designed for those who value calm, focused sleep.' }
    },
    dr: {
      safety: { line: 'Non-drowsy, supports physical recovery', body: 'Formulated for clean physical recovery without drowsiness.' },
      habit: { line: 'Non-habit forming, recovery-focused', body: 'Designed for nightly restoration without dependency.' },
      effectiveness: { line: 'Designed for deep restorative sleep', body: 'Works with your body\'s natural recovery systems.' },
      speed: { line: 'Supports deeper sleep', body: 'Most members notice improved recovery within 7-14 nights.' },
      refund: { line: 'Free shipping · 30-day renewal guarantee', body: '30-day money-back guarantee. No questions asked.' },
      fit: { line: 'Works with recovery-focused sleep', body: 'Designed for those who value deep, restorative sleep.' }
    },
    ss: {
      safety: { line: 'Non-drowsy, supports emotional calm', body: 'Gentle formula supports emotional regulation without heaviness.' },
      habit: { line: 'Non-habit forming, emotionally supportive', body: 'Designed for gentle nightly ritual without dependency.' },
      effectiveness: { line: 'Designed for gentle nightly ritual', body: 'Works with your body\'s natural emotional balance.' },
      speed: { line: 'Supports gentle relaxation', body: 'Most members notice calmer emotions within 7-14 nights.' },
      refund: { line: 'Free shipping · 30-day renewal guarantee', body: '30-day money-back guarantee. No questions asked.' },
      fit: { line: 'Works with emotionally sensitive sleep', body: 'Designed for those who value gentle, emotionally supportive sleep.' }
    },
    cr: {
      safety: { line: 'Non-drowsy, supports circadian rhythm', body: 'Gentle formula helps realign circadian timing without grogginess.' },
      habit: { line: 'Non-habit forming, rhythm-focused', body: 'Designed for circadian alignment without dependency.' },
      effectiveness: { line: 'Designed to align your sleep cycle', body: 'Works with your body\'s natural circadian rhythm.' },
      speed: { line: 'Supports rhythm alignment', body: 'Most members notice better sleep timing within 7-14 nights.' },
      refund: { line: 'Free shipping · 30-day renewal guarantee', body: '30-day money-back guarantee. No questions asked.' },
      fit: { line: 'Works with rhythm-based sleep', body: 'Designed for those who value aligned, rhythm-based sleep.' }
    }
  };

  /**
   * PDP Objection Engine
   * Applies ritual-aware micro-objection messaging based on ritual state
   */
  const PDPObjectionEngine = {
    /**
     * Resolve ritual key from hard and soft state
     * Priority: hard state > soft state (if confidence >= 0.65) > default
     * (Same logic as TILE-052, TILE-053, TILE-054, TILE-055, TILE-056, TILE-057, TILE-058, TILE-059)
     */
    resolveRitualKey() {
      // Check for hard state (quiz result)
      if (window.VelunaRitualState && typeof window.VelunaRitualState.get === 'function') {
        const hardState = window.VelunaRitualState.get();
        if (hardState && hardState.ritual) {
          const ritual = hardState.ritual.toLowerCase();
          if (ritual.includes('mind') || ritual === 'mc') return 'mc';
          if (ritual.includes('deep') || ritual === 'dr') return 'dr';
          if (ritual.includes('sacred') || ritual === 'ss') return 'ss';
          if (ritual.includes('circadian') || ritual === 'cr') return 'cr';
        }
      }

      // Check for soft state (TILE-051) if confidence >= 0.65
      if (window.VelunaSoftRitualState && typeof window.VelunaSoftRitualState.get === 'function') {
        const softState = window.VelunaSoftRitualState.get();
        if (softState && softState.ritual && softState.confidence >= 0.65) {
          const ritual = softState.ritual.toLowerCase();
          if (ritual.includes('mind') || ritual === 'mc') return 'mc';
          if (ritual.includes('deep') || ritual === 'dr') return 'dr';
          if (ritual.includes('sacred') || ritual === 'ss') return 'ss';
          if (ritual.includes('circadian') || ritual === 'cr') return 'cr';
        }
      }

      return 'default';
    },

    /**
     * Collect all objection elements from the page
     */
    collectObjectionElements() {
      const primaryGroup = document.querySelector('[data-pdp-objection-group="primary"]');
      const primaryElements = primaryGroup ? primaryGroup.querySelectorAll('[data-pdp-objection]') : [];
      
      const safetyCards = document.querySelectorAll('.pdp-safety-card [data-pdp-objection]');
      const safetyCardBodies = document.querySelectorAll('.pdp-safety-card [data-pdp-objection-body]');
      
      return {
        primary: Array.from(primaryElements).map(el => ({
          element: el,
          key: el.getAttribute('data-pdp-objection')
        })),
        safetyCards: Array.from(safetyCards).map(el => ({
          element: el,
          key: el.getAttribute('data-pdp-objection')
        })),
        safetyCardBodies: Array.from(safetyCardBodies).map(el => ({
          element: el,
          key: el.getAttribute('data-pdp-objection-body')
        }))
      };
    },

    /**
     * Apply ritual-aware copy to line-level objection elements
     */
    applyLineCopy(objectionElements, ritualKey) {
      try {
        const objectionCopy = PDP_OBJECTION_COPY[ritualKey] || PDP_OBJECTION_COPY.default;
        if (!objectionCopy) return;

        // Apply to primary objection elements
        objectionElements.primary.forEach(objEl => {
          const objectionKey = objEl.key;
          const copy = objectionCopy[objectionKey];
          
          if (copy && copy.line) {
            // Update textContent only (DOM-safe, no innerHTML)
            objEl.element.textContent = copy.line;
          }
        });

        // Apply to safety card titles
        objectionElements.safetyCards.forEach(objEl => {
          const objectionKey = objEl.key;
          const copy = objectionCopy[objectionKey];
          
          if (copy && copy.line) {
            // Update textContent only (DOM-safe, no innerHTML)
            objEl.element.textContent = copy.line;
          }
        });

        // Apply to safety card bodies
        objectionElements.safetyCardBodies.forEach(objEl => {
          const objectionKey = objEl.key;
          const copy = objectionCopy[objectionKey];
          
          if (copy && copy.body) {
            // Update textContent only (DOM-safe, no innerHTML)
            objEl.element.textContent = copy.body;
          }
        });
      } catch (error) {
        logger.warn('[PDPObjectionEngine] Failed to apply line copy', error);
      }
    },

    /**
     * Apply objection personalization
     */
    applyPersonalization() {
      try {
        const ritualKey = this.resolveRitualKey();
        const objectionElements = this.collectObjectionElements();
        
        if (!objectionElements.primary.length && !objectionElements.safetyCards.length && !objectionElements.safetyCardBodies.length) return;

        this.applyLineCopy(objectionElements, ritualKey);
      } catch (error) {
        logger.warn('[PDPObjectionEngine] Failed to personalize objection messaging', error);
      }
    },

    /**
     * Initialize the objection engine
     */
    init() {
      if (typeof document === 'undefined') return;
      this.applyPersonalization();
    }
  };

  // Expose globally
  window.PDPObjectionEngine = PDPObjectionEngine;
  window.PDP_OBJECTION_COPY = PDP_OBJECTION_COPY; // For debugging

})();

// ═══════════════════════════════════════════════════════════════════════════
// TILE-061: PDP RITUAL-AWARE PRICE & VALUE FRAMING ENGINE (Wave 10)
// ═══════════════════════════════════════════════════════════════════════════

(function () {
  'use strict';
  
  if (!window.PerformanceCore) return;

  /**
   * PDP Price Framing Map
   * Ritual-aware price and value framing messaging
   * Tone: Premium sleep ritual × calm authority × editorial excellence
   */
  const PDP_PRICE_FRAMING = {
    default: {
      price_line: 'Premium sleep ritual',
      per_night: 'Less than $X per night',
      sub_save: 'Save 15% with subscription',
      premium: 'Premium ingredients, transparent pricing',
      potency: 'Clinically studied doses, third-party tested',
      scientific: 'Science-backed formulation',
      ritual: 'A complete nightly ritual, not just a supplement'
    },
    mc: {
      price_line: 'Premium mind calm ritual',
      per_night: 'Less than $X per night for mental calm',
      sub_save: 'Save 15% with subscription',
      premium: 'Premium ingredients for calm focus, transparent pricing',
      potency: 'Clinically studied doses for mental calm, third-party tested',
      scientific: 'Science-backed formula for quieting racing thoughts',
      ritual: 'A complete mind calm ritual, not just a supplement'
    },
    dr: {
      price_line: 'Premium deep restore ritual',
      per_night: 'Less than $X per night for physical recovery',
      sub_save: 'Save 15% with subscription',
      premium: 'Premium ingredients for deep restoration, transparent pricing',
      potency: 'Clinically studied doses for physical recovery, third-party tested',
      scientific: 'Science-backed formula for deeper sleep quality',
      ritual: 'A complete deep restore ritual, not just a supplement'
    },
    ss: {
      price_line: 'Premium sacred soothe ritual',
      per_night: 'Less than $X per night for emotional calm',
      sub_save: 'Save 15% with subscription',
      premium: 'Premium ingredients for emotional balance, transparent pricing',
      potency: 'Clinically studied doses for gentle relaxation, third-party tested',
      scientific: 'Science-backed formula for emotional regulation',
      ritual: 'A complete sacred soothe ritual, not just a supplement'
    },
    cr: {
      price_line: 'Premium circadian reset ritual',
      per_night: 'Less than $X per night for rhythm alignment',
      sub_save: 'Save 15% with subscription',
      premium: 'Premium ingredients for circadian alignment, transparent pricing',
      potency: 'Clinically studied doses for sleep-wake rhythm, third-party tested',
      scientific: 'Science-backed formula for natural circadian timing',
      ritual: 'A complete circadian reset ritual, not just a supplement'
    }
  };

  /**
   * PDP Price Value Engine
   * Applies ritual-aware price and value framing based on ritual state
   */
  const PDPPriceValueEngine = {
    /**
     * Resolve ritual key from hard and soft state
     * Priority: hard state > soft state (if confidence >= 0.65) > default
     * (Same logic as TILE-052, TILE-053, TILE-054, TILE-055, TILE-056, TILE-057, TILE-058, TILE-059, TILE-060)
     */
    resolveRitualKey() {
      // Check for hard state (quiz result)
      if (window.VelunaRitualState && typeof window.VelunaRitualState.get === 'function') {
        const hardState = window.VelunaRitualState.get();
        if (hardState && hardState.ritual) {
          const ritual = hardState.ritual.toLowerCase();
          if (ritual.includes('mind') || ritual === 'mc') return 'mc';
          if (ritual.includes('deep') || ritual === 'dr') return 'dr';
          if (ritual.includes('sacred') || ritual === 'ss') return 'ss';
          if (ritual.includes('circadian') || ritual === 'cr') return 'cr';
        }
      }

      // Check for soft state (TILE-051) if confidence >= 0.65
      if (window.VelunaSoftRitualState && typeof window.VelunaSoftRitualState.get === 'function') {
        const softState = window.VelunaSoftRitualState.get();
        if (softState && softState.ritual && softState.confidence >= 0.65) {
          const ritual = softState.ritual.toLowerCase();
          if (ritual.includes('mind') || ritual === 'mc') return 'mc';
          if (ritual.includes('deep') || ritual === 'dr') return 'dr';
          if (ritual.includes('sacred') || ritual === 'ss') return 'ss';
          if (ritual.includes('circadian') || ritual === 'cr') return 'cr';
        }
      }

      return 'default';
    },

    /**
     * Collect all price/value elements from the page
     */
    collectPriceNodes() {
      const priceWrapper = document.querySelector('[data-pdp-price-wrapper]');
      const pricePrimary = document.querySelector('[data-pdp-price-primary]');
      const priceCompare = document.querySelector('[data-pdp-price-compare]');
      const pricePerNight = document.querySelector('[data-pdp-price-per-night]');
      const priceSubSave = document.querySelector('[data-pdp-price-sub-save]');
      const valueElements = document.querySelectorAll('[data-pdp-value]');
      const valueBundle = document.querySelector('[data-pdp-value-bundle]');

      return {
        priceWrapper: priceWrapper,
        pricePrimary: pricePrimary,
        priceCompare: priceCompare,
        pricePerNight: pricePerNight,
        priceSubSave: priceSubSave,
        valueElements: Array.from(valueElements).map(el => ({
          element: el,
          key: el.getAttribute('data-pdp-value')
        })),
        valueBundle: valueBundle
      };
    },

    /**
     * Calculate per-night price from product price
     */
    calculatePerNightPrice() {
      try {
        const pricePrimary = document.querySelector('[data-pdp-price-primary]');
        if (!pricePrimary) return null;

        // Extract price from text content (e.g., "$49.00" -> 49)
        const priceText = pricePrimary.textContent.trim();
        const priceMatch = priceText.match(/[\d.]+/);
        if (!priceMatch) return null;

        const price = parseFloat(priceMatch[0]);
        if (isNaN(price)) return null;

        // Assume 30-day supply (1 per night)
        const perNight = price / 30;
        return perNight;
      } catch (error) {
        logger.warn('[PDPPriceValueEngine] Failed to calculate per-night price', error);
        return null;
      }
    },

    /**
     * Apply ritual-aware price framing
     */
    applyPriceFraming(priceNodes, ritualKey) {
      try {
        const priceFraming = PDP_PRICE_FRAMING[ritualKey] || PDP_PRICE_FRAMING.default;
        if (!priceFraming) return;

        // Apply per-night price if element exists
        if (priceNodes.pricePerNight) {
          const perNightPrice = this.calculatePerNightPrice();
          if (perNightPrice) {
            const perNightText = priceFraming.per_night.replace('$X', '$' + perNightPrice.toFixed(2));
            priceNodes.pricePerNight.textContent = perNightText;
            priceNodes.pricePerNight.style.display = 'block';
          } else {
            priceNodes.pricePerNight.style.display = 'none';
          }
        }

        // Apply subscription save text if element exists
        if (priceNodes.priceSubSave && priceFraming.sub_save) {
          priceNodes.priceSubSave.textContent = priceFraming.sub_save;
          priceNodes.priceSubSave.style.display = 'block';
        }

        // Apply value framing elements
        priceNodes.valueElements.forEach(valueEl => {
          const valueKey = valueEl.key;
          const copy = priceFraming[valueKey];
          
          if (copy) {
            // Update textContent only (DOM-safe, no innerHTML)
            valueEl.element.textContent = copy;
            valueEl.element.style.display = 'block';
          } else {
            valueEl.element.style.display = 'none';
          }
        });

        // Apply bundle value framing if element exists
        if (priceNodes.valueBundle && priceFraming.ritual) {
          priceNodes.valueBundle.textContent = priceFraming.ritual;
        }
      } catch (error) {
        logger.warn('[PDPPriceValueEngine] Failed to apply price framing', error);
      }
    },

    /**
     * Apply price and value personalization
     */
    applyPersonalization() {
      try {
        const ritualKey = this.resolveRitualKey();
        const priceNodes = this.collectPriceNodes();
        
        if (!priceNodes.priceWrapper) return;

        this.applyPriceFraming(priceNodes, ritualKey);
      } catch (error) {
        logger.warn('[PDPPriceValueEngine] Failed to personalize price/value framing', error);
      }
    },

    /**
     * Initialize the price value engine
     */
    init() {
      if (typeof document === 'undefined') return;
      this.applyPersonalization();
    }
  };

  // Expose globally
  window.PDPPriceValueEngine = PDPPriceValueEngine;
  window.PDP_PRICE_FRAMING = PDP_PRICE_FRAMING; // For debugging

})();

// ═══════════════════════════════════════════════════════════════════════════
// TILE-062: CART RITUAL-AWARE SUMMARY & INCENTIVE ENGINE (Wave 1)
// ═══════════════════════════════════════════════════════════════════════════

(function () {
  'use strict';
  
  if (!window.PerformanceCore) return;

  /**
   * Cart Ritual Copy Map
   * Ritual-aware cart summary and value framing messaging
   * Tone: Premium sleep ritual × calm authority × editorial excellence
   */
  const CART_RITUAL_COPY = {
    default: {
      summary: 'Your sleep ritual is almost ready.',
      subcopy: 'Review your items, then complete your order to begin.',
      value_line: 'Premium, non-drowsy sleep support.',
      threshold_hint: 'Complete your ritual when you\'re ready.'
    },
    mc: {
      summary: 'Your Mind Calm ritual is almost ready.',
      subcopy: 'You\'re a few clicks away from quieter nights and a calmer mind.',
      value_line: 'Gentle, non-drowsy support for racing thoughts.',
      threshold_hint: 'Completing this order sets up your Mind Calm practice.'
    },
    dr: {
      summary: 'Your Deep Restore ritual is almost ready.',
      subcopy: 'Lock in deeper nightly recovery and physical restoration.',
      value_line: 'Formulated to support muscle recovery and deeper sleep.',
      threshold_hint: 'Completing this order sets your body up for better nights.'
    },
    ss: {
      summary: 'Your Sacred Soothe ritual is almost ready.',
      subcopy: 'You\'re close to softer nights and emotional calm.',
      value_line: 'Designed to gently soothe a restless, sensitive system.',
      threshold_hint: 'Completing this order anchors your Sacred Soothe ritual.'
    },
    cr: {
      summary: 'Your Circadian Reset ritual is almost ready.',
      subcopy: 'You\'re close to realigning your sleep-wake cycle.',
      value_line: 'Helps support a more consistent, aligned sleep rhythm.',
      threshold_hint: 'Completing this order supports your long-term rhythm reset.'
    }
  };

  /**
   * Cart Ritual Engine
   * Applies ritual-aware cart summary and value framing based on ritual state
   */
  const CartRitualEngine = {
    /**
     * Resolve ritual key from hard and soft state
     * Priority: hard state > soft state (if confidence >= 0.65) > default
     * (Same logic as TILE-052, TILE-053, TILE-054, TILE-055, TILE-056, TILE-057, TILE-058, TILE-059, TILE-060, TILE-061)
     */
    resolveRitualKey() {
      // Check for hard state (quiz result)
      if (window.VelunaRitualState && typeof window.VelunaRitualState.get === 'function') {
        const hardState = window.VelunaRitualState.get();
        if (hardState && hardState.ritual) {
          const ritual = hardState.ritual.toLowerCase();
          if (ritual.includes('mind') || ritual === 'mc') return 'mc';
          if (ritual.includes('deep') || ritual === 'dr') return 'dr';
          if (ritual.includes('sacred') || ritual === 'ss') return 'ss';
          if (ritual.includes('circadian') || ritual === 'cr') return 'cr';
        }
      }

      // Check for soft state (TILE-051) if confidence >= 0.65
      if (window.VelunaSoftRitualState && typeof window.VelunaSoftRitualState.get === 'function') {
        const softState = window.VelunaSoftRitualState.get();
        if (softState && softState.ritual && softState.confidence >= 0.65) {
          const ritual = softState.ritual.toLowerCase();
          if (ritual.includes('mind') || ritual === 'mc') return 'mc';
          if (ritual.includes('deep') || ritual === 'dr') return 'dr';
          if (ritual.includes('sacred') || ritual === 'ss') return 'ss';
          if (ritual.includes('circadian') || ritual === 'cr') return 'cr';
        }
      }

      return 'default';
    },

    /**
     * Collect all cart ritual elements from the page
     */
    collectNodes() {
      const summary = document.querySelector('[data-cart-ritual-summary]');
      const summaryDrawer = document.querySelector('[data-cart-ritual-summary="drawer"]');
      const subcopy = document.querySelector('[data-cart-ritual-subcopy]');
      const valueLine = document.querySelector('[data-cart-value-line]');
      const valueLineDrawer = document.querySelector('[data-cart-value-line="drawer"]');
      const thresholdSummary = document.querySelector('[data-cart-threshold-summary]');

      return {
        summary: summary,
        summaryDrawer: summaryDrawer,
        subcopy: subcopy,
        valueLine: valueLine,
        valueLineDrawer: valueLineDrawer,
        thresholdSummary: thresholdSummary
      };
    },

    /**
     * Apply ritual-aware cart copy
     */
    applyCopy(ritualKey) {
      try {
        const cartCopy = CART_RITUAL_COPY[ritualKey] || CART_RITUAL_COPY.default;
        if (!cartCopy) return;

        const nodes = this.collectNodes();

        // Apply summary (main cart page)
        if (nodes.summary && cartCopy.summary) {
          nodes.summary.textContent = cartCopy.summary;
        }

        // Apply summary (cart drawer)
        if (nodes.summaryDrawer && cartCopy.summary) {
          nodes.summaryDrawer.textContent = cartCopy.summary;
        }

        // Apply subcopy
        if (nodes.subcopy && cartCopy.subcopy) {
          nodes.subcopy.textContent = cartCopy.subcopy;
          nodes.subcopy.style.display = 'block';
        }

        // Apply value line (main cart page)
        if (nodes.valueLine && cartCopy.value_line) {
          nodes.valueLine.textContent = cartCopy.value_line;
        }

        // Apply value line (cart drawer)
        if (nodes.valueLineDrawer && cartCopy.value_line) {
          nodes.valueLineDrawer.textContent = cartCopy.value_line;
          nodes.valueLineDrawer.style.display = 'block';
        }

        // Apply threshold hint (for future upsell logic)
        if (nodes.thresholdSummary && cartCopy.threshold_hint) {
          nodes.thresholdSummary.textContent = cartCopy.threshold_hint;
          // Keep hidden for now - will be used by future upsell/threshold logic
        }
      } catch (error) {
        logger.warn('[CartRitualEngine] Failed to apply cart copy', error);
      }
    },

    /**
     * Check if cart elements are present on the page
     */
    isCartPage() {
      return !!document.querySelector('[data-cart-ritual-summary]') || 
             !!document.querySelector('[data-cart-ritual-summary="drawer"]');
    },

    /**
     * Initialize the cart ritual engine
     */
    init() {
      if (typeof document === 'undefined') return;
      
      // Only run on cart pages/drawers
      if (!this.isCartPage()) return;

      try {
        const ritualKey = this.resolveRitualKey();
        this.applyCopy(ritualKey);

        // TILE-066: Update customer profile (if identifier available)
        if (window.CustomerProfileEngine && typeof window.CustomerProfileEngine.recordTouchpoint === 'function') {
          // Try to get customer identifier from cart data or URL params
          const customerEmail = document.querySelector('[data-customer-email]')?.textContent?.trim() ||
                                new URLSearchParams(window.location.search).get('customer_email');
          
          if (customerEmail) {
            window.CustomerProfileEngine.recordTouchpoint(customerEmail, 'cart', ritualKey).catch(() => {
              // Silently fail if profile update fails
            });
          }
        }
      } catch (error) {
        logger.warn('[CartRitualEngine] Failed to personalize cart', error);
      }
    }
  };

  // Expose globally
  window.CartRitualEngine = CartRitualEngine;
  window.CART_RITUAL_COPY = CART_RITUAL_COPY; // For debugging

  // Initialize cart engine after LCP (global, not PDP-specific)
  if (window.PerformanceCore && typeof window.PerformanceCore.afterLCP === 'function') {
    window.PerformanceCore.afterLCP(() => {
      try {
        if (window.CartRitualEngine && typeof window.CartRitualEngine.init === 'function') {
          window.CartRitualEngine.init();
        }
      } catch (error) {
        logger.warn('[GlobalInit] Cart ritual engine init failed', error);
      }
    });
  }

})();

// ═══════════════════════════════════════════════════════════════════════════
// TILE-063: CHECKOUT RITUAL-AWARE CONFIRMATION ENGINE (Wave 1)
// ═══════════════════════════════════════════════════════════════════════════

(function () {
  'use strict';
  
  if (!window.PerformanceCore) return;

  /**
   * Checkout Ritual Copy Map
   * Ritual-aware checkout/thank-you confirmation messaging
   * Tone: Premium sleep ritual × calm authority × editorial excellence
   */
  const CHECKOUT_RITUAL_COPY = {
    default: {
      title: 'Your sleep ritual is on its way.',
      body: 'Tonight is the first step. When your order arrives, check your inbox for your ritual emails and treat each night as a practice, not a pill.',
      next_step: 'Add Veluna to your contacts and plan a calm 10-minute wind-down tonight.'
    },
    mc: {
      title: 'Your Mind Calm ritual is on its way.',
      body: 'You\'ve chosen a ritual designed to quiet racing thoughts and help your system downshift before bed. When it arrives, your inbox will guide you through a simple, screen-light wind-down.',
      next_step: 'Tonight, choose one calming habit and watch for your Mind Calm ritual emails.'
    },
    dr: {
      title: 'Your Deep Restore ritual is on its way.',
      body: 'You\'ve chosen a ritual built to support physical recovery and deeper nightly restoration. Your post-purchase emails will show you how to treat bedtime like a full-body cooldown.',
      next_step: 'Tonight, give yourself a little extra time to unwind and look out for your Deep Restore ritual email.'
    },
    ss: {
      title: 'Your Sacred Soothe ritual is on its way.',
      body: 'You\'ve chosen a ritual created for softer nights and an emotionally calmer nervous system. Your ritual emails will gently walk you through how to signal safety to your body each night.',
      next_step: 'Tonight, pick one gentle act of care-and watch for your Sacred Soothe ritual email to build on it.'
    },
    cr: {
      title: 'Your Circadian Reset ritual is on its way.',
      body: 'You\'ve chosen a ritual meant to support a more consistent, aligned sleep rhythm. Your inbox will guide you through a simple reset window over the next few weeks.',
      next_step: 'Tonight, choose a consistent wind-down time you\'ll protect-then watch for your Circadian Reset ritual email.'
    }
  };

  /**
   * Checkout Ritual Engine
   * Applies ritual-aware checkout/thank-you confirmation messaging based on ritual state
   */
  const CheckoutRitualEngine = {
    /**
     * Resolve ritual key from hard and soft state
     * Priority: hard state > soft state (if confidence >= 0.65) > default
     * (Same logic as TILE-052, TILE-053, TILE-054, TILE-055, TILE-056, TILE-057, TILE-058, TILE-059, TILE-060, TILE-061, TILE-062)
     */
    resolveRitualKey() {
      // Check for hard state (quiz result)
      if (window.VelunaRitualState && typeof window.VelunaRitualState.get === 'function') {
        const hardState = window.VelunaRitualState.get();
        if (hardState && hardState.ritual) {
          const ritual = hardState.ritual.toLowerCase();
          if (ritual.includes('mind') || ritual === 'mc') return 'mc';
          if (ritual.includes('deep') || ritual === 'dr') return 'dr';
          if (ritual.includes('sacred') || ritual === 'ss') return 'ss';
          if (ritual.includes('circadian') || ritual === 'cr') return 'cr';
        }
      }

      // Check for soft state (TILE-051) if confidence >= 0.65
      if (window.VelunaSoftRitualState && typeof window.VelunaSoftRitualState.get === 'function') {
        const softState = window.VelunaSoftRitualState.get();
        if (softState && softState.ritual && softState.confidence >= 0.65) {
          const ritual = softState.ritual.toLowerCase();
          if (ritual.includes('mind') || ritual === 'mc') return 'mc';
          if (ritual.includes('deep') || ritual === 'dr') return 'dr';
          if (ritual.includes('sacred') || ritual === 'ss') return 'ss';
          if (ritual.includes('circadian') || ritual === 'cr') return 'cr';
        }
      }

      return 'default';
    },

    /**
     * Collect all checkout ritual nodes from the page
     */
    collectNodes() {
      const block = document.querySelector('[data-checkout-ritual-block]');
      const title = document.querySelector('[data-checkout-ritual-title]');
      const body = document.querySelector('[data-checkout-ritual-body]');
      const nextStep = document.querySelector('[data-checkout-ritual-next-step]');

      return {
        block: block,
        title: title,
        body: body,
        nextStep: nextStep
      };
    },

    /**
     * Check if checkout elements are present on the page
     */
    isCheckoutPage() {
      return !!document.querySelector('[data-checkout-ritual-block]');
    },

    /**
     * Apply ritual-aware checkout copy
     */
    applyCopy(ritualKey) {
      try {
        const checkoutCopy = CHECKOUT_RITUAL_COPY[ritualKey] || CHECKOUT_RITUAL_COPY.default;
        if (!checkoutCopy) return;

        const nodes = this.collectNodes();

        // Apply title
        if (nodes.title && checkoutCopy.title) {
          nodes.title.textContent = checkoutCopy.title;
        }

        // Apply body
        if (nodes.body && checkoutCopy.body) {
          nodes.body.textContent = checkoutCopy.body;
        }

        // Apply next step
        if (nodes.nextStep && checkoutCopy.next_step) {
          nodes.nextStep.textContent = checkoutCopy.next_step;
        }

        // Show the block
        if (nodes.block) {
          nodes.block.style.display = 'block';
        }
      } catch (error) {
        logger.warn('[CheckoutRitualEngine] Failed to apply checkout copy', error);
      }
    },

    /**
     * Initialize the checkout ritual engine
     */
    init() {
      if (typeof document === 'undefined') return;
      
      // Only run on checkout/order confirmation pages
      if (!this.isCheckoutPage()) return;

      try {
        const ritualKey = this.resolveRitualKey();
        this.applyCopy(ritualKey);

        // TILE-066: Update customer profile (if identifier available)
        if (window.CustomerProfileEngine && typeof window.CustomerProfileEngine.recordTouchpoint === 'function') {
          // Try to get customer identifier from order data or URL params
          const customerEmail = document.querySelector('[data-order-email]')?.textContent?.trim() ||
                                new URLSearchParams(window.location.search).get('email') ||
                                document.querySelector('[data-customer-email]')?.textContent?.trim();
          
          const orderId = document.querySelector('[data-order-id]')?.textContent?.trim() ||
                          new URLSearchParams(window.location.search).get('order_id');

          if (customerEmail || orderId) {
            const identifier = customerEmail || orderId;
            window.CustomerProfileEngine.recordTouchpoint(identifier, 'checkout', ritualKey).catch(() => {
              // Silently fail if profile update fails
            });

            // Also create order entry if order ID available
            if (orderId && customerEmail) {
              window.CustomerProfileEngine.createOrUpdateProfile(customerEmail, {
                order: {
                  order_id: orderId,
                  ritual_type: ritualKey,
                  completed_at: new Date().toISOString(),
                  touchpoint: 'checkout'
                }
              }).catch(() => {
                // Silently fail if profile update fails
              });
            }
          }
        }
      } catch (error) {
        logger.warn('[CheckoutRitualEngine] Failed to personalize checkout', error);
      }
    }
  };

  // Expose globally
  window.CheckoutRitualEngine = CheckoutRitualEngine;
  window.CHECKOUT_RITUAL_COPY = CHECKOUT_RITUAL_COPY; // For debugging

  // Initialize checkout engine after LCP (global, not PDP-specific)
  if (window.PerformanceCore && typeof window.PerformanceCore.afterLCP === 'function') {
    window.PerformanceCore.afterLCP(() => {
      try {
        if (window.CheckoutRitualEngine && typeof window.CheckoutRitualEngine.init === 'function') {
          window.CheckoutRitualEngine.init();
        }
      } catch (error) {
        logger.warn('[GlobalInit] Checkout ritual engine init failed', error);
      }
    });
  }

})();

// ═══════════════════════════════════════════════════════════════════════════
// TILE-064: POST-PURCHASE RITUAL-AWARE EMAIL DATA ENGINE (Wave 1)
// ═══════════════════════════════════════════════════════════════════════════

(function () {
  'use strict';
  
  /**
   * Email Data Engine
   * Provides programmatic access to ritual-aware email templates
   * Templates are loaded from data/email-templates/ritual-email-templates.json
   * This is a utility module for ESP integration and future email personalization
   */
  const EmailDataEngine = {
    /**
     * Email templates cache
     * Loaded from JSON file (can be populated via fetch or inline import)
     */
    _templates: null,

    /**
     * Resolve ritual key from hard and soft state
     * Priority: hard state > soft state (if confidence >= 0.65) > default
     * (Same logic as TILE-052, TILE-053, TILE-054, TILE-055, TILE-056, TILE-057, TILE-058, TILE-059, TILE-060, TILE-061, TILE-062, TILE-063)
     */
    resolveRitualKey() {
      // Check for hard state (quiz result)
      if (window.VelunaRitualState && typeof window.VelunaRitualState.get === 'function') {
        const hardState = window.VelunaRitualState.get();
        if (hardState && hardState.ritual) {
          const ritual = hardState.ritual.toLowerCase();
          if (ritual.includes('mind') || ritual === 'mc') return 'mc';
          if (ritual.includes('deep') || ritual === 'dr') return 'dr';
          if (ritual.includes('sacred') || ritual === 'ss') return 'ss';
          if (ritual.includes('circadian') || ritual === 'cr') return 'cr';
        }
      }

      // Check for soft state (TILE-051) if confidence >= 0.65
      if (window.VelunaSoftRitualState && typeof window.VelunaSoftRitualState.get === 'function') {
        const softState = window.VelunaSoftRitualState.get();
        if (softState && softState.ritual && softState.confidence >= 0.65) {
          const ritual = softState.ritual.toLowerCase();
          if (ritual.includes('mind') || ritual === 'mc') return 'mc';
          if (ritual.includes('deep') || ritual === 'dr') return 'dr';
          if (ritual.includes('sacred') || ritual === 'ss') return 'ss';
          if (ritual.includes('circadian') || ritual === 'cr') return 'cr';
        }
      }

      return 'default';
    },

    /**
     * Load email templates from JSON file
     * This is a utility method for loading templates (can be called manually)
     */
    async loadTemplates() {
      try {
        const response = await fetch('/assets/ritual-email-templates.json');
        if (!response.ok) {
          throw new Error(`Failed to load email templates: ${response.status}`);
        }
        const data = await response.json();
        this._templates = data.templates;
        return this._templates;
      } catch (error) {
        logger.warn('[EmailDataEngine] Failed to load email templates', error);
        return null;
      }
    },

    /**
     * Set email templates (for manual initialization or inline import)
     * @param {Object} templates - Email templates object
     */
    setTemplates(templates) {
      this._templates = templates;
    },

    /**
     * Get email template for a specific email type and ritual
     * @param {string} emailType - Email type (e.g., 'order_confirmation', 'shipping_notification')
     * @param {string} ritualKey - Ritual key ('mc', 'dr', 'ss', 'cr', or 'default')
     * @returns {Object|null} Email template object or null if not found
     */
    getTemplate(emailType, ritualKey) {
      if (!this._templates) {
        logger.warn('[EmailDataEngine] Templates not loaded. Call loadTemplates() or setTemplates() first.');
        return null;
      }

      if (!this._templates[emailType]) {
        logger.warn(`[EmailDataEngine] Email type "${emailType}" not found.`);
        return null;
      }

      const template = this._templates[emailType][ritualKey] || this._templates[emailType].default;
      return template || null;
    },

    /**
     * Get email template for current ritual state
     * @param {string} emailType - Email type (e.g., 'order_confirmation', 'shipping_notification')
     * @returns {Object|null} Email template object or null if not found
     */
    getTemplateForCurrentRitual(emailType) {
      const ritualKey = this.resolveRitualKey();
      return this.getTemplate(emailType, ritualKey);
    },

    /**
     * Get all email templates for a specific ritual
     * @param {string} ritualKey - Ritual key ('mc', 'dr', 'ss', 'cr', or 'default')
     * @returns {Object|null} All email templates for the ritual or null if not found
     */
    getAllTemplatesForRitual(ritualKey) {
      if (!this._templates) {
        logger.warn('[EmailDataEngine] Templates not loaded. Call loadTemplates() or setTemplates() first.');
        return null;
      }

      const result = {};
      for (const emailType in this._templates) {
        if (this._templates[emailType][ritualKey]) {
          result[emailType] = this._templates[emailType][ritualKey];
        } else if (this._templates[emailType].default) {
          result[emailType] = this._templates[emailType].default;
        }
      }
      return Object.keys(result).length > 0 ? result : null;
    },

    /**
     * Export email data for ESP integration
     * Returns a structured object ready for ESP import
     * @param {string} ritualKey - Ritual key ('mc', 'dr', 'ss', 'cr', or 'default')
     * @returns {Object|null} ESP-ready email data structure or null if not found
     */
    exportForESP(ritualKey) {
      const templates = this.getAllTemplatesForRitual(ritualKey);
      if (!templates) return null;

      return {
        ritual: ritualKey,
        templates: templates,
        metadata: {
          version: '1.0.0',
          exported_at: new Date().toISOString(),
          tile: 'TILE-064'
        }
      };
    }
  };

  // Expose globally
  window.EmailDataEngine = EmailDataEngine;

  // Note: Templates are not loaded automatically to avoid unnecessary network requests
  // Call EmailDataEngine.loadTemplates() or EmailDataEngine.setTemplates() when needed
  // This allows ESP integration or manual initialization

})();

// ═══════════════════════════════════════════════════════════════════════════
// TILE-065: POST-PURCHASE RITUAL-AWARE EMAIL SEQUENCE ENGINE (Wave 1)
// ═══════════════════════════════════════════════════════════════════════════

(function () {
  'use strict';
  
  /**
   * Email Sequence Engine
   * Provides programmatic access to ritual-aware email sequences
   * Sequences are loaded from data/email-templates/ritual-email-sequences.json
   * This is a utility module for ESP integration and email automation
   * Pure utility: no DOM work, no LCP hooks, no runtime side effects
   */
  const EmailSequenceEngine = {
    /**
     * Email sequences cache
     * Loaded from JSON file (can be populated via fetch or inline import)
     */
    _sequences: null,

    /**
     * Resolve ritual key from ritual state object
     * Pure function: works in browser or Node contexts
     * @param {Object} ritualState - Ritual state object (hard or soft)
     * @returns {string} Ritual key ('mc', 'dr', 'ss', 'cr', or 'default')
     */
    resolveRitualKeyFromState(ritualState) {
      if (!ritualState) return 'default';

      // Handle hard state (quiz result)
      if (ritualState.ritual) {
        const ritual = ritualState.ritual.toLowerCase();
        if (ritual.includes('mind') || ritual === 'mc') return 'mc';
        if (ritual.includes('deep') || ritual === 'dr') return 'dr';
        if (ritual.includes('sacred') || ritual === 'ss') return 'ss';
        if (ritual.includes('circadian') || ritual === 'cr') return 'cr';
      }

      // Handle soft state (TILE-051) if confidence >= 0.65
      if (ritualState.confidence && ritualState.confidence >= 0.65 && ritualState.ritual) {
        const ritual = ritualState.ritual.toLowerCase();
        if (ritual.includes('mind') || ritual === 'mc') return 'mc';
        if (ritual.includes('deep') || ritual === 'dr') return 'dr';
        if (ritual.includes('sacred') || ritual === 'ss') return 'ss';
        if (ritual.includes('circadian') || ritual === 'cr') return 'cr';
      }

      return 'default';
    },

    /**
     * Resolve ritual key from window state (browser context only)
     * Falls back to resolveRitualKeyFromState if window state available
     * @returns {string} Ritual key ('mc', 'dr', 'ss', 'cr', or 'default')
     */
    resolveRitualKey() {
      // Check for hard state (quiz result)
      if (typeof window !== 'undefined' && window.VelunaRitualState && typeof window.VelunaRitualState.get === 'function') {
        const hardState = window.VelunaRitualState.get();
        if (hardState) {
          const key = this.resolveRitualKeyFromState(hardState);
          if (key !== 'default') return key;
        }
      }

      // Check for soft state (TILE-051) if confidence >= 0.65
      if (typeof window !== 'undefined' && window.VelunaSoftRitualState && typeof window.VelunaSoftRitualState.get === 'function') {
        const softState = window.VelunaSoftRitualState.get();
        if (softState) {
          const key = this.resolveRitualKeyFromState(softState);
          if (key !== 'default') return key;
        }
      }

      return 'default';
    },

    /**
     * Load email sequences from JSON file
     * This is a utility method for loading sequences (can be called manually)
     * @returns {Promise<Object|null>} Sequences object or null if failed
     */
    async loadSequences() {
      try {
        // Check if fetch is available (browser context)
        if (typeof fetch === 'undefined') {
          logger.warn('[EmailSequenceEngine] fetch not available. Use setSequences() to provide sequences manually.');
          return null;
        }

        const response = await fetch('/assets/ritual-email-sequences.json');
        if (!response.ok) {
          throw new Error(`Failed to load email sequences: ${response.status}`);
        }
        const data = await response.json();
        this._sequences = data.sequences;
        return this._sequences;
      } catch (error) {
        logger.warn('[EmailSequenceEngine] Failed to load email sequences', error);
        return null;
      }
    },

    /**
     * Set email sequences (for manual initialization or inline import)
     * @param {Object} sequences - Email sequences object
     */
    setSequences(sequences) {
      this._sequences = sequences;
    },

    /**
     * Get sequences for a specific ritual and scenario
     * @param {string} ritualKey - Ritual key ('mc', 'dr', 'ss', 'cr', or 'default')
     * @param {string} scenario - Scenario ('post_purchase_order', 'post_purchase_subscription', 'quiz_lead_non_buyer')
     * @returns {Array|null} Sequence array or null if not found
     */
    getSequencesForRitual(ritualKey, scenario) {
      if (!this._sequences) {
        logger.warn('[EmailSequenceEngine] Sequences not loaded. Call loadSequences() or setSequences() first.');
        return null;
      }

      if (!this._sequences[ritualKey]) {
        logger.warn(`[EmailSequenceEngine] Ritual "${ritualKey}" not found.`);
        return null;
      }

      if (!this._sequences[ritualKey][scenario]) {
        logger.warn(`[EmailSequenceEngine] Scenario "${scenario}" not found for ritual "${ritualKey}".`);
        return null;
      }

      return this._sequences[ritualKey][scenario] || null;
    },

    /**
     * Get sequences for a ritual state object and scenario
     * @param {Object} ritualState - Ritual state object (hard or soft)
     * @param {string} scenario - Scenario ('post_purchase_order', 'post_purchase_subscription', 'quiz_lead_non_buyer')
     * @returns {Array|null} Sequence array or null if not found
     */
    getSequencesForState(ritualState, scenario) {
      const ritualKey = this.resolveRitualKeyFromState(ritualState);
      return this.getSequencesForRitual(ritualKey, scenario);
    },

    /**
     * Get resolved sequence with template bodies merged
     * Combines sequence entries with template data from EmailDataEngine
     * @param {string} ritualKey - Ritual key ('mc', 'dr', 'ss', 'cr', or 'default')
     * @param {string} scenario - Scenario ('post_purchase_order', 'post_purchase_subscription', 'quiz_lead_non_buyer')
     * @returns {Array|null} Resolved sequence array with template fields or null if not found
     */
    getResolvedSequence(ritualKey, scenario) {
      const sequences = this.getSequencesForRitual(ritualKey, scenario);
      if (!sequences) return null;

      // Check if EmailDataEngine is available
      if (typeof window === 'undefined' || !window.EmailDataEngine) {
        logger.warn('[EmailSequenceEngine] EmailDataEngine not available. Returning sequences without template data.');
        return sequences;
      }

      const resolved = sequences.map(seq => {
        const resolvedSeq = { ...seq };

        // Parse template_key (e.g., "welcome_series.email_1_day_0" or "order_confirmation")
        const templateKeyParts = seq.template_key.split('.');
        const emailType = templateKeyParts[0];
        const subKey = templateKeyParts.length > 1 ? templateKeyParts.slice(1).join('.') : null;

        // Get template from EmailDataEngine
        let template = window.EmailDataEngine.getTemplate(emailType, ritualKey);

        // If subKey exists (e.g., "email_1_day_0"), get nested template
        if (subKey && template && template[subKey]) {
          template = template[subKey];
        }

        // Merge template fields into sequence entry
        if (template) {
          resolvedSeq.subject = template.subject;
          resolvedSeq.preheader = template.preheader;
          resolvedSeq.body = template.body;
          resolvedSeq.cta_text = template.cta_text;
          resolvedSeq.footer_note = template.footer_note;
        }

        return resolvedSeq;
      });

      return resolved;
    },

    /**
     * Export email sequence data for ESP integration
     * Returns a structured object ready for ESP import
     * @param {string} ritualKey - Ritual key ('mc', 'dr', 'ss', 'cr', or 'default')
     * @param {string} scenario - Scenario ('post_purchase_order', 'post_purchase_subscription', 'quiz_lead_non_buyer')
     * @returns {Object|null} ESP-ready email sequence data structure or null if not found
     */
    exportForESP(ritualKey, scenario) {
      const resolvedSequence = this.getResolvedSequence(ritualKey, scenario);
      if (!resolvedSequence) return null;

      return {
        ritual: ritualKey,
        scenario: scenario,
        sequence: resolvedSequence,
        metadata: {
          version: '1.0.0',
          exported_at: new Date().toISOString(),
          tile: 'TILE-065'
        }
      };
    }
  };

  // Expose globally
  window.EmailSequenceEngine = EmailSequenceEngine;

  // Note: Sequences are not loaded automatically to avoid unnecessary network requests
  // Call EmailSequenceEngine.loadSequences() or EmailSequenceEngine.setSequences() when needed
  // This allows ESP integration or manual initialization
  // Pure utility: no DOM work, no LCP hooks, no runtime side effects

})();

// ═══════════════════════════════════════════════════════════════════════════
// TILE-066: POST-PURCHASE RITUAL-AWARE CUSTOMER PROFILE ENGINE (Wave 1)
// ═══════════════════════════════════════════════════════════════════════════

(function () {
  'use strict';
  
  /**
   * Customer Profile Engine
   * Provides persistent storage and retrieval of ritual-aware customer profiles
   * Profiles are stored in data/customer-profiles/profiles.json
   * This is a utility module for customer personalization and automation
   * Works in browser and Node contexts (read/write in Node, read-only in browser)
   */
  const CustomerProfileEngine = {
    /**
     * Profiles cache
     * Loaded from JSON file (can be populated via fetch or inline import)
     */
    _profiles: null,

    /**
     * Resolve ritual key from hard and soft state
     * Priority: hard state > soft state (if confidence >= 0.65) > default
     * (Same logic as TILE-052, TILE-053, TILE-054, TILE-055, TILE-056, TILE-057, TILE-058, TILE-059, TILE-060, TILE-061, TILE-062, TILE-063, TILE-064, TILE-065)
     */
    resolveRitualKey() {
      // Check for hard state (quiz result)
      if (typeof window !== 'undefined' && window.VelunaRitualState && typeof window.VelunaRitualState.get === 'function') {
        const hardState = window.VelunaRitualState.get();
        if (hardState && hardState.ritual) {
          const ritual = hardState.ritual.toLowerCase();
          if (ritual.includes('mind') || ritual === 'mc') return 'mc';
          if (ritual.includes('deep') || ritual === 'dr') return 'dr';
          if (ritual.includes('sacred') || ritual === 'ss') return 'ss';
          if (ritual.includes('circadian') || ritual === 'cr') return 'cr';
        }
      }

      // Check for soft state (TILE-051) if confidence >= 0.65
      if (typeof window !== 'undefined' && window.VelunaSoftRitualState && typeof window.VelunaSoftRitualState.get === 'function') {
        const softState = window.VelunaSoftRitualState.get();
        if (softState && softState.ritual && softState.confidence >= 0.65) {
          const ritual = softState.ritual.toLowerCase();
          if (ritual.includes('mind') || ritual === 'mc') return 'mc';
          if (ritual.includes('deep') || ritual === 'dr') return 'dr';
          if (ritual.includes('sacred') || ritual === 'ss') return 'ss';
          if (ritual.includes('circadian') || ritual === 'cr') return 'cr';
        }
      }

      return 'default';
    },

    /**
     * Load profiles from JSON file
     * Browser: Uses fetch API (read-only)
     * Node: Uses fs module (read/write)
     * @returns {Promise<Object|null>} Profiles object or null if failed
     */
    async loadProfiles() {
      try {
        // Browser context: use fetch
        if (typeof fetch !== 'undefined') {
          const response = await fetch('/assets/customer-profiles.json');
          if (!response.ok) {
            // File might not exist yet, create empty structure
            this._profiles = {
              by_email: {},
              by_customer_id: {},
              by_shopify_id: {},
              metadata: {
                version: '1.0.0',
                created: new Date().toISOString(),
                tile: 'TILE-066',
                description: 'Ritual-aware customer profiles for personalization and automation',
                last_updated: null
              }
            };
            return this._profiles;
          }
          const data = await response.json();
          this._profiles = data;
          return this._profiles;
        }

        // Node context: use fs (if available)
        if (typeof require !== 'undefined') {
          try {
            const fs = require('fs');
            const path = require('path');
            const profilesPath = path.join(__dirname, '../assets/customer-profiles.json');
            
            // Check if file exists
            if (fs.existsSync(profilesPath)) {
              const data = JSON.parse(fs.readFileSync(profilesPath, 'utf8'));
              this._profiles = data;
              return this._profiles;
            } else {
              // Create empty structure
              this._profiles = {
                by_email: {},
                by_customer_id: {},
                by_shopify_id: {},
                metadata: {
                  version: '1.0.0',
                  created: new Date().toISOString(),
                  tile: 'TILE-066',
                  description: 'Ritual-aware customer profiles for personalization and automation',
                  last_updated: null
                }
              };
              // Write empty file
              fs.mkdirSync(path.dirname(profilesPath), { recursive: true });
              fs.writeFileSync(profilesPath, JSON.stringify(this._profiles, null, 2));
              return this._profiles;
            }
          } catch (error) {
            logger.warn('[CustomerProfileEngine] Failed to load profiles from file system', error);
            return null;
          }
        }

        logger.warn('[CustomerProfileEngine] Unable to load profiles: neither fetch nor fs available');
        return null;
      } catch (error) {
        logger.warn('[CustomerProfileEngine] Failed to load profiles', error);
        return null;
      }
    },

    /**
     * Save profiles to JSON file
     * Browser: Not supported (read-only in browser)
     * Node: Uses fs module to write to file
     * @returns {Promise<boolean>} True if saved, false otherwise
     */
    async saveProfiles() {
      if (!this._profiles) {
        logger.warn('[CustomerProfileEngine] No profiles to save');
        return false;
      }

      // Browser context: not supported (read-only)
      if (typeof window !== 'undefined') {
        logger.warn('[CustomerProfileEngine] Profile saving not supported in browser context. Use Node/Jarvis for writes.');
        return false;
      }

      // Node context: use fs
      if (typeof require !== 'undefined') {
        try {
          const fs = require('fs');
          const path = require('path');
          const profilesPath = path.join(__dirname, '../data/customer-profiles/profiles.json');

          // Update metadata
          this._profiles.metadata.last_updated = new Date().toISOString();

          // Write to file
          fs.mkdirSync(path.dirname(profilesPath), { recursive: true });
          fs.writeFileSync(profilesPath, JSON.stringify(this._profiles, null, 2));
          return true;
        } catch (error) {
          logger.warn('[CustomerProfileEngine] Failed to save profiles', error);
          return false;
        }
      }

      return false;
    },

    /**
     * Set profiles (for manual initialization or inline import)
     * @param {Object} profiles - Profiles object
     */
    setProfiles(profiles) {
      this._profiles = profiles;
    },

    /**
     * Get profile by identifier (email, customer_id, or shopify_id)
     * @param {string} identifier - Email, customer_id, or shopify_id
     * @returns {Object|null} Profile object or null if not found
     */
    getProfile(identifier) {
      if (!this._profiles) {
        logger.warn('[CustomerProfileEngine] Profiles not loaded. Call loadProfiles() or setProfiles() first.');
        return null;
      }

      // Try email first
      if (this._profiles.by_email[identifier]) {
        return this._profiles.by_email[identifier];
      }

      // Try customer_id
      if (this._profiles.by_customer_id[identifier]) {
        return this._profiles.by_customer_id[identifier];
      }

      // Try shopify_id
      if (this._profiles.by_shopify_id[identifier]) {
        return this._profiles.by_shopify_id[identifier];
      }

      return null;
    },

    /**
     * Create or update profile
     * @param {string} identifier - Email, customer_id, or shopify_id
     * @param {Object} data - Profile data to merge
     * @returns {Object|null} Updated profile or null if failed
     */
    async createOrUpdateProfile(identifier, data) {
      if (!this._profiles) {
        await this.loadProfiles();
      }

      if (!this._profiles) {
        logger.warn('[CustomerProfileEngine] Unable to load profiles');
        return null;
      }

      // Determine identifier type
      const isEmail = identifier.includes('@');
      const identifierType = isEmail ? 'email' : (data.customer_id ? 'customer_id' : (data.shopify_id ? 'shopify_id' : 'email'));

      // Get or create profile
      let profile = this.getProfile(identifier);

      if (!profile) {
        // Create new profile
        profile = {
          email: data.email || (isEmail ? identifier : null),
          customer_id: data.customer_id || (identifierType === 'customer_id' ? identifier : null),
          shopify_id: data.shopify_id || (identifierType === 'shopify_id' ? identifier : null),
          ritual_state: {
            hard: null,
            soft: null,
            resolved: 'default',
            confidence: 0
          },
          quiz_results: null,
          orders: [],
          email_sequences: [],
          subscriptions: [],
          touchpoints: [],
          last_touchpoint: null,
          last_updated: new Date().toISOString()
        };

        // Add to indexes
        if (profile.email) this._profiles.by_email[profile.email] = profile;
        if (profile.customer_id) this._profiles.by_customer_id[profile.customer_id] = profile;
        if (profile.shopify_id) this._profiles.by_shopify_id[profile.shopify_id] = profile;
      }

      // Update profile with new data
      if (data.ritual_state) {
        profile.ritual_state = { ...profile.ritual_state, ...data.ritual_state };
        if (data.ritual_state.hard || data.ritual_state.soft) {
          profile.ritual_state.resolved = data.ritual_state.hard || (data.ritual_state.confidence >= 0.65 ? data.ritual_state.soft : 'default');
        }
      }

      if (data.quiz_results) {
        profile.quiz_results = { ...profile.quiz_results, ...data.quiz_results };
      }

      if (data.order) {
        profile.orders.push(data.order);
      }

      if (data.email_sequence) {
        profile.email_sequences.push(data.email_sequence);
      }

      if (data.subscription) {
        profile.subscriptions.push(data.subscription);
      }

      if (data.touchpoint) {
        profile.touchpoints.push(data.touchpoint);
        profile.last_touchpoint = data.touchpoint.touchpoint;
      }

      profile.last_updated = new Date().toISOString();

      // Save profiles (Node context only)
      await this.saveProfiles();

      return profile;
    },

    /**
     * Record touchpoint
     * @param {string} identifier - Email, customer_id, or shopify_id
     * @param {string} touchpoint - Touchpoint type (pdp, cart, checkout, email)
     * @param {string} ritualKey - Ritual key (mc, dr, ss, cr, default)
     * @returns {Object|null} Updated profile or null if failed
     */
    async recordTouchpoint(identifier, touchpoint, ritualKey) {
      const resolvedRitualKey = ritualKey || this.resolveRitualKey();

      return await this.createOrUpdateProfile(identifier, {
        touchpoint: {
          touchpoint: touchpoint,
          ritual_key: resolvedRitualKey,
          timestamp: new Date().toISOString()
        }
      });
    },

    /**
     * Assign email sequence
     * @param {string} identifier - Email, customer_id, or shopify_id
     * @param {string} scenario - Email sequence scenario (post_purchase_order, post_purchase_subscription, quiz_lead_non_buyer)
     * @param {string} ritualKey - Ritual key (mc, dr, ss, cr, default)
     * @returns {Object|null} Updated profile or null if failed
     */
    async assignEmailSequence(identifier, scenario, ritualKey) {
      const resolvedRitualKey = ritualKey || this.resolveRitualKey();

      return await this.createOrUpdateProfile(identifier, {
        email_sequence: {
          scenario: scenario,
          ritual_key: resolvedRitualKey,
          assigned_at: new Date().toISOString()
        }
      });
    },

    /**
     * Export profile data for ESP integration
     * @param {string} identifier - Email, customer_id, or shopify_id
     * @returns {Object|null} ESP-ready profile data structure or null if not found
     */
    exportForESP(identifier) {
      const profile = this.getProfile(identifier);
      if (!profile) return null;

      return {
        email: profile.email,
        customer_id: profile.customer_id,
        shopify_id: profile.shopify_id,
        ritual: profile.ritual_state.resolved,
        ritual_state: profile.ritual_state,
        last_touchpoint: profile.last_touchpoint,
        email_sequences: profile.email_sequences,
        orders: profile.orders.length,
        subscriptions: profile.subscriptions.length,
        last_updated: profile.last_updated,
        metadata: {
          version: '1.0.0',
          exported_at: new Date().toISOString(),
          tile: 'TILE-066'
        }
      };
    }
  };

  // Expose globally (browser context)
  if (typeof window !== 'undefined') {
    window.CustomerProfileEngine = CustomerProfileEngine;
  }

  // Expose for Node (Jarvis context)
  if (typeof module !== 'undefined' && module.exports) {
    module.exports.CustomerProfileEngine = CustomerProfileEngine;
  }

  // Note: Profiles are not loaded automatically to avoid unnecessary network requests
  // Call CustomerProfileEngine.loadProfiles() or CustomerProfileEngine.setProfiles() when needed
  // Browser: Read-only (can read profiles, cannot write)
  // Node/Jarvis: Read/write (can read and write profiles to JSON file)

})();

// ═══════════════════════════════════════════════════════════════════════════
// TILE-067: POST-PURCHASE RITUAL-AWARE ESP SYNC ORCHESTRATOR (Wave 1)
// ═══════════════════════════════════════════════════════════════════════════

(function () {
  'use strict';
  
  /**
   * ESP Sync Engine
   * Orchestrates EmailDataEngine (TILE-064), EmailSequenceEngine (TILE-065), and CustomerProfileEngine (TILE-066)
   * to produce ESP-ready payloads (JSON/CSV) for MailerLite/Klaviyo/Jarvis
   * Pure utility: no DOM work, no network calls, Node-compatible
   * 
   * Dependencies:
   * - EmailDataEngine (TILE-064): Provides email templates
   * - EmailSequenceEngine (TILE-065): Provides email sequences with template data
   * - CustomerProfileEngine (TILE-066): Provides customer profiles with ritual state
   * 
   * Usage:
   * - Browser: Read-only usage (window.ESPSyncEngine)
   * - Node/Jarvis: Full orchestration (module.exports.ESPSyncEngine)
   */
  const ESPSyncEngine = {
    /**
     * Resolve ritual key for a given profile
     * Priority: profile.ritual_state.hard > profile.ritual_state.resolved > default
     * @param {Object} profile - Customer profile object
     * @returns {string} Ritual key ('mc', 'dr', 'ss', 'cr', or 'default')
     */
    resolveRitualKeyForProfile(profile) {
      if (!profile || !profile.ritual_state) return 'default';

      // Prefer hard state if available
      if (profile.ritual_state.hard) {
        return profile.ritual_state.hard;
      }

      // Use resolved state if available
      if (profile.ritual_state.resolved && profile.ritual_state.resolved !== 'default') {
        return profile.ritual_state.resolved;
      }

      // Check soft state if confidence >= 0.65
      if (profile.ritual_state.soft && profile.ritual_state.confidence >= 0.65) {
        return profile.ritual_state.soft;
      }

      return 'default';
    },

    /**
     * Get post-purchase order sequence for a profile
     * @param {Object} profile - Customer profile object
     * @returns {Object|null} Resolved sequence object or null if not found
     */
    async getPostPurchaseOrderSequenceForProfile(profile) {
      const ritualKey = this.resolveRitualKeyForProfile(profile);
      
      // Get EmailSequenceEngine (works in browser or Node)
      const SequenceEngine = (typeof window !== 'undefined' && window.EmailSequenceEngine) ||
                             (typeof module !== 'undefined' && module.exports && module.exports.EmailSequenceEngine);
      
      if (!SequenceEngine) {
        logger.warn('[ESPSyncEngine] EmailSequenceEngine not available');
        return null;
      }

      // Load sequences if not already loaded
      if (!SequenceEngine._sequences) {
        await SequenceEngine.loadSequences();
      }

      return SequenceEngine.getResolvedSequence(ritualKey, 'post_purchase_order');
    },

    /**
     * Get post-purchase subscription sequence for a profile
     * @param {Object} profile - Customer profile object
     * @returns {Object|null} Resolved sequence object or null if not found
     */
    async getPostPurchaseSubscriptionSequenceForProfile(profile) {
      const ritualKey = this.resolveRitualKeyForProfile(profile);
      
      const SequenceEngine = (typeof window !== 'undefined' && window.EmailSequenceEngine) ||
                             (typeof module !== 'undefined' && module.exports && module.exports.EmailSequenceEngine);
      
      if (!SequenceEngine) {
        logger.warn('[ESPSyncEngine] EmailSequenceEngine not available');
        return null;
      }

      if (!SequenceEngine._sequences) {
        await SequenceEngine.loadSequences();
      }

      return SequenceEngine.getResolvedSequence(ritualKey, 'post_purchase_subscription');
    },

    /**
     * Get quiz lead sequence for a profile
     * @param {Object} profile - Customer profile object
     * @returns {Object|null} Resolved sequence object or null if not found
     */
    async getQuizLeadSequenceForProfile(profile) {
      const ritualKey = this.resolveRitualKeyForProfile(profile);
      
      const SequenceEngine = (typeof window !== 'undefined' && window.EmailSequenceEngine) ||
                             (typeof module !== 'undefined' && module.exports && module.exports.EmailSequenceEngine);
      
      if (!SequenceEngine) {
        logger.warn('[ESPSyncEngine] EmailSequenceEngine not available');
        return null;
      }

      if (!SequenceEngine._sequences) {
        await SequenceEngine.loadSequences();
      }

      return SequenceEngine.getResolvedSequence(ritualKey, 'quiz_lead_non_buyer');
    },

    /**
     * Build ESP export for a single profile
     * @param {string} profileIdentifier - Email, customer_id, or shopify_id
     * @param {string} scenario - Scenario ('post_purchase_order', 'post_purchase_subscription', 'quiz_lead_non_buyer')
     * @returns {Object|null} ESP-ready export object or null if not found
     */
    async buildESPExportForProfile(profileIdentifier, scenario) {
      // Get CustomerProfileEngine
      const ProfileEngine = (typeof window !== 'undefined' && window.CustomerProfileEngine) ||
                            (typeof module !== 'undefined' && module.exports && module.exports.CustomerProfileEngine);
      
      if (!ProfileEngine) {
        logger.warn('[ESPSyncEngine] CustomerProfileEngine not available');
        return null;
      }

      // Load profiles if not already loaded
      if (!ProfileEngine._profiles) {
        await ProfileEngine.loadProfiles();
      }

      // Get profile
      const profile = ProfileEngine.getProfile(profileIdentifier);
      if (!profile) {
        logger.warn(`[ESPSyncEngine] Profile not found for identifier: ${profileIdentifier}`);
        return null;
      }

      // Resolve ritual key
      const ritualKey = this.resolveRitualKeyForProfile(profile);

      // Get SequenceEngine
      const SequenceEngine = (typeof window !== 'undefined' && window.EmailSequenceEngine) ||
                             (typeof module !== 'undefined' && module.exports && module.exports.EmailSequenceEngine);
      
      if (!SequenceEngine) {
        logger.warn('[ESPSyncEngine] EmailSequenceEngine not available');
        return null;
      }

      // Load sequences if not already loaded
      if (!SequenceEngine._sequences) {
        await SequenceEngine.loadSequences();
      }

      // Get resolved sequence
      const sequence = SequenceEngine.getResolvedSequence(ritualKey, scenario);
      if (!sequence) {
        logger.warn(`[ESPSyncEngine] Sequence not found for ritual: ${ritualKey}, scenario: ${scenario}`);
        return null;
      }

      // Build ESP export
      return {
        profile: {
          email: profile.email,
          customer_id: profile.customer_id,
          shopify_id: profile.shopify_id,
          ritual: ritualKey,
          ritual_state: profile.ritual_state,
          last_touchpoint: profile.last_touchpoint,
          last_updated: profile.last_updated
        },
        scenario: scenario,
        sequence: {
          ritualKey: ritualKey,
          scenario: scenario,
          steps: sequence.map(seq => ({
            step_id: seq.id,
            day_offset: seq.day_offset,
            trigger: seq.trigger,
            channel: seq.channel,
            tags: seq.tags,
            esp_template_id: seq.esp_template_id || null,
            subject: seq.subject || null,
            preheader: seq.preheader || null,
            body: seq.body || null,
            cta_text: seq.cta_text || null,
            footer_note: seq.footer_note || null
          }))
        },
        metadata: {
          version: '1.0.0',
          exported_at: new Date().toISOString(),
          tile: 'TILE-067'
        }
      };
    },

    /**
     * Build ESP export for all profiles
     * @param {string} scenario - Scenario ('post_purchase_order', 'post_purchase_subscription', 'quiz_lead_non_buyer')
     * @returns {Array} Array of ESP-ready export objects
     */
    async buildESPExportForAllProfiles(scenario) {
      // Get CustomerProfileEngine
      const ProfileEngine = (typeof window !== 'undefined' && window.CustomerProfileEngine) ||
                            (typeof module !== 'undefined' && module.exports && module.exports.CustomerProfileEngine);
      
      if (!ProfileEngine) {
        logger.warn('[ESPSyncEngine] CustomerProfileEngine not available');
        return [];
      }

      // Load profiles if not already loaded
      if (!ProfileEngine._profiles) {
        await ProfileEngine.loadProfiles();
      }

      if (!ProfileEngine._profiles || !ProfileEngine._profiles.by_email) {
        logger.warn('[ESPSyncEngine] No profiles loaded');
        return [];
      }

      // Get all profiles from by_email index
      const profiles = Object.values(ProfileEngine._profiles.by_email);
      const exports = [];

      // Build export for each profile
      for (const profile of profiles) {
        const identifier = profile.email || profile.customer_id || profile.shopify_id;
        if (!identifier) continue;

        try {
          const exportData = await this.buildESPExportForProfile(identifier, scenario);
          if (exportData) {
            exports.push(exportData);
          }
        } catch (error) {
          logger.warn(`[ESPSyncEngine] Failed to build export for profile: ${identifier}`, error);
        }
      }

      return exports;
    },

    /**
     * Build CSV rows for a scenario
     * @param {string} scenario - Scenario ('post_purchase_order', 'post_purchase_subscription', 'quiz_lead_non_buyer')
     * @param {Object} filters - Optional filters (ritualKey, etc.)
     * @returns {Array} Array of objects suitable for CSV export
     */
    async buildCSVRowsForScenario(scenario, filters = {}) {
      const exports = await this.buildESPExportForAllProfiles(scenario);
      
      const rows = [];
      
      for (const exportData of exports) {
        // Apply filters
        if (filters.ritualKey && exportData.profile.ritual !== filters.ritualKey) {
          continue;
        }

        // Create a row for each step in the sequence
        for (const step of exportData.sequence.steps) {
          rows.push({
            email: exportData.profile.email,
            customer_id: exportData.profile.customer_id || '',
            shopify_id: exportData.profile.shopify_id || '',
            ritual: exportData.profile.ritual,
            scenario: scenario,
            step_id: step.step_id,
            day_offset: step.day_offset,
            trigger: step.trigger,
            channel: step.channel,
            tags: Array.isArray(step.tags) ? step.tags.join(';') : '',
            esp_template_id: step.esp_template_id || '',
            subject: step.subject || '',
            preheader: step.preheader || '',
            body: step.body || '',
            cta_text: step.cta_text || '',
            footer_note: step.footer_note || ''
          });
        }
      }

      return rows;
    },

    /**
     * Convert array of objects to CSV string
     * @param {Array} rows - Array of objects
     * @returns {string} CSV string
     */
    toCSV(rows) {
      if (!rows || rows.length === 0) return '';

      // Get headers from first row
      const headers = Object.keys(rows[0]);
      
      // Escape CSV values
      const escapeCSV = (value) => {
        if (value === null || value === undefined) return '';
        const str = String(value);
        // If contains comma, quote, or newline, wrap in quotes and escape quotes
        if (str.includes(',') || str.includes('"') || str.includes('\n')) {
          return `"${str.replace(/"/g, '""')}"`;
        }
        return str;
      };

      // Build CSV lines
      const lines = [];
      
      // Header row
      lines.push(headers.map(escapeCSV).join(','));

      // Data rows
      for (const row of rows) {
        const values = headers.map(header => escapeCSV(row[header]));
        lines.push(values.join(','));
      }

      return lines.join('\n');
    },

    /**
     * Mark sequences as assigned for a profile
     * @param {string} profileIdentifier - Email, customer_id, or shopify_id
     * @param {string} scenario - Scenario ('post_purchase_order', 'post_purchase_subscription', 'quiz_lead_non_buyer')
     * @param {string} ritualKey - Ritual key (mc, dr, ss, cr, default)
     * @returns {Object|null} Updated profile or null if failed
     */
    async markSequencesAssigned(profileIdentifier, scenario, ritualKey) {
      try {
        const ProfileEngine = (typeof window !== 'undefined' && window.CustomerProfileEngine) ||
                              (typeof module !== 'undefined' && module.exports && module.exports.CustomerProfileEngine);
        
        if (!ProfileEngine) {
          logger.warn('[ESPSyncEngine] CustomerProfileEngine not available');
          return null;
        }

        // Load profiles if not already loaded
        if (!ProfileEngine._profiles) {
          await ProfileEngine.loadProfiles();
        }

        // Assign email sequence via CustomerProfileEngine
        return await ProfileEngine.assignEmailSequence(profileIdentifier, scenario, ritualKey);
      } catch (error) {
        logger.warn(`[ESPSyncEngine] Failed to mark sequences assigned for profile: ${profileIdentifier}`, error);
        return null;
      }
    }
  };

  // Expose globally (browser context)
  if (typeof window !== 'undefined') {
    window.ESPSyncEngine = ESPSyncEngine;
  }

  // Expose for Node (Jarvis context)
  if (typeof module !== 'undefined' && module.exports) {
    module.exports.ESPSyncEngine = ESPSyncEngine;
  }

  // Note: ESPSyncEngine is a pure utility - no DOM work, no network calls, no runtime hooks
  // Use in Node/Jarvis scripts or browser dev tools for ESP export generation
  // Does not automatically run - must be called explicitly

})();

// ═══════════════════════════════════════════════════════════════════════════
// TILE-068: POST-PURCHASE RITUAL-AWARE ANALYTICS & LTV ENGINE (Wave 1)
// ═══════════════════════════════════════════════════════════════════════════

(function () {
  'use strict';
  
  /**
   * Ritual Analytics Engine
   * Aggregates customer, order, and sequence data by ritual (mc, dr, ss, cr, default)
   * Produces reusable, Jarvis-ready JSON & CSV stats for dashboards and 100M ARR optimization
   * Pure utility: no DOM work, no network calls, no runtime hooks
   * 
   * Dependencies:
   * - CustomerProfileEngine (TILE-066): Provides customer profiles with ritual state, orders, subscriptions
   * 
   * Usage:
   * - Browser: Read-only usage (window.RitualAnalyticsEngine)
   * - Node/Jarvis: Full analytics computation (module.exports.RitualAnalyticsEngine)
   * 
   * Analytics Shape:
   * - RitualStats: Per-ritual metrics (customer count, orders, revenue, AOV, subscriptions, etc.)
   * - GlobalRitualAnalytics: Aggregated stats across all rituals + totals
   */

  /**
   * Ritual keys constant
   */
  const RITUAL_KEYS = ['mc', 'dr', 'ss', 'cr', 'default'];

  /**
   * Resolve ritual key for a profile
   * Priority: hard > resolved > soft (confidence >= 0.65) > default
   * @param {Object} profile - Customer profile object
   * @returns {string} Ritual key ('mc', 'dr', 'ss', 'cr', or 'default')
   */
  function resolveRitualKeyForProfile(profile) {
    if (!profile || !profile.ritual_state) return 'default';

    // Prefer hard state if available
    if (profile.ritual_state.hard) {
      return profile.ritual_state.hard;
    }

    // Use resolved state if available and not default
    if (profile.ritual_state.resolved && profile.ritual_state.resolved !== 'default') {
      return profile.ritual_state.resolved;
    }

    // Check soft state if confidence >= 0.65
    if (profile.ritual_state.soft && profile.ritual_state.confidence >= 0.65) {
      return profile.ritual_state.soft;
    }

    return 'default';
  }

  /**
   * Get all profiles from CustomerProfileEngine
   * @returns {Array} Array of all profile objects
   */
  function getAllProfiles() {
    const ProfileEngine = (typeof window !== 'undefined' && window.CustomerProfileEngine) ||
                          (typeof module !== 'undefined' && module.exports && module.exports.CustomerProfileEngine);
    
    if (!ProfileEngine || !ProfileEngine._profiles) {
      return [];
    }

    // Get all profiles from by_email index
    if (ProfileEngine._profiles.by_email) {
      return Object.values(ProfileEngine._profiles.by_email);
    }

    return [];
  }

  /**
   * Initialize empty ritual stats
   * @param {string} ritualKey - Ritual key
   * @returns {Object} Empty RitualStats object
   */
  function initRitualStats(ritualKey) {
    return {
      ritualKey: ritualKey,
      customerCount: 0,
      profilesWithQuiz: 0,
      profilesWithOrders: 0,
      profilesWithSubscriptions: 0,
      ordersCount: 0,
      totalRevenue: 0,
      averageOrderValue: 0,
      subscriptionsCount: 0,
      lastOrderAt: null
    };
  }

  /**
   * Ritual Analytics Engine
   */
  const RitualAnalyticsEngine = {
    /**
     * Cached analytics (in-memory cache)
     */
    _cachedAnalytics: null,

    /**
     * Ritual keys constant
     */
    RITUAL_KEYS: RITUAL_KEYS,

    /**
     * Compute analytics for all profiles
     * @returns {Object} GlobalRitualAnalytics object
     */
    async computeAnalytics() {
      // Get CustomerProfileEngine
      const ProfileEngine = (typeof window !== 'undefined' && window.CustomerProfileEngine) ||
                            (typeof module !== 'undefined' && module.exports && module.exports.CustomerProfileEngine);
      
      if (!ProfileEngine) {
        logger.warn('[RitualAnalyticsEngine] CustomerProfileEngine not available');
        return this._getEmptyAnalytics();
      }

      // Load profiles if not already loaded
      if (!ProfileEngine._profiles) {
        await ProfileEngine.loadProfiles();
      }

      // Get all profiles
      const profiles = getAllProfiles();

      if (profiles.length === 0) {
        logger.warn('[RitualAnalyticsEngine] No profiles found');
        return this._getEmptyAnalytics();
      }

      // Initialize stats per ritual
      const byRitual = {};
      for (const ritualKey of RITUAL_KEYS) {
        byRitual[ritualKey] = initRitualStats(ritualKey);
      }

      // Process each profile
      for (const profile of profiles) {
        // Resolve ritual key for this profile
        const ritualKey = resolveRitualKeyForProfile(profile);
        const stats = byRitual[ritualKey];

        if (!stats) continue;

        // Increment customer count
        stats.customerCount++;

        // Check for quiz results
        if (profile.quiz_results && (profile.quiz_results !== null && Object.keys(profile.quiz_results).length > 0)) {
          stats.profilesWithQuiz++;
        }

        // Check for orders
        if (profile.orders && Array.isArray(profile.orders) && profile.orders.length > 0) {
          stats.profilesWithOrders++;
          stats.ordersCount += profile.orders.length;

          // Aggregate revenue and find last order
          let lastOrderDate = null;
          for (const order of profile.orders) {
            // Try to get order amount (handle missing gracefully)
            if (order.amount !== undefined && order.amount !== null) {
              const amount = typeof order.amount === 'number' ? order.amount : parseFloat(order.amount);
              if (!isNaN(amount)) {
                stats.totalRevenue += amount;
              }
            }

            // Track last order date
            if (order.completed_at) {
              const orderDate = new Date(order.completed_at);
              if (!isNaN(orderDate.getTime())) {
                if (!lastOrderDate || orderDate > lastOrderDate) {
                  lastOrderDate = orderDate;
                }
              }
            }
          }

          // Update last order date (use latest across all profiles for this ritual)
          if (lastOrderDate) {
            if (!stats.lastOrderAt || lastOrderDate > new Date(stats.lastOrderAt)) {
              stats.lastOrderAt = lastOrderDate.toISOString();
            }
          }
        }

        // Check for subscriptions
        if (profile.subscriptions && Array.isArray(profile.subscriptions) && profile.subscriptions.length > 0) {
          stats.profilesWithSubscriptions++;
          stats.subscriptionsCount += profile.subscriptions.length;
        }
      }

      // Calculate derived metrics per ritual
      for (const ritualKey of RITUAL_KEYS) {
        const stats = byRitual[ritualKey];
        stats.averageOrderValue = stats.ordersCount > 0 ? stats.totalRevenue / stats.ordersCount : 0;
      }

      // Calculate totals
      const totals = initRitualStats('TOTAL');
      for (const ritualKey of RITUAL_KEYS) {
        const stats = byRitual[ritualKey];
        totals.customerCount += stats.customerCount;
        totals.profilesWithQuiz += stats.profilesWithQuiz;
        totals.profilesWithOrders += stats.profilesWithOrders;
        totals.profilesWithSubscriptions += stats.profilesWithSubscriptions;
        totals.ordersCount += stats.ordersCount;
        totals.totalRevenue += stats.totalRevenue;
        totals.subscriptionsCount += stats.subscriptionsCount;

        // Track latest order across all rituals
        if (stats.lastOrderAt) {
          const statsDate = new Date(stats.lastOrderAt);
          if (!totals.lastOrderAt || statsDate > new Date(totals.lastOrderAt)) {
            totals.lastOrderAt = stats.lastOrderAt;
          }
        }
      }

      // Calculate global average order value
      totals.averageOrderValue = totals.ordersCount > 0 ? totals.totalRevenue / totals.ordersCount : 0;

      // Build analytics object
      const analytics = {
        byRitual: byRitual,
        totals: totals,
        generatedAt: new Date().toISOString(),
        version: 'TILE-068-v1'
      };

      // Cache result
      this._cachedAnalytics = analytics;

      return analytics;
    },

    /**
     * Get cached analytics (if available)
     * @returns {Object|null} Cached GlobalRitualAnalytics or null
     */
    getAnalyticsCached() {
      return this._cachedAnalytics || null;
    },

    /**
     * Export analytics for Jarvis (plain JSON)
     * @returns {Object} JSON-ready analytics object
     */
    async exportForJarvis() {
      const analytics = await this.computeAnalytics();
      return JSON.parse(JSON.stringify(analytics)); // Deep clone to ensure plain object
    },

    /**
     * Export analytics as CSV string
     * @returns {string} CSV string with one row per ritual + TOTAL row
     */
    async exportCSV() {
      const analytics = await this.computeAnalytics();
      const rows = [];

      // Header row
      const headers = [
        'ritual_key',
        'customer_count',
        'profiles_with_quiz',
        'profiles_with_orders',
        'orders_count',
        'total_revenue',
        'average_order_value',
        'subscriptions_count',
        'last_order_at'
      ];

      // Add row for each ritual
      for (const ritualKey of RITUAL_KEYS) {
        const stats = analytics.byRitual[ritualKey];
        rows.push({
          ritual_key: stats.ritualKey,
          customer_count: stats.customerCount,
          profiles_with_quiz: stats.profilesWithQuiz,
          profiles_with_orders: stats.profilesWithOrders,
          orders_count: stats.ordersCount,
          total_revenue: stats.totalRevenue.toFixed(2),
          average_order_value: stats.averageOrderValue.toFixed(2),
          subscriptions_count: stats.subscriptionsCount,
          last_order_at: stats.lastOrderAt || ''
        });
      }

      // Add TOTAL row
      const totals = analytics.totals;
      rows.push({
        ritual_key: 'TOTAL',
        customer_count: totals.customerCount,
        profiles_with_quiz: totals.profilesWithQuiz,
        profiles_with_orders: totals.profilesWithOrders,
        orders_count: totals.ordersCount,
        total_revenue: totals.totalRevenue.toFixed(2),
        average_order_value: totals.averageOrderValue.toFixed(2),
        subscriptions_count: totals.subscriptionsCount,
        last_order_at: totals.lastOrderAt || ''
      });

      // Convert to CSV string
      const escapeCSV = (value) => {
        if (value === null || value === undefined) return '';
        const str = String(value);
        if (str.includes(',') || str.includes('"') || str.includes('\n')) {
          return `"${str.replace(/"/g, '""')}"`;
        }
        return str;
      };

      const csvLines = [];
      
      // Header row
      csvLines.push(headers.map(escapeCSV).join(','));

      // Data rows
      for (const row of rows) {
        const values = headers.map(header => escapeCSV(row[header]));
        csvLines.push(values.join(','));
      }

      return csvLines.join('\n');
    },

    /**
     * Get empty analytics structure (fallback)
     * @returns {Object} Empty GlobalRitualAnalytics object
     */
    _getEmptyAnalytics() {
      const byRitual = {};
      for (const ritualKey of RITUAL_KEYS) {
        byRitual[ritualKey] = initRitualStats(ritualKey);
      }

      return {
        byRitual: byRitual,
        totals: initRitualStats('TOTAL'),
        generatedAt: new Date().toISOString(),
        version: 'TILE-068-v1'
      };
    }
  };

  // Expose globally (browser context)
  if (typeof window !== 'undefined') {
    window.RitualAnalyticsEngine = RitualAnalyticsEngine;
  }

  // Expose for Node (Jarvis context)
  if (typeof module !== 'undefined' && module.exports) {
    module.exports.RitualAnalyticsEngine = RitualAnalyticsEngine;
  }

  // Note: RitualAnalyticsEngine is a pure utility - no DOM work, no network calls, no runtime hooks
  // Use in Node/Jarvis scripts or browser dev tools for analytics generation
  // Does not automatically run - must be called explicitly

})();


// ═══════════════════════════════════════════════════════════════════════════
// MY RITUAL PAGE - BACK BUTTON FIX
// Prevents users from being redirected to random blog articles
// ═══════════════════════════════════════════════════════════════════════════
(function initMyRitualBackButtonFix() {
  // Only run on My Ritual page
  if (!window.location.pathname.includes('/pages/my-ritual')) return;
  
  // Check if user came from quiz
  const urlParams = new URLSearchParams(window.location.search);
  const fromQuiz = urlParams.get('from_quiz') === 'true';
  
  if (fromQuiz) {
    console.log('[My Ritual Navigation] User came from quiz, installing back button override');
    
    // Override the back button behavior
    window.addEventListener('popstate', function(e) {
      console.log('[My Ritual Navigation] Back button pressed, redirecting to homepage');
      e.preventDefault();
      window.location.replace('/'); // Go to homepage instead of history.back()
    });
    
    // Also clean the URL to remove the from_quiz parameter
    // This prevents the override from triggering on subsequent visits
    if (window.history && window.history.replaceState) {
      const cleanUrl = window.location.pathname + 
                       (urlParams.get('category') ? '?category=' + urlParams.get('category') : '');
      window.history.replaceState({}, '', cleanUrl);
    }
    
    // Add a history entry so there's something to "back" to
    // This ensures popstate fires when user presses back
    if (window.history && window.history.pushState) {
      window.history.pushState({fromQuiz: true}, '', window.location.href);
    }
  }
})();
